
var API   = 'https://erp-ai-backend.vercel.app';
var TOKEN = null, USER = null, ROLE = null, PERMS = {};
var _projects = [], _currentProj = null, _chatTimer = null;

// ── Boot ──────────────────────────────────────────────────────────────────────
(function boot() {
  // ERP Manager
  var pt = localStorage.getItem('ls_proj_token');
  var pu = JSON.parse(localStorage.getItem('ls_proj_user') || 'null');
  if (pt && pu && pu.role === 'manager') {
    TOKEN = pt; USER = pu; ROLE = 'manager';
    return initUI();
  }
  // Consultant
  var ct = localStorage.getItem('ls_consultant_token') || localStorage.getItem('consultant_token');
  var cu = JSON.parse(localStorage.getItem('ls_consultant') || localStorage.getItem('consultant_user') || 'null');
  if (ct && cu) {
    TOKEN = ct; USER = cu; ROLE = 'consultant';
    return initUI();
  }
  location.href = 'https://erponlinehub.com/pages/erp-login';
})();

async function initUI() {
  // Helper: set element property only if element exists
  function _set(id, prop, val) { var el = document.getElementById(id); if (el) el[prop] = val; }
  function _cls(id, cls)       { var el = document.getElementById(id); if (el) el.className = cls; }
  function _clsAdd(id, cls)    { var el = document.getElementById(id); if (el) el.classList.add(cls); }

  // Set nav
  var name = USER.full_name || (ROLE === 'manager' ? 'Manager' : 'Consultant');
  _set('nav-name',   'textContent', name);
  _set('nav-avatar', 'textContent', name.charAt(0).toUpperCase());
  _set('nav-role-label', 'textContent', ROLE === 'manager' ? 'ERP Manager' : 'Consultant');
  _set('ov-name', 'textContent', name.split(' ')[0]);
  if (ROLE === 'manager') {
    _clsAdd('nav-avatar', 'mgr');
    _set('nav-role-pill',    'textContent', 'ERP Manager');
    _cls('nav-role-pill',    'pill pill-mgr');
    _set('nav-portal-label', 'textContent', 'ERP Manager Portal');
    _set('ov-sub',           'textContent', 'Manage your ERP projects and team');
  } else {
    _set('nav-role-pill',    'textContent', 'Consultant');
    _cls('nav-role-pill',    'pill pill-cons');
    _set('nav-portal-label', 'textContent', 'Consultant Portal');
    _set('ov-sub',           'textContent', 'Your assigned projects and tasks');
  }

  // Fetch permissions
  await loadPermissions();
  // Show role-based nav
  applyNavPermissions();
  // Load data
  await loadProjects();
  loadAllTasks();
  // Start notification polling
  startNotifPolling();
  // Init profile card (avatar, QR, profile ID)
  setTimeout(_initProfileCard, 600);
  // Load profile including avatar — updates nav avatar when done
  loadConsProfile();
}

async function loadPermissions(projectId) {
  try {
    var pid = projectId || null;
    var base = ROLE === 'manager'
      ? '/proj/auth/my-permissions'
      : '/ls/consultants/my-permissions';
    var endpoint = pid ? base + '?project_id=' + pid : base;
    var r = await _api('GET', endpoint);
    if (r.ok) PERMS = (await r.json()).permissions || {};
    else PERMS = {};
  } catch(e) { PERMS = {}; }
  // Defaults - these are ON unless admin explicitly disables them
  PERMS.can_manage_meetings    = PERMS.can_manage_meetings    !== false;
  PERMS.can_view_all_docs      = PERMS.can_view_all_docs      !== false;
  PERMS.can_view_own_earnings  = PERMS.can_view_own_earnings  !== false;
  PERMS.can_upload_files       = PERMS.can_upload_files       !== false;
  PERMS.can_send_messages      = PERMS.can_send_messages      !== false;
  PERMS.can_update_task_status = PERMS.can_update_task_status !== false;
  PERMS.can_log_hours          = PERMS.can_log_hours          !== false;
  PERMS.can_generate_task_docs = PERMS.can_generate_task_docs !== false;
  // These default OFF unless admin enables
  if (PERMS.can_create_tasks          === undefined) PERMS.can_create_tasks          = false;
  if (PERMS.can_view_connections      === undefined) PERMS.can_view_connections      = false;
  if (PERMS.can_edit_connections       === undefined) PERMS.can_edit_connections       = false;
  if (PERMS.can_view_estimate         === undefined) PERMS.can_view_estimate         = false;
  if (PERMS.can_generate_project_docs === undefined) PERMS.can_generate_project_docs = false;
  if (PERMS.can_view_project_budget   === undefined) PERMS.can_view_project_budget   = false;
  if (PERMS.can_delete_files          === undefined) PERMS.can_delete_files          = false;
}

function applyNavPermissions() {
  // Show manager-only nav items based on permissions
  if (ROLE === 'manager') {
    // Only reveal manager NAV items, NOT section divs (sections are controlled by goSection).
    // A blanket '.mgr-only' selector also matched #sec-mgr-rates/#sec-mgr-wallet/#sec-mgr-bank
    // and forced them to display:flex, laying the page header and content grid side-by-side.
    document.querySelectorAll('.nav-item.mgr-only, .nav-section.mgr-only').forEach(function(el){ el.style.display = 'flex'; });
    // Hide consultant pool if no permission
    if (!PERMS.can_browse_consultants) document.getElementById('nav-consultants').style.display = 'none';
    // Hide earnings if no permission
    if (!PERMS.can_view_own_earnings) {
      document.getElementById('nav-earnings').style.display = 'none';
      document.getElementById('nav-sec-financial').style.display = 'none';
    }
    // Create task button
    if (PERMS.can_create_tasks) {
      document.getElementById('create-task-btn-wrap').innerHTML =
        '<button class="btn btn-primary btn-sm" onclick="openCreateTask()">+ Create Task</button>';
    }
    // Generate project doc button
    if (PERMS.can_generate_project_docs) {
      document.getElementById('gen-doc-btn-wrap').innerHTML =
        '<button class="btn btn-purple btn-sm" onclick="openGenDoc()">&#10024; Generate AI Doc</button>';
    }
  } else {
    // Consultant - show only NAV items, not section divs (sections controlled by goSection)
    document.querySelectorAll('.nav-item.cons-only, .nav-section.cons-only').forEach(function(el){
      el.style.display = 'flex';
    });
    document.getElementById('tasks-title').textContent = 'My Assigned Tasks';
    if (PERMS.can_generate_task_docs) {
      document.getElementById('gen-doc-btn-wrap').innerHTML =
        '<button class="btn btn-purple btn-sm" onclick="openGenDoc()">&#10024; Generate Task Doc</button>';
    }
  }
}

// ── API helper ────────────────────────────────────────────────────────────────
function _api(method, path, body) {
  // Route /proj/* calls to their correct authenticated endpoints based on role
  var routedPath = path;
  if (typeof ROLE !== 'undefined' && ROLE === 'consultant') {
    // Consultants authenticate via ls_consultant_sessions - route to /ls/consultants/*
    if (path === '/proj/projects' || path.indexOf('/proj/projects?') === 0) {
      routedPath = '/ls/consultants/projects';
    } else if (path.match(/^\/proj\/projects\/([^/]+)$/) || path.match(/^\/proj\/projects\/([^/]+)\?/)) {
      // GET /proj/projects/:id - project detail
      routedPath = path.replace('/proj/projects/', '/ls/consultants/projects/');
    } else if (path.match(/\/proj\/projects\/([^/]+)\/connections/)) {
      // Route connections to LS endpoint which handles consultant auth and all fields
      routedPath = path.replace('/proj/projects/', '/ls/consultants/projects/');
    } else if (path.indexOf('/proj/projects/') === 0) {
      // All other sub-routes: /messages, /tasks, /meetings, /files etc.
      routedPath = path;
    } else if (path.indexOf('/proj/opportunities/') === 0 && path.indexOf('/respond') > 0) {
      routedPath = path.replace('/proj/opportunities/', '/ls/consultants/opportunities/');
    }
  }
  var opts = { method, headers: { 'Authorization': 'Bearer ' + TOKEN } };
  if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
  return fetch(API + routedPath, opts);
}
function _date(d){ return d ? new Date(d).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) : '-'; }
function _time(d){ return d ? new Date(d).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'}) : ''; }
function _badge(v,c){ return '<span class="badge '+(c||'b-'+v)+'">'+((v||'').replace(/_/g,' '))+'</span>'; }

// ── Project lifecycle stage checker ─────────────────────────────────────────
// Returns what a consultant/manager CAN do at each stage
function _projectStage(project, members) {
  if (!project) return { stage: 'none', canMeet: false, canDoc: false, canTask: false, label: '-' };
  var s = project.status || 'active';
  var isAssigned = members && members.some(function(m) {
    return (m.user_id === USER?.id || m.consultant_id === USER?.id) && m.is_active;
  });
  var hasPaidTicket = project._has_paid_ticket;
  var hasConfirmedMeeting = project._has_confirmed_meeting;
  var hasPaidInvoice = ['paid','in_progress','completed'].includes(s);

  return {
    stage:    s,
    assigned: isAssigned,
    canMeet:  isAssigned && hasPaidTicket,
    canDoc:   isAssigned && hasConfirmedMeeting,
    canTask:  isAssigned && hasPaidInvoice,
    label: {
      'active':           '&#128203; Discovery fee pending',
      'has_ticket':       '&#128179; Awaiting payment',
      'assigned':         '&#128197; Schedule discovery meeting',
      'meeting_held':     '&#128196; Generate documentation',
      'doc_submitted':    '&#9203; Awaiting client approval',
      'doc_approved':     '&#128176; Admin sending estimate',
      'estimated':        '&#10003; Client reviewing estimate',
      'estimate_approved':'&#128179; Awaiting payment',
      'paid':             '&#10003; Create project tasks',
      'in_progress':      '&#128296; Tasks in progress',
      'completed':        '&#10003; Project complete',
    }[s] || s
  };
}

function goSection(id, el) {
  // Use style.display — class toggling alone is overridden by Shopify's CDN CSS
  document.querySelectorAll('.section').forEach(function(s){
    s.style.display = 'none';
    s.classList.remove('active');
  });
  document.querySelectorAll('.nav-item').forEach(function(n){ n.classList.remove('active'); });
  var sec = document.getElementById('sec-' + id);
  if (!sec) { console.warn('Section not found: sec-' + id); return; }
  sec.style.display = 'block';
  sec.classList.add('active');
  if (el) el.classList.add('active');
  // Lazy loaders
  if (id === 'projects')     { document.getElementById('proj-detail').style.display='none'; document.getElementById('projects-list').style.display='block'; }
  if (id === 'consultants')  loadConsultants();
  if (id === 'wallet')       loadWallet();
  if (id === 'banking')      loadBanking();
  if (id === 'rates') {
    var grid = document.getElementById('avail-grid');
    if (grid && !grid.children.length) buildAvailGrid();
    if (CONS_DATA && CONS_DATA.availability) populateAvailGrid(CONS_DATA.availability);
  }
  if (id === 'mgr-rates')  { if(ROLE==='manager') loadMgrProfileSections(); }
  if (id === 'mgr-wallet') { if(ROLE==='manager') loadMgrWallet(); }
  if (id === 'mgr-bank')   { if(ROLE==='manager') loadMgrProfileSections(); }
  if (id === 'opportunities') { if (typeof loadOpportunities === 'function') loadOpportunities(); }
  if (id === 'timelogs')      { if (typeof loadMyTimeLogs   === 'function') loadMyTimeLogs(); }
  if (id === 'meetings')      { if (typeof loadAllMeetings  === 'function') loadAllMeetings(); }
  if (id === 'documents')     { loadAllDocuments(); }
  if (id === 'inbox')         { loadInbox(); }
}

async function loadAllDocuments() {
  var el = document.getElementById('docs-list');
  if (!el) return;
  if (!_projects.length) { el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">&#128196;</div><p>No projects assigned yet</p></div></div>'; return; }
  el.innerHTML = '<div style="text-align:center;color:var(--muted);padding:24px">Loading documents...</div>';
  var allDocs = [];
  for (var _pi2 = 0; _pi2 < _projects.length; _pi2++) {
    try {
      var _pr2 = await _api('GET', '/proj/projects/'+_projects[_pi2].id+'/documents');
      if (!_pr2.ok) continue;
      var _dd2 = await _pr2.json();
      (_dd2.documents||[]).forEach(function(d){ allDocs.push(Object.assign({},d,{_ptitle:_projects[_pi2].title,_pid:_projects[_pi2].id})); });
    } catch(_e3) {}
  }
  if (!allDocs.length) {
    el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">&#128196;</div><p>No documents yet.<br><span style="font-size:12px;color:var(--muted)">Open a project -> AI Docs tab to generate documents.</span></p></div></div>';
    return;
  }
  var _byP = {};
  allDocs.forEach(function(d){ if(!_byP[d._pid]) _byP[d._pid]={title:d._ptitle,docs:[]}; _byP[d._pid].docs.push(d); });
  var _hh = '';
  Object.keys(_byP).forEach(function(pid) {
    var pg2=_byP[pid];
    _hh += '<div class="card" style="margin-bottom:16px"><div style="font-weight:700;font-size:14px;margin-bottom:12px;padding-bottom:10px;border-bottom:1px solid var(--border)">&#128193; '+escHtml(pg2.title)+'</div>'
      + pg2.docs.map(function(doc){
          var stClr=['admin_approved','sent_to_client'].includes(doc.status)?'var(--gl)':doc.status==='rejected'?'var(--danger)':'var(--warn)';
          return '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid var(--border);gap:10px">'
            +'<div style="flex:1;min-width:0"><div style="font-weight:600;font-size:13px">'+escHtml(doc.title||doc.type||'Document')+'</div>'
            +'<div style="font-size:11px;color:var(--muted);margin-top:2px">v'+doc.version+' · '+_date(doc.created_at)+' · <span style="color:'+stClr+'">'+doc.status.replace(/_/g,' ')+'</span></div></div>'
            +'<button onclick="viewProjDocument(this.dataset.id)" data-id="'+doc.id+'" class="btn btn-outline btn-sm">&#128065; View</button>'            +(doc.file_url?'<a href="'+doc.file_url+'" download class="btn btn-outline btn-sm" style="margin-left:4px">&#11015;</a>':'')            +'<button onclick="deleteAiDoc(this.dataset.id)" data-id="'+doc.id+'" class="btn btn-danger btn-sm" style="margin-left:4px;padding:4px 8px">&#128465;</button>'
            +(doc.file_url?'<a href="'+doc.file_url+'" download="'+escHtml(doc.title||'document')+'.docx" class="btn btn-outline btn-sm" style="margin-left:4px">&#11015; Download</a>':'')
            +'<button onclick="deleteAiDoc(this.dataset.id)" data-id="'+doc.id+'" class="btn btn-danger btn-sm" style="margin-left:4px;padding:4px 8px;font-size:12px">&#128465;</button>'
            +'</div>';
        }).join('')+'</div>';
  });
  el.innerHTML = _hh;
}
async function loadProjectDocs(pid) {
  var el = document.getElementById('proj-docs-content');
  if (!el) return;
  try {
    var r = await _api('GET', '/proj/projects/' + pid + '/documents');
    if (!r.ok) {
      el.innerHTML = '<div class="empty"><div class="empty-icon">&#128196;</div><p>' + (r.status===404?'Documents not available yet':'Error loading') + '</p></div>';
      return;
    }
    var dd = await r.json();
    var docs = dd.documents || [];
    if (!docs.length) {
      el.innerHTML = '<div class="empty"><div class="empty-icon">&#128196;</div><p>No documents yet.'
        + (PERMS.can_generate_project_docs||PERMS.can_generate_task_docs?' Click &#10024; Generate to create AI documents.':'') + '</p></div>';
      return;
    }
    el.innerHTML = docs.map(function(doc) {
      var stClr = ['admin_approved','sent_to_client'].includes(doc.status)?'var(--gl)':doc.status==='rejected'?'var(--danger)':'var(--warn)';
      var docId = doc.id; var docTitle = (doc.title||doc.type||'Document');
      return '<div style="background:var(--bg3);border:1px solid var(--border);border-radius:8px;padding:12px 14px;margin-bottom:8px">'
        +'<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:10px;flex-wrap:wrap">'
        +'<div style="flex:1;min-width:0">'
        +'<div style="font-weight:600;font-size:13px">'+escHtml(docTitle)+'</div>'
        +'<div style="font-size:11px;color:var(--muted);margin-top:2px">v'+doc.version+' · '+_date(doc.created_at)+' · <span style="color:'+stClr+'">'+doc.status.replace(/_/g,' ')+'</span></div>'
        +'</div>'
        +'<div style="display:flex;gap:6px;flex-wrap:wrap;flex-shrink:0">'
        +'<button onclick="viewProjDocument(this.dataset.id)" data-id="'+doc.id+'" class="btn btn-outline btn-sm">&#128065; View</button>'
        +(doc.file_url?'<a href="'+doc.file_url+'" download="'+escHtml(docTitle)+'.docx" class="btn btn-outline btn-sm">&#11015; Download</a>':'')
        +'<button onclick="renameAiDoc(this.dataset.id,this.dataset.title)" data-id="'+doc.id+'" data-title="'+escHtml(docTitle)+'" class="btn btn-outline btn-sm" style="font-size:11px">&#9998; Rename</button>'
        +'<button onclick="sendDocToFiles(this.dataset.id,this.dataset.pid)" data-id="'+doc.id+'" data-pid="'+pid+'" class="btn btn-outline btn-sm" style="color:var(--gl);border-color:var(--gl)">&#128193; Save to Files</button>'
        +'<button onclick="deleteAiDoc(this.dataset.id)" data-id="'+doc.id+'" class="btn btn-danger btn-sm" style="padding:4px 8px">&#128465;</button>'
        +'</div></div></div>';
    }).join('');
  } catch(e) {
    el.innerHTML = '<div class="empty"><p>Error: ' + escHtml(e.message) + '</p></div>';
  }
}

async function sendDocToFiles(docId, pid) {
  var modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:9000;display:flex;align-items:center;justify-content:center;padding:16px';
  modal.innerHTML = '<div style="background:var(--bg2);border:1px solid var(--border);border-radius:14px;padding:24px;max-width:380px;width:100%">'
    +'<div style="font-weight:800;font-size:15px;margin-bottom:14px">&#128193; Save to Project Files</div>'
    +'<label style="font-size:12px;font-weight:700;color:var(--muted);text-transform:uppercase;display:block;margin-bottom:6px">Folder</label>'
    +'<select id="stf-sel" class="finput" style="width:100%;margin-bottom:8px">'
    +'<option>AI Documents</option><option>Project Documents</option><option>Reports</option><option>Specifications</option><option>General</option>'
    +'</select>'
    +'<input id="stf-custom" class="finput" placeholder="Or type a new folder name..." style="width:100%;box-sizing:border-box;margin-bottom:14px">'
    +'<div id="stf-msg" style="margin-bottom:10px"></div>'
    +'<div style="display:flex;gap:10px">'
    +'<button class="btn btn-outline btn-sm" onclick="this.closest(\'[data-stf]\').remove()" style="flex:1">Cancel</button>'
    +'<button class="btn btn-primary btn-sm" onclick="doSendDocToFiles(this.dataset.id,this.dataset.pid)" data-id="'+docId+'" data-pid="'+pid+'" style="flex:1">&#128193; Save</button>'
    +'</div></div>';
  modal.dataset.stf = '1';
  document.body.appendChild(modal);
  modal.addEventListener('click', function(e){ if(e.target===modal) modal.remove(); });
}

async function doSendDocToFiles(docId, pid) {
  var custom = (document.getElementById('stf-custom')||{}).value||'';
  var folder = custom.trim() || (document.getElementById('stf-sel')||{}).value || 'AI Documents';
  var msgEl  = document.getElementById('stf-msg');
  var r = await _api('GET', '/proj/documents/'+docId);
  if (!r.ok) { if(msgEl) msgEl.innerHTML='<span style="color:var(--danger);font-size:12px">Failed to load doc</span>'; return; }
  var dd2 = await r.json(); var doc2 = dd2.document||{};
  if (!doc2.file_url) { if(msgEl) msgEl.innerHTML='<span style="color:var(--danger);font-size:12px">No file attached yet</span>'; return; }
  var r2 = await _api('POST', '/proj/projects/'+pid+'/files', {
    filename: (doc2.title||'document').replace(/[^a-zA-Z0-9 ._-]/g,'_')+'.docx',
    file_path: doc2.file_url.split('/proj/files/').pop(),
    file_size: null, file_type:'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    folder: folder
  });
  if (r2.ok) {
    if(msgEl) msgEl.innerHTML='<span style="color:var(--gl);font-size:12px">&#10003; Saved to "'+escHtml(folder)+'"</span>';
    setTimeout(function(){ document.querySelector('[data-stf]')?.remove(); }, 1200);
  } else { if(msgEl) msgEl.innerHTML='<span style="color:var(--danger);font-size:12px">Save failed</span>'; }
}


async function renameAiDoc(docId, currentTitle) {
  var newTitle = prompt('Rename document:', currentTitle || '');
  if (newTitle === null) return;           // cancelled
  newTitle = newTitle.trim();
  if (!newTitle) { window.toast && window.toast('Title cannot be empty', 'error'); return; }
  if (newTitle === currentTitle) return;   // no change

  var r = await _api('PUT', '/proj/documents/' + docId, { title: newTitle });
  if (r.ok) {
    window.toast && window.toast('Document renamed', 'success');
    // Update the title in-place without full reload
    var btn = document.querySelector('[data-id="' + docId + '"][data-title]');
    if (btn) btn.dataset.title = newTitle;
    var titleEl = btn && btn.closest('[style]') && btn.closest('[style]').previousElementSibling;
    // Refresh docs tab
    var pid = _currentProj && _currentProj.project && _currentProj.project.id;
    if (pid) loadProjectDocs(pid);
  } else {
    var d = await r.json().catch(function(){ return {}; });
    window.toast && window.toast(d.error || 'Rename failed', 'error');
  }
}

async function deleteAiDoc(docId) {
  if (!confirm('Delete this document? This cannot be undone.')) return;
  var r = await _api('DELETE', '/proj/documents/' + docId);
  if (r.ok) { window.toast && window.toast('Document deleted', 'success'); loadAllDocuments(); }
  else { var d2=await r.json().catch(function(){return{};}); window.toast && window.toast(d2.error||'Failed', 'error'); }
}

async function viewProjDocument(docId) {
  var _rr = await _api('GET', '/proj/documents/'+docId);
  if (!_rr.ok) { window.toast&&window.toast('Could not load document','error'); return; }
  var _dd3 = await _rr.json();
  var _doc3 = _dd3.document || _dd3;
  if (!_doc3||!_doc3.content_html) { window.toast&&window.toast('Document has no content yet','error'); return; }
  var _ww = window.open('','_blank');
  _ww.document.write('<html><head><title>'+escHtml(_doc3.title||'Document')+'</title><style>body{font-family:system-ui,sans-serif;max-width:900px;margin:40px auto;padding:0 24px;line-height:1.6}</style></head><body>'+_doc3.content_html+'</body></html>');
  _ww.document.close();
}

function signOut() {
  if (ROLE === 'manager') { _api('POST','/proj/auth/logout').catch(function(){}); localStorage.removeItem('ls_proj_token'); localStorage.removeItem('ls_proj_user'); }
  else { _api('POST','/ls/consultants/logout').catch(function(){}); localStorage.removeItem('ls_consultant_token'); localStorage.removeItem('ls_consultant'); localStorage.removeItem('consultant_token'); localStorage.removeItem('consultant_user'); }
  location.href = 'https://erponlinehub.com/pages/erp-login';
}

// ── Projects ──────────────────────────────────────────────────────────────────
async function loadProjects() {
  var r = await _api('GET', '/proj/projects');
  var d = await r.json();
  _projects = d.projects || [];
  document.getElementById('ov-projects').textContent = _projects.length;
  renderProjectList();
  document.getElementById('ov-projects-list').innerHTML = _projects.length
    ? '<div style="font-size:12px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.05em;margin-bottom:10px">Active Projects</div>'
      + _projects.slice(0,3).map(projCard).join('')
    : '<div class="card"><div class="empty"><div class="empty-icon">&#128193;</div><p>No projects assigned yet.<br>Admin will assign you to a project.</p></div></div>';
}

function renderProjectList() {
  var el = document.getElementById('projects-list');
  el.style.display = 'block';
  el.innerHTML = _projects.length
    ? _projects.map(projCard).join('')
    : '<div class="card"><div class="empty"><div class="empty-icon">&#128193;</div><p>No projects assigned yet.</p></div></div>';
}

function projCard(p) {
  return '<div class="proj-card" onclick="openProject(\''+p.id+'\')"><div style="display:flex;justify-content:space-between;align-items:flex-start">'
    + '<div><div class="proj-num">'+(p.project_number||'-')+'</div><div class="proj-title">'+p.title+'</div></div>'
    + _badge(p.status)+'</div>'
    + '<div class="proj-meta"><span>&#9881; '+(p.erp_system||'-')+'</span>'
    + (p.start_date?'<span>&#128640; '+_date(p.start_date)+'</span>':'')
    + '</div></div>';
}

async function openProject(id) {
  document.getElementById('projects-list').style.display = 'none';
  document.getElementById('proj-detail').style.display   = 'block';
  await loadPermissions(id);
  var r = await _api('GET', '/proj/projects/'+id);
  _currentProj = await r.json();
  // Build tab bar
  // Base tabs for all roles
  // Tabs driven by PERMS - same logic for manager and consultant
  var tabs = [['overview','Overview'],['tasks','Tasks'],['meetings','Meetings'],['files','Files']];
  if (PERMS.can_view_all_docs || PERMS.can_generate_project_docs || PERMS.can_generate_task_docs) {
    tabs.push(['documents','&#128196; Docs']);
  }
  if (PERMS.can_view_connections) tabs.push(['connections','&#128268; ERP Access']);
  if (PERMS.can_view_estimate)    tabs.push(['estimate','&#128203; Estimate']);
  if (PERMS.can_send_messages !== false) tabs.push(['chat','&#128172; Chat']);
  document.getElementById('proj-tabs').innerHTML = tabs.map(function(t,i){
    var badge = t[0]==='chat' ? '<span id="ptab-chat-badge" style="display:none;background:var(--gl);color:#fff;border-radius:10px;padding:1px 6px;font-size:9px;font-weight:800;margin-left:4px"></span>' : '';
    return '<button class="tab-btn'+(i===0?' active':'') + '" id="ptab-'+t[0]+'" onclick="projTab(\''+t[0]+'\')">'+t[1]+badge+'</button>';
  }).join('')+'<button class="tab-btn" onclick="refreshCurrentTab()" title="Refresh" style="margin-left:auto;padding:6px 10px;font-size:15px;color:var(--muted)">&#128260;</button>';
  projTab('overview');
}
function closeDetail(){ document.getElementById('proj-detail').style.display='none'; renderProjectList(); if(_chatTimer){clearInterval(_chatTimer);_chatTimer=null;} }

// Re-fetch project data and re-render the current active tab
async function refreshCurrentTab() {
  // Check if we're in global tasks section vs project tab
  var tasksSection = document.getElementById('tasks-list');
  var tasksSec = tasksSection && tasksSection.closest('.section');
  var tasksSectionActive = tasksSec && tasksSec.classList.contains('active');
  
  if (tasksSectionActive) {
    await loadAllTasks();
    return;
  }
  if (!_currentProj || !_currentProj.project) return;
  
  var pid = _currentProj.project.id;
  try {
    var r = await _api('GET', '/proj/projects/' + pid);
    if (r.ok) {
      _currentProj = await r.json();
      var activeBtn = document.querySelector('#proj-tabs .tab-btn.active');
      var tab = activeBtn ? activeBtn.id.replace('ptab-','') : 'tasks';
      projTab(tab);
    }
  } catch(e) { console.error('[refreshCurrentTab]', e.message); }
}

function projTab(tab) {
  document.querySelectorAll('#proj-tabs .tab-btn').forEach(function(b){ b.classList.toggle('active', b.id==='ptab-'+tab); });
  var d = _currentProj || {}, p = d.project||{}, tasks=d.tasks||[], meetings=d.meetings||[], members=d.members||[], files=d.files||[];
  var html = '';
  if(_chatTimer){ clearInterval(_chatTimer); _chatTimer=null; }

  if (tab==='overview') {
    var mgr  = members.find(function(m){ return m.role==='manager'; });
    var cons = members.filter(function(m){ return m.role==='consultant'; });
    // Compute stage
    var stageInfo = _projectStage(p, _currentProj?.members || members);
    var stageColors = {
      canAct: 'rgba(15,181,116,.12);border-color:rgba(15,181,116,.3);color:var(--gl)',
      wait:   'rgba(245,158,11,.08);border-color:rgba(245,158,11,.25);color:var(--warn)',
      locked: 'rgba(74,85,104,.15);border-color:var(--border);color:var(--muted)'
    };
    var stageColor = stageInfo.canMeet||stageInfo.canDoc||stageInfo.canTask ? stageColors.canAct
                   : (!stageInfo.assigned ? stageColors.locked : stageColors.wait);
    var stageBanner = '<div style="background:'+stageColor+';border:1px solid;border-radius:10px;padding:14px 18px;margin-bottom:16px;display:flex;align-items:center;gap:12px">'
      +'<div style="flex:1">'
      +'<div style="font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;margin-bottom:2px;opacity:.7">Project Stage</div>'
      +'<div style="font-size:14px;font-weight:700">'+stageInfo.label+'</div>'
      +'</div>'
      +'<div style="display:flex;gap:8px;font-size:11px">'
      +(stageInfo.canMeet ? '<span style="background:rgba(15,181,116,.15);border:1px solid rgba(15,181,116,.3);border-radius:4px;padding:2px 8px;color:var(--gl)">&#128197; Can Schedule Meeting</span>' : '')
      +(stageInfo.canDoc  ? '<span style="background:rgba(15,181,116,.15);border:1px solid rgba(15,181,116,.3);border-radius:4px;padding:2px 8px;color:var(--gl)">&#128196; Can Generate Docs</span>' : '')
      +(stageInfo.canTask ? '<span style="background:rgba(15,181,116,.15);border:1px solid rgba(15,181,116,.3);border-radius:4px;padding:2px 8px;color:var(--gl)">&#10003; Can Create Tasks</span>' : '')
      +(!stageInfo.assigned ? '<span style="background:rgba(224,82,82,.1);border:1px solid rgba(224,82,82,.25);border-radius:4px;padding:2px 8px;color:var(--danger)">&#9940; Not assigned to this project</span>' : '')
      +'</div></div>';
    html = stageBanner + '<div class="card"><div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:16px">'
      +'<div><div style="font-size:18px;font-weight:800">'+p.title+'</div>'
      +'<div style="font-size:12px;color:var(--muted);margin-top:2px">'+(p.project_number||'')+(p.erp_system?' · '+p.erp_system:'')+'</div></div>'
      +_badge(p.status)+'</div>'
      +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:16px">'
      +'<div>'
      +drow('ERP System',p.erp_system||'-')+drow('Industry',p.industry||'-')
      +drow('Start Date',_date(p.start_date))+drow('End Date',_date(p.end_date))
      +'</div><div>'
      +(mgr?drow('ERP Manager','<span style="color:var(--purple)">'+mgr.full_name+'</span>'):'')
      +cons.map(function(c,i){ return drow('Consultant '+(i+1),c.full_name); }).join('')
      +'</div></div>'
      +(p.description?'<div style="margin-top:14px;padding-top:14px;border-top:1px solid var(--border);font-size:13px;color:var(--muted)">'+p.description+'</div>':'')
      +'</div>';
  }

  if (tab==='tasks') {
    // Show: all tasks if manager; tasks created-by or assigned-to if consultant
    var myTasks = ROLE==='manager' ? tasks : tasks.filter(function(t){
      return t.assigned_to===USER.id || t.created_by===USER.id || !t.assigned_to;
    });
    html = '<div class="page-hdr" style="margin-bottom:12px"><div style="font-weight:700">Tasks ('+myTasks.length+')</div>'
      +(PERMS.can_create_tasks?'<button class="btn btn-primary btn-sm" onclick="openCreateTaskModal()">+ Create Task</button>':'')
      +'</div>'
      +(myTasks.length ? myTasks.map(taskCard).join('') : '<div class="empty"><div class="empty-icon">&#10003;</div><p>No tasks yet</p></div>');
  }

  if (tab==='meetings') {
    html = '<div class="page-hdr" style="margin-bottom:12px"><div style="font-weight:700">Meetings</div>'
      +(PERMS.can_manage_meetings!==false?'<button class="btn btn-primary btn-sm" onclick="openMeetingModal()">+ Schedule</button>':'')
      +'</div>'
      +(meetings.length ? meetings.map(meetingItem).join('') : '<div class="empty"><div class="empty-icon">&#128197;</div><p>No meetings yet</p></div>');
  }

  if (tab==='files') {
    var _fmtSz=function(b){return !b?'':b<1048576?(b/1024).toFixed(1)+' KB':(b/1048576).toFixed(2)+' MB';};
    var _fMap={'__gen':{name:'General',files:[]}};
    files.forEach(function(f){var k=f.folder||'__gen';if(!_fMap[k])_fMap[k]={name:f.folder||'General',files:[]};_fMap[k].files.push(f);});
    var _fH=Object.keys(_fMap).map(function(k){
      var fo=_fMap[k];if(!fo.files.length)return '';
      return '<div style="margin-bottom:12px"><div style="font-size:11px;font-weight:800;text-transform:uppercase;color:var(--muted);letter-spacing:.06em;margin-bottom:7px">&#128193; '+escHtml(fo.name)+' ('+fo.files.length+')</div>'
        +fo.files.map(function(f){
          var ext=(f.filename||'').split('.').pop().toUpperCase().substring(0,5)||'FILE';
          var canDelete = PERMS.can_delete_files === true;
          return '<div class="meeting-item" style="padding:9px 13px;margin-bottom:6px">'
            +'<div style="display:flex;align-items:center;gap:10px;flex:1;min-width:0">'
            +'<div style="width:30px;height:30px;background:rgba(15,181,116,.1);border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:var(--gl);flex-shrink:0">'+ext+'</div>'
            +'<div style="min-width:0"><div style="font-weight:600;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">'+escHtml(f.filename||'file')+'</div>'
            +'<div style="font-size:11px;color:var(--muted)">'+escHtml(f.uploaded_by_name||'')+(f.file_size?' · '+_fmtSz(f.file_size):'')+(f.created_at?' · '+_date(f.created_at):'')+'</div></div></div>'
            +'<a href="'+f.file_url+'" download="'+escHtml(f.filename||'file')+'" target="_blank" class="btn btn-outline btn-sm">&#11015; Download</a>'
            +(canDelete ? '<button onclick="deleteProjectFile(\''+f.id+'\',\''+escHtml(f.filename||'file')+'\')" class="btn btn-danger btn-sm" style="margin-left:6px;padding:4px 8px" title="Delete file">&#128465;</button>' : '')
            +'</div>';
        }).join('')+'</div>';
    }).join('');
    html='<div class="page-hdr" style="margin-bottom:12px"><div style="font-weight:700">Project Files</div>'
      +(PERMS.can_upload_files!==false
        ?'<div style="display:flex;gap:8px;align-items:center">'
         +'<input id="cons-folder-input" class="finput" placeholder="Folder (optional)" style="width:150px;font-size:12px">'
         +'<label class="btn btn-primary btn-sm" style="cursor:pointer">&#128206; Upload <input type="file" style="display:none" onchange="uploadFile(this)"></label>'
         +'</div>':'')
      +'</div>'
      +(_fH||'<div class="empty"><div class="empty-icon">&#128206;</div><p>No files yet</p></div>');
  }


  if (tab==='connections') {
    if (!PERMS.can_view_connections) {
      html = '<div class="locked-msg">&#128274; You don\'t have permission to view ERP system connections. Contact admin.</div>';
    } else {
      html = '<div id="conn-content"><div class="empty"><div class="empty-icon">&#128268;</div><p>Loading connections...</p></div></div>';
    }
  }

  if (tab==='estimate') {
    if (!PERMS.can_view_estimate) {
      html = '<div class="locked-msg">&#128274; You don\'t have permission to view the project estimate.</div>';
    } else {
      html = '<div id="estimate-content"><div class="empty"><div class="empty-icon">&#128203;</div><p>Loading estimate...</p></div></div>';
    }
  }

  if (tab==='documents') {
    html = '<div class="page-hdr" style="margin-bottom:12px"><div style="font-weight:700">Project Documents</div>'
      +(PERMS.can_generate_project_docs||PERMS.can_generate_task_docs?'<button class="btn btn-purple btn-sm" onclick="openGenDoc()">&#10024; Generate Doc</button>':'')
      +'</div><div id="proj-docs-content"><div class="empty"><div class="empty-icon">&#128196;</div><p>Loading documents...</p></div></div>';
  }

  if (tab==='chat') {
    html = '<div id="proj-chat-container" style="height:560px;display:flex;overflow:hidden;border-radius:12px"></div>';
  }

  var _tc = document.getElementById('proj-tab-content');
  _tc.innerHTML   = html;
  _tc.style.height   = tab === 'chat' ? '560px' : 'auto';
  _tc.style.overflow = tab === 'chat' ? 'hidden' : 'visible';

  // Async loaders - called AFTER innerHTML so DOM elements exist
  if (tab==='chat') {
    var cb = document.getElementById('ptab-chat-badge');
    if (cb) cb.style.display = 'none';
    fetchChat(p.id); _chatTimer = setInterval(function(){ fetchChat(p.id); }, 8000); }
  if (tab==='connections'  && PERMS.can_view_connections) { loadConnections(p.id); }
  if (tab==='estimate'     && PERMS.can_view_estimate)    { loadEstimate(p.id); }
  if (tab==='documents')   { loadProjectDocs(p.id); }
}

function drow(l,v){ return '<div class="detail-row"><span class="lbl">'+l+'</span><span>'+v+'</span></div>'; }

function taskCard(t) {
  var s   = t.status || 'pending';
  var cs  = t.client_status || '';
  var ps  = t.payment_status || '';
  var paid = ps==='paid' || ps==='no_invoice';
  var closed   = cs==='closed';
  var rejected = cs==='rejected';

  // Action compatibility matrix
  var canStart    = s==='pending'    && paid && !closed;
  var canSubmit   = s==='in_progress' && !closed;
  var canRework   = (s==='rejected'  || rejected) && !closed;
  var canCancel   = ['pending','in_progress'].includes(s) && !closed;
  var canLog      = ['pending','in_progress'].includes(s) && paid && !closed && PERMS.can_log_hours!==false;
  var canEdit     = ['pending','in_progress'].includes(s) && !closed;
  var canInvoice  = s==='pending' && !paid && PERMS.can_create_invoices;

  // Status banner message
  function lockBanner() {
    var msg='', clr='rgba(245,158,11,.1)', bdr='rgba(245,158,11,.3)', txt='var(--warn)';
    if (!ps||ps==='pending')   msg='&#128222; Invoice Required &#8212; Finance team will create an invoice for client payment';
    else if (ps==='invoiced')  msg='&#9203; Awaiting Client Payment &#8212; Invoice sent, awaiting client confirmation';
    else if (ps==='review')    msg='&#128203; Under Review &#8212; Payment is being verified';
    else                       msg='&#128179; Payment Pending &#8212; Awaiting financial approval';
    return '<div style="background:'+clr+';border:1px solid '+bdr+';border-radius:8px;padding:10px 14px;margin-bottom:8px">'
      +'<div style="font-size:12px;font-weight:700;color:'+txt+';margin-bottom:2px">Task Locked</div>'
      +'<div style="font-size:11px;color:var(--muted)">'+msg+'</div>'
      +(canInvoice?'<button class="btn btn-outline btn-sm" onclick="openTaskInvoiceModal(\''+t.id+'\',\''+escHtml(t.title)+'\','+(t.estimated_hours||0)+')" style="color:var(--gl);border-color:var(--gl);margin-top:8px;font-size:11px">Create Invoice</button>':'')
      +'</div>';
  }

  return '<div class="task-card" id="tc-'+t.id+'" data-status="'+s+'" style="'+(s==='cancelled'?'opacity:0.6;':'')+'">'
    // Header: title + edit icon + status badge
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:6px">'
    +'<div class="task-title" style="display:flex;align-items:center;gap:6px">'
    +escHtml(t.title||'Untitled')
    +(canEdit?'<button onclick="editTaskNote(\''+t.id+'\')" style="background:none;border:none;cursor:pointer;color:var(--muted);padding:2px 4px;font-size:12px;border-radius:4px" title="Add note">&#9998;</button>':'')
    +'</div>'
    +'<div style="display:flex;align-items:center;gap:6px">'
    +_badge(s)
    +(closed?'<span class="badge b-completed">client closed</span>':'')
    +'</div></div>'

    // Meta row
    +'<div class="task-meta">'+_badge(t.priority,'b-'+t.priority)
    +(t.estimated_hours?'<span style="font-size:11px;color:var(--muted)">&#9201; '+t.estimated_hours+'h est</span>':'')
    +(t.actual_hours?'<span style="font-size:11px;color:var(--gl)">&#9201; '+t.actual_hours+'h actual</span>':'')
    +(t.start_date?'<span style="font-size:11px;color:var(--muted)">&#128640; Start: '+new Date(t.start_date+'T00:00:00').toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})+'</span>':'')
    +(t.end_date?'<span style="font-size:11px;color:var(--muted)">&#127937; End: '+new Date(t.end_date+'T00:00:00').toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})+'</span>':'')
    +(t.due_date?'<span style="font-size:11px;font-weight:700;color:'+(new Date(t.due_date)<new Date()&&s!=='completed'&&s!=='cancelled'?'var(--danger)':'#f59e0b')+'" >&#128197; Due: '+new Date(t.due_date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})+'</span>':'')
    +'</div>'

    // Client rejection note
    +(rejected?'<div class="task-client-note">&#9888; Client rejected: '+(t.client_notes||'No reason provided')+'</div>':'')
    +(!rejected&&t.client_notes?'<div class="task-consultant-note" style="font-size:12px;background:rgba(245,158,11,.06);border-left:3px solid rgba(245,158,11,.3);padding:8px 10px;border-radius:0 6px 6px 0;margin-bottom:8px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;color:var(--warn);margin-bottom:3px">Your Note</div>'+escHtml(t.client_notes)+'</div>':'')

    // Requirements
    +(t.requirements?'<div style="font-size:12px;background:rgba(10,76,204,.06);border-left:3px solid rgba(10,76,204,.3);padding:8px 10px;border-radius:0 6px 6px 0;margin-bottom:8px">'
      +'<div style="font-size:10px;font-weight:700;text-transform:uppercase;color:#60a5fa;margin-bottom:3px">Requirements</div>'
      +escHtml(t.requirements)+'</div>':'')

    // Agreement
    +(t.agreement_accepted?'<div style="font-size:10px;color:var(--gl);margin-bottom:5px">&#10003; Agreement accepted</div>':'')

    // ── Status-based action zone ──────────────────────────────────────────────
    // CANCELLED
    +(s==='cancelled'?'<div style="font-size:12px;font-weight:600;color:var(--danger);background:rgba(224,82,82,.06);border:1px solid rgba(224,82,82,.2);border-radius:8px;padding:10px 14px">&#10060; This task was cancelled'+(t.admin_notes&&t.admin_notes.includes('[Cancelled')?' &#8212; <span style="font-weight:400;color:var(--muted)">'+escHtml(t.admin_notes.split('[Cancelled')[1]?.split(']:')[1]?.trim()||'')+'</span>':'')+'</div>':'')

    // CLIENT CLOSED
    +(closed&&s!=='cancelled'?'<div style="font-size:11px;color:var(--gl);background:rgba(15,181,116,.08);border:1px solid rgba(15,181,116,.2);border-radius:8px;padding:8px 12px">&#127881; Task completed and closed by client &#8212; all actions disabled</div>':'')

    // PENDING: lock banner or start button
    +(s==='pending'&&!closed?(!paid?lockBanner():''):'')
    +(canStart?'<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:6px">'
      +'<button class="btn btn-primary btn-sm" data-id="'+t.id+'" onclick="setTaskStatus(this.dataset.id,\'in_progress\')">&#9654; Start Task</button>'
      +(canLog?'<button class="btn btn-outline btn-sm" data-id="'+t.id+'" onclick="logHours(this.dataset.id)" style="font-size:12px">&#9201; Log Hours</button>':'')
      +'<button class="btn btn-outline btn-sm" data-id="'+t.id+'" onclick="editTaskNote(this.dataset.id)" style="font-size:11px">&#9998; Note</button>'
      +(canCancel?'<button class="btn btn-danger btn-sm" data-id="'+t.id+'" onclick="cancelTask(this.dataset.id)" style="font-size:11px">&#10060; Cancel</button>':'')
      +'</div>':'')

    // IN PROGRESS: submit + log + cancel
    +(s==='in_progress'&&!closed?'<div style="display:flex;gap:6px;flex-wrap:wrap">'
      +'<button class="btn btn-primary btn-sm" data-id="'+t.id+'" onclick="setTaskStatus(this.dataset.id,\'submitted\')">&#128228; Submit for Review</button>'
      +(canLog?'<button class="btn btn-outline btn-sm" data-id="'+t.id+'" onclick="logHours(this.dataset.id)" style="font-size:12px">&#9201; Log Hours</button>':'')
      +'<button class="btn btn-outline btn-sm" data-id="'+t.id+'" onclick="editTaskNote(this.dataset.id)" style="font-size:11px">&#9998; Note</button>'
      +'<button class="btn btn-danger btn-sm" data-id="'+t.id+'" onclick="cancelTask(this.dataset.id)" style="font-size:11px">&#10060; Cancel</button>'
      +'</div>':'')

    // SUBMITTED: waiting
    +(s==='submitted'?'<div style="font-size:11px;color:#a78bfa;background:rgba(167,139,250,.08);border:1px solid rgba(167,139,250,.2);border-radius:8px;padding:8px 12px">&#128228; Submitted &#8212; Waiting for client confirmation</div>':'')

    // REJECTED: rework
    +(canRework?'<button class="btn btn-warn btn-sm" data-id="'+t.id+'" onclick="setTaskStatus(this.dataset.id,\'in_progress\')">&#128260; Rework &amp; Resubmit</button>':'')

    // COMPLETED: awaiting sign-off
    +(s==='completed'&&!closed?'<div style="font-size:11px;color:var(--gl);background:rgba(15,181,116,.08);border:1px solid rgba(15,181,116,.2);border-radius:8px;padding:8px 12px">&#10003; Task Completed &#8212; Awaiting client sign-off</div>':'')

    +'</div>';
}


async function setTaskStatus(taskId, status) {
  var r = await _api('PUT', '/proj/tasks/'+taskId+'/status', { status });
  if (r.ok) {
    var labels = { in_progress:'Task started', submitted:'Submitted for review', completed:'Task completed' };
    window.toast && window.toast((labels[status]||'Updated')+' &#10003;', 'success');
    await refreshCurrentTab();
  } else {
    var d = await r.json().catch(function(){return{};});
    window.toast && window.toast(d.error||'Failed', 'error');
  }
}
async function cancelTask(taskId) {
  var reasons = [
    'Unable to complete due to time constraints',
    'Task requirements are unclear or incomplete',
    'Required resources or access not provided',
    'Task outside my area of expertise',
    'Personal/health emergency',
    'Other (please specify)'
  ];
  var idx = 0;
  // Build a simple modal
  var modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);z-index:9999;display:flex;align-items:center;justify-content:center';
  var box = document.createElement('div');
  box.style.cssText = 'background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:24px;width:420px;max-width:95vw';
  box.innerHTML = '<div style="font-size:15px;font-weight:800;margin-bottom:16px;color:#e05252">&#10060; Cancel Task</div>'
    +'<div style="font-size:13px;color:var(--muted);margin-bottom:14px">Please select a reason for cancelling this task. Admin and client will be notified.</div>'
    +'<div id="cancel-reasons" style="display:flex;flex-direction:column;gap:6px;margin-bottom:14px">'
    + reasons.map(function(r,i){ return '<label style="display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;padding:8px 10px;border:1px solid var(--border);border-radius:7px"><input type="radio" name="cancel-reason" value="'+i+'" '+(i===0?'checked':'')+'>'+r+'</label>'; }).join('')
    +'</div>'
    +'<div id="cancel-other" style="display:none;margin-bottom:14px"><textarea id="cancel-other-text" placeholder="Please describe the reason..." style="width:100%;font-family:inherit;font-size:12px;background:var(--bg3);border:1px solid var(--border);border-radius:7px;padding:8px 10px;color:var(--text);resize:vertical;min-height:70px;box-sizing:border-box"></textarea></div>'
    +'<div style="display:flex;gap:8px">'
    +'<button id="confirm-cancel-btn" class="btn btn-danger btn-sm">Cancel Task</button>'
    +'<button id="close-cancel-btn" class="btn btn-outline btn-sm">Keep Task</button>'
    +'</div>';
  modal.appendChild(box);
  document.body.appendChild(modal);

  // Show other textarea
  box.querySelectorAll('input[name="cancel-reason"]').forEach(function(inp) {
    inp.addEventListener('change', function() {
      document.getElementById('cancel-other').style.display = inp.value==='5' ? 'block' : 'none';
    });
  });

  document.getElementById('close-cancel-btn').addEventListener('click', function(){ document.body.removeChild(modal); });
  document.getElementById('confirm-cancel-btn').addEventListener('click', async function() {
    var selected = box.querySelector('input[name="cancel-reason"]:checked');
    var reasonIdx = selected ? parseInt(selected.value) : 0;
    var reason = reasonIdx === 5 ? (document.getElementById('cancel-other-text').value.trim()||'Other') : reasons[reasonIdx];
    if (!reason) { window.toast&&window.toast('Please select a reason','error'); return; }
    document.getElementById('confirm-cancel-btn').disabled = true;
    document.getElementById('confirm-cancel-btn').textContent = 'Cancelling...';
    var r = await _api('POST', '/proj/tasks/'+taskId+'/cancel', { reason });
    var d = await r.json().catch(function(){return{};});
    if (r.ok) {
      document.body.removeChild(modal);
      window.toast && window.toast('Task cancelled. Admin and client have been notified.', 'ok');
      await refreshCurrentTab();
    } else {
      // Show error inside modal instead of removing it
      document.getElementById('confirm-cancel-btn').disabled = false;
      document.getElementById('confirm-cancel-btn').textContent = 'Cancel Task';
      var errDiv = document.getElementById('cancel-error');
      if (!errDiv) { errDiv = document.createElement('div'); errDiv.id = 'cancel-error'; errDiv.style.cssText = 'font-size:12px;color:#e05252;background:rgba(224,82,82,.08);border:1px solid rgba(224,82,82,.2);border-radius:6px;padding:8px 10px;margin-bottom:8px'; box.insertBefore(errDiv, box.lastElementChild); }
      errDiv.textContent = '❌ ' + (d.error || 'HTTP ' + r.status + ' — Failed to cancel task');
    }
  });
}

function editTaskNote(taskId) {
  // Get existing note
  var card = document.getElementById('tc-'+taskId);
  var currentNote = '';
  if (card) {
    var noteEl = card.querySelector('.task-consultant-note');
    if (noteEl) currentNote = noteEl.textContent;
  }

  // Build modal
  var modal = document.createElement('div');
  modal.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);z-index:9999;display:flex;align-items:center;justify-content:center';
  var box = document.createElement('div');
  box.style.cssText = 'background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:24px;width:440px;max-width:95vw';
  box.innerHTML = '<div style="font-size:15px;font-weight:800;margin-bottom:8px">&#9998; Add Note</div>'
    +'<div style="font-size:12px;color:var(--muted);margin-bottom:14px">Your note will be visible to admin and the project team.</div>'
    +'<textarea id="task-note-text" style="width:100%;font-family:inherit;font-size:13px;background:var(--bg3);border:1px solid var(--border);border-radius:8px;padding:10px 12px;color:var(--text);resize:vertical;min-height:100px;box-sizing:border-box;outline:none">'+escHtml(currentNote)+'</textarea>'
    +'<div style="display:flex;gap:8px;margin-top:14px">'
    +'<button id="save-note-btn" class="btn btn-primary btn-sm">Save Note</button>'
    +'<button id="close-note-btn" class="btn btn-outline btn-sm">Cancel</button>'
    +'</div>';
  modal.appendChild(box);
  document.body.appendChild(modal);
  document.getElementById('task-note-text').focus();

  document.getElementById('close-note-btn').addEventListener('click', function(){ document.body.removeChild(modal); });
  document.getElementById('save-note-btn').addEventListener('click', async function() {
    var note = document.getElementById('task-note-text').value.trim();
    document.getElementById('save-note-btn').disabled = true;
    document.getElementById('save-note-btn').textContent = 'Saving...';
    var r = await _api('PUT', '/proj/tasks/'+taskId+'/notes', { consultant_note: note });
    document.body.removeChild(modal);
    if (r.ok) {
      window.toast && window.toast('Note saved &#10003;', 'success');
      await refreshCurrentTab();
    } else {
      window.toast && window.toast('Failed to save note', 'error');
    }
  });
}

function logHours(taskId) {
  var h = prompt('Enter actual hours worked on this task:');
  if (h && !isNaN(h)) _api('PUT', '/proj/tasks/'+taskId+'/hours', { actual_hours: parseFloat(h) }).then(function(){ refreshCurrentTab(); window.toast&&window.toast('Hours logged &#10003;','success'); });
}

function meetingItem(m) {
  var needsConfirm = m.status==='pending_confirmation' && (
    (m.confirmation_required_from==='consultant' && ROLE==='consultant') ||
    (m.confirmation_required_from==='manager'    && ROLE==='manager')
  );
  var tz      = m.timezone || null;
  var dateStr = m.scheduled_date ? _fmtDate(m.scheduled_date) : '-';
  var timeStr = m.scheduled_time ? _fmtTime(m.scheduled_time, _userTz(), tz) : '-';
  var _platLabels = { daily:'⚡ EOH Room', livekit:'⚡ EOH Room', jitsi:'Jitsi', meet:'Google Meet', zoom:'Zoom', zoho:'Zoho Meeting', gmeet:'Google Meet', teams:'Teams' };
  var platform = m.platform ? (_platLabels[m.platform] || m.platform.charAt(0).toUpperCase()+m.platform.slice(1)) : '-';
  var duration=m.duration_minutes?m.duration_minutes+' min':'';
  var createdBy=m.created_by_name?'By '+m.created_by_name:'';

  // 1-hour past/live check
  var meetMs = 0;
  if (m.scheduled_date && m.scheduled_time) {
    var tM = String(m.scheduled_time).match(/^(\d{1,2}:\d{2})/);
    if (tM) { try { meetMs = new Date(m.scheduled_date+'T'+tM[1]+':00').getTime(); } catch(e){} }
  }
  var now2       = Date.now();
  var localToday = new Date().toLocaleDateString('en-CA');
  var isToday3   = m.scheduled_date && (m.scheduled_date === localToday || m.scheduled_date === new Date().toISOString().split('T')[0]);
  var isPastMtg  = meetMs > 0 && now2 > meetMs + 60*60*1000 && !isToday3;
  var isLiveMtg  = isToday3 || (meetMs > 0 && now2 >= meetMs - 15*60*1000 && now2 <= meetMs + 60*60*1000);
  var statusLabel = isPastMtg ? 'past' : m.status==='pending_confirmation' ? 'pending' : m.status;

  // Show join button for today OR within window
  var showJoin = m.meeting_link && ['confirmed','completed'].includes(m.status) && (isLiveMtg || (!isPastMtg));

  return '<div class="meeting-item" style="flex-direction:column;align-items:stretch;opacity:'+(isPastMtg?'0.55':'1')+'">'
    +'<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:10px;flex-wrap:wrap">'
    +'<div style="flex:1;min-width:0"><div style="font-weight:700;font-size:13px;margin-bottom:6px">'+escHtml(m.title||'Meeting')+'</div>'
    +'<div style="display:flex;flex-wrap:wrap;gap:6px;align-items:center">'
    +'<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(15,181,116,.1);border:1px solid rgba(15,181,116,.25);color:var(--gl);font-size:12px;font-weight:800;padding:4px 10px;border-radius:8px">&#128197; '+dateStr+'</span>'
    +'<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(10,76,204,.15);border:1px solid rgba(10,76,204,.35);color:#60a5fa;font-size:12px;font-weight:800;padding:4px 10px;border-radius:8px">&#128336; '+timeStr+'</span>'
    +'<span style="display:inline-flex;align-items:center;gap:4px;background:var(--bg3);border:1px solid var(--border);color:var(--muted);font-size:11px;font-weight:600;padding:3px 9px;border-radius:8px">&#128187; '+platform+'</span>'
    +(duration?'<span style="font-size:11px;color:var(--muted);padding:3px 9px;background:var(--bg3);border:1px solid var(--border);border-radius:8px">&#9201; '+duration+'</span>':'')
    +(createdBy?'<span style="font-size:11px;color:var(--muted)">&#128100; '+escHtml(createdBy)+'</span>':'')
    +'</div>'
    +(m.agenda?'<div style="margin-top:8px;padding:8px 10px;background:var(--bg2);border-radius:7px;font-size:11px;color:var(--muted);border-left:3px solid var(--border2)">&#128221; '+escHtml(m.agenda.slice(0,160))+(m.agenda.length>160?'...':'')+'</div>':'')
    +'</div>'
    +'<div style="display:flex;gap:6px;align-items:flex-start;flex-wrap:wrap">'
    +(isPastMtg?'<span style="font-size:10px;padding:2px 8px;border-radius:6px;background:rgba(15,181,116,.08);border:1px solid rgba(15,181,116,.2);color:var(--gl);font-weight:700;letter-spacing:.05em">✅ Completed</span>':'')
    +_badge(statusLabel)
    +(showJoin ? (function() {
      var _p = m.platform || 'jitsi';
      var _n = (window.USER && window.USER.full_name) ? window.USER.full_name : 'Consultant';
      var isExt = (_p === 'meet' || _p === 'zoom');
      if (isExt) return '<a href="'+m.meeting_link+'" target="_blank" class="btn btn-primary btn-sm">&#127909; Join</a>';
      var qp = new URLSearchParams({ platform: _p, link: m.meeting_link, name: _n, company: m._proj_title||'', date: m.scheduled_date||'' });
      return '<a href="/pages/eoh-meeting-room?'+qp.toString()+'" class="btn btn-primary btn-sm" style="animation:pulse 2s infinite">&#9889; Join EOH Room</a>';
    })() : '')
    +(needsConfirm&&!isPastMtg?'<button class="btn btn-sm" style="background:rgba(15,181,116,.12);border:1px solid rgba(15,181,116,.3);color:var(--gl)" onclick="confirmMeeting(this.dataset.id,\'confirm\')" data-id="'+m.id+'">&#10003; Confirm</button><button class="btn btn-danger btn-sm" onclick="confirmMeeting(this.dataset.id,\'decline\')" data-id="'+m.id+'">&#10060; Decline</button>':'')
    +'</div></div>'
    +(m.notes_after?'<div style="margin-top:8px;padding:8px 10px;background:rgba(15,181,116,.05);border-radius:7px;font-size:11px;color:var(--muted)">&#128203; '+escHtml(m.notes_after)+'</div>':'')
    +'</div>';
}

async function confirmMeeting(id, action) {
  var r = await _api('PUT', '/proj/meetings/'+id+'/confirm', { action });
  if (r.ok) {
    window.toast&&window.toast(action==='confirm'?'✅ Meeting confirmed — team notified':'Meeting declined','success');
    // Refresh: if in a project → refresh project meetings tab, else reload global meetings
    if (_currentProj?.project?.id) { await refreshCurrentTab(); }
    else { await loadAllMeetings(); }
  } else window.toast&&window.toast('Failed to update meeting','error');
}

// ── All Tasks (global) ────────────────────────────────────────────────────────
async function loadAllTasks() {
  var all = [];
  for (var p of _projects) {
    var r = await _api('GET', '/proj/projects/'+p.id);
    var d = await r.json();
    var t = (d.tasks||[]).map(function(tk){ return Object.assign({},tk,{_ptitle:p.title}); });
    all = all.concat(ROLE==='manager' ? t : t.filter(function(tk){ return tk.assigned_to===USER.id||tk.created_by===USER.id||!tk.assigned_to; }));
  }
  document.getElementById('ov-tasks').textContent = all.filter(function(t){ return ['pending','in_progress'].includes(t.status); }).length;
  var el = document.getElementById('tasks-list');
  el.innerHTML = all.length
    ? all.map(function(t){ return '<div style="margin-bottom:4px"><div style="font-size:10px;color:var(--gl);font-weight:700;margin-bottom:4px">'+t._ptitle+'</div>'+taskCard(t)+'</div>'; }).join('')
    : '<div class="card"><div class="empty"><div class="empty-icon">&#10003;</div><p>No tasks assigned</p></div></div>';
}

// ── Consultants ───────────────────────────────────────────────────────────────
async function loadConsultants() {
  if (!PERMS.can_browse_consultants) {
    document.getElementById('consultants-list').innerHTML = '<div class="locked-msg">&#128274; You don\'t have permission to browse consultants. Contact admin.</div>';
    return;
  }
  var r = await _api('GET', '/proj/manager/ls-consultants');
  var d = await r.json();
  if (!r.ok) { document.getElementById('consultants-list').innerHTML = '<div class="err-msg">'+d.error+'</div>'; return; }
  var list = d.consultants||[];
  document.getElementById('consultants-list').innerHTML = list.length
    ? list.map(function(c){
        return '<div class="meeting-item"><div><div style="font-weight:600;font-size:14px">'+c.full_name+'</div>'
          +'<div style="font-size:12px;color:var(--muted);margin-top:3px">'+(c.country||'')+(c.years_exp?' · '+c.years_exp+' yrs':'')+' · '+((c.erp_expertise||[]).slice(0,3).join(', '))+'</div>'
          +(c.hourly_rate?'<div style="font-size:12px;color:var(--gl);margin-top:2px">$'+c.hourly_rate+'/hr</div>':'')
          +'</div>'+(PERMS.can_assign_consultants?'<button class="btn btn-outline btn-sm" onclick="assignConsultantToProject(c.id)">Assign</button>':'')+'</div>';
      }).join('')
    : '<div class="empty"><div class="empty-icon">&#128101;</div><p>No approved consultants yet</p></div>';
}

// ── Chat ──────────────────────────────────────────────────────────────────────
// Chat functions (Sprint 7 - uses shared engine)
function fetchChat(pid) { initChat(pid, USER.id, USER.full_name, ROLE, 'proj-chat-container'); }
function sendChat() { chatSend(); }

// ── ERP System Connections ───────────────────────────────────────────────────
var _connCache = {};
function toggleConnPass(btn) {
  var inp = document.getElementById(btn.dataset.fid);
  if (!inp) return;
  var hidden = inp.type === 'password';
  inp.type = hidden ? 'text' : 'password';
  btn.textContent = hidden ? 'Hide' : 'Show';
}
function copyField(fid) {
  var inp = document.getElementById(fid);
  if (!inp) return;
  navigator.clipboard.writeText(inp.value).then(function(){
    window.toast && window.toast('Copied &#10003;', 'success');
  }).catch(function(){
    var t = document.createElement('textarea');
    t.value = inp.value; document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t);
    window.toast && window.toast('Copied &#10003;', 'success');
  });
}

async function loadConnections(pid) {
  var el = document.getElementById('conn-content');
  if (!el) { console.warn('[loadConnections] conn-content not found'); return; }
  try { el.innerHTML = '<div class="empty"><p>Loading&#8230;</p></div>'; } catch(e) { return; }
  try {
    var r = await _api('GET', '/proj/projects/' + pid + '/connections');
    if (!r.ok) {
      var eBody = await r.json().catch(function(){return{};});
      var msg = r.status === 403
        ? 'ERP Access not enabled for your account on this project. Ask admin to grant View ERP/VPN Access in the Permissions tab.'
        : (eBody.error || 'Could not load connections');
      if (el) el.innerHTML = '<div class="empty"><div class="empty-icon">&#128274;</div><p style="font-size:13px;color:var(--muted);max-width:380px;margin:0 auto;text-align:center">' + escHtml(msg) + '</p></div>';
      return;
    }
    var d = await r.json();
    var conns = (d.connections||[]).filter(function(c){ return c.is_active !== false; });

    var confidentialBanner = '<div style="display:flex;align-items:center;gap:12px;background:rgba(245,158,11,.06);border:1px solid rgba(245,158,11,.2);border-radius:10px;padding:12px 16px;margin-bottom:16px">'
      + '<span style="font-size:22px">&#128274;</span>'
      + '<div><div style="font-size:13px;font-weight:700;color:var(--warn)">ERP Credentials &#8212; Confidential</div>'
      + '<div style="font-size:12px;color:var(--muted);margin-top:2px">All credentials are hidden. Click <b>Show</b> to reveal, <b>Copy</b> to copy securely.</div></div></div>';

    var addBtnHtml = PERMS.can_edit_connections
      ? '<div style="display:flex;justify-content:flex-end;margin-bottom:14px"><button class="btn btn-primary btn-sm" id="add-conn-btn">+ Add Connection</button></div>'
      : '';

    el.innerHTML = confidentialBanner + addBtnHtml + '<div id="conn-add-form" style="display:none"></div><div id="conn-list"></div>';

    var addBtn = document.getElementById('add-conn-btn');
    if (addBtn) addBtn.addEventListener('click', function(){ showConnForm(pid); });

    _connCache = {};
    conns.forEach(function(c){ if (c.id) _connCache[c.id] = c; });

    if (!conns.length) {
      document.getElementById('conn-list').innerHTML = '<div class="empty"><div class="empty-icon">&#128268;</div><p>No ERP connections yet.' + (PERMS.can_edit_connections ? ' Click + Add Connection.' : '') + '</p></div>';
      return;
    }

    var listEl = document.getElementById('conn-list');
    conns.forEach(function(c, idx) {
      var card = document.createElement('div');
      card.style.cssText = 'background:var(--bg2);border:1px solid var(--border);border-left:3px solid #60a5fa;border-radius:12px;overflow:hidden;margin-bottom:16px';
      card.dataset.cid = c.id;

      // ── Card header ──
      var hdr = document.createElement('div');
      hdr.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid var(--border);background:var(--bg3)';
      hdr.innerHTML = '<div style="display:flex;align-items:center;gap:10px">'
        + '<span style="font-size:20px">&#128268;</span>'
        + '<div>'
        + '<div style="font-size:15px;font-weight:800">' + escHtml(c.erp_system||'ERP') + '</div>'
        + '<div style="font-size:11px;color:var(--muted);margin-top:1px;text-transform:capitalize">' + escHtml(c.environment||'') + '</div>'
        + '</div></div>'
        + '<div style="display:flex;align-items:center;gap:8px">'
        + '<span style="font-size:10px;font-weight:700;padding:3px 10px;border-radius:20px;background:rgba(15,181,116,.1);color:var(--gl);border:1px solid rgba(15,181,116,.2)">ACTIVE</span>'
        + (PERMS.can_edit_connections
          ? '<button class="btn btn-outline btn-sm" style="font-size:11px" data-cid="' + c.id + '" data-pid="' + pid + '" onclick="var b=this;showConnForm(b.dataset.pid,_connCache[b.dataset.cid])">&#9998; Edit</button>'
          : '')
        + '</div>';
      card.appendChild(hdr);

      // ── Field builder ──
      function mkField(label, val, fid) {
        var hasVal = !!(val && String(val).trim());
        var wrap = document.createElement('div');
        wrap.style.cssText = 'padding:12px 18px;border-bottom:1px solid var(--border)';
        var lbl = document.createElement('div');
        lbl.style.cssText = 'font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:var(--muted);margin-bottom:6px';
        lbl.textContent = label;
        wrap.appendChild(lbl);
        var row = document.createElement('div');
        row.style.cssText = 'display:flex;align-items:center;gap:8px';
        var inp = document.createElement('input');
        inp.type = 'password';
        inp.id = fid;
        inp.readOnly = true;
        inp.value = hasVal ? String(val) : '';
        inp.placeholder = hasVal ? '' : 'Not set';
        inp.style.cssText = 'font-family:monospace;font-size:13px;background:' + (hasVal ? 'var(--bg3)' : 'transparent') + ';border:1px solid ' + (hasVal ? 'var(--border2)' : 'var(--border)') + ';border-radius:7px;padding:8px 12px;color:' + (hasVal ? 'var(--text)' : 'var(--dim)') + ';flex:1;min-width:0;outline:none';
        row.appendChild(inp);
        if (hasVal) {
          var showB = document.createElement('button');
          showB.type = 'button';
          showB.textContent = 'Show';
          showB.dataset.fid = fid;
          showB.style.cssText = 'background:var(--bg3);border:1px solid var(--border2);border-radius:6px;padding:6px 12px;cursor:pointer;font-size:11px;font-weight:600;color:var(--muted);font-family:inherit;white-space:nowrap;flex-shrink:0;transition:.15s';
          showB.addEventListener('mouseover', function(){ this.style.borderColor='var(--gl)'; this.style.color='var(--gl)'; });
          showB.addEventListener('mouseout',  function(){ this.style.borderColor='var(--border2)'; this.style.color='var(--muted)'; });
          showB.addEventListener('click', function() {
            var i = document.getElementById(this.dataset.fid);
            if (!i) return;
            i.type = i.type === 'password' ? 'text' : 'password';
            this.textContent = i.type === 'password' ? 'Show' : 'Hide';
          });
          var copyB = document.createElement('button');
          copyB.type = 'button';
          copyB.textContent = 'Copy';
          copyB.dataset.fid = fid;
          copyB.style.cssText = 'background:var(--bg3);border:1px solid var(--border2);border-radius:6px;padding:6px 12px;cursor:pointer;font-size:11px;font-weight:600;color:var(--muted);font-family:inherit;white-space:nowrap;flex-shrink:0;transition:.15s';
          copyB.addEventListener('mouseover', function(){ this.style.borderColor='#60a5fa'; this.style.color='#60a5fa'; });
          copyB.addEventListener('mouseout',  function(){ this.style.borderColor='var(--border2)'; this.style.color='var(--muted)'; });
          copyB.addEventListener('click', function() {
            var i = document.getElementById(this.dataset.fid);
            if (!i) return;
            navigator.clipboard.writeText(i.value).then(function(){
              window.toast && window.toast('Copied &#10003;', 'success');
            }).catch(function(){
              var t = document.createElement('textarea'); t.value = i.value;
              document.body.appendChild(t); t.select(); document.execCommand('copy'); document.body.removeChild(t);
              window.toast && window.toast('Copied &#10003;', 'success');
            });
          });
          row.appendChild(showB);
          row.appendChild(copyB);
        }
        wrap.appendChild(row);
        return wrap;
      }

      // ── ERP System Access section ──
      var erpHdr = document.createElement('div');
      erpHdr.style.cssText = 'padding:10px 18px;background:rgba(96,165,250,.04);border-bottom:1px solid var(--border)';
      erpHdr.innerHTML = '<div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#60a5fa">ERP System Access</div>';
      card.appendChild(erpHdr);

      // 2-column grid for ERP fields
      var erpGrid = document.createElement('div');
      erpGrid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr';
      erpGrid.appendChild(mkField('Server URL',       c.server_url,    'ls-srv-' + idx));
      erpGrid.appendChild(mkField('Client / Sys No.', c.client_number, 'ls-cln-' + idx));
      erpGrid.appendChild(mkField('System ID',        c.system_id,     'ls-sid-' + idx));
      erpGrid.appendChild(mkField('Username',         c.username,      'ls-usr-' + idx));
      card.appendChild(erpGrid);
      // Password full width
      card.appendChild(mkField('Password', c.password, 'ls-pw-' + idx));

      // ── VPN Access section ──
      var vpnHdr = document.createElement('div');
      vpnHdr.style.cssText = 'padding:10px 18px;background:rgba(59,130,246,.04);border-bottom:1px solid var(--border);border-top:2px solid rgba(59,130,246,.15)';
      vpnHdr.innerHTML = '<div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#818cf8">VPN Access</div>';
      card.appendChild(vpnHdr);

      var vpnGrid = document.createElement('div');
      vpnGrid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr';
      vpnGrid.appendChild(mkField('VPN Type',     c.vpn_type,     'ls-vt-'  + idx));
      vpnGrid.appendChild(mkField('VPN Server',   c.vpn_server,   'ls-vs-'  + idx));
      vpnGrid.appendChild(mkField('VPN Username', c.vpn_username, 'ls-vu-'  + idx));
      vpnGrid.appendChild(mkField('VPN Password', c.vpn_password, 'ls-vpw-' + idx));
      card.appendChild(vpnGrid);

      // Notes
      if (c.notes) {
        var notes = document.createElement('div');
        notes.style.cssText = 'padding:12px 18px;font-size:12px;color:var(--muted);background:var(--bg3);border-top:1px solid var(--border)';
        notes.innerHTML = '<span style="font-weight:600;color:var(--text)">Notes:</span> ' + escHtml(c.notes);
        card.appendChild(notes);
      }

      listEl.appendChild(card);
    });

  } catch(e) {
    if (el) el.innerHTML = '<div class="empty"><p>Error: ' + escHtml(e.message) + '</p></div>';
    console.error('[loadConnections]', e);
  }
}


function cancelConnForm() {
  var f = document.getElementById('conn-add-form');
  if (f) { f.innerHTML = ''; f.style.display = 'none'; }
  var b = document.getElementById('add-conn-btn');
  if (b) b.style.display = '';
}

async function saveConnForm(pid, editId) {
  var fv = function(id) { var e = document.getElementById(id); return e ? e.value.trim() : ''; };
  var erp = fv('cf-erp');
  if (!erp) { window.showToast && window.showToast('ERP System is required', 'error'); return; }
  var body = {
    erp_system:    erp,
    environment:   fv('cf-env') || 'production',
    server_url:    fv('cf-server') || null,
    username:      fv('cf-user')   || null,
    password:      fv('cf-pass')   || undefined,  // undefined = keep existing
    client_number: fv('cf-client') || null,
    system_id:     fv('cf-sysid')  || null,
    vpn_type:      fv('cf-vpntype')|| null,
    vpn_server:    fv('cf-vpnsrv') || null,
    vpn_username:  fv('cf-vpnusr') || null,
    vpn_password:  fv('cf-vpnpw')  || null,
    notes:         fv('cf-notes')  || null,
  };
  var method = editId ? 'PUT' : 'POST';
  var url    = editId ? '/proj/projects/' + pid + '/connections/' + editId : '/proj/projects/' + pid + '/connections';
  var r = await _api(method, url, body);
  if (r.ok) {
    cancelConnForm();
    loadConnections(pid);
  } else {
    var d = await r.json().catch(function(){ return {}; });
    alert(d.error || 'Failed to save connection');
  }
}

function showConnForm(pid, editData) {
  var formEl = document.getElementById('conn-add-form');
  var addBtn  = document.getElementById('add-conn-btn');
  if (!formEl) return;
  var isEdit = !!(editData && editData.id);
  if (addBtn) addBtn.style.display = 'none';
  var ed = editData || {};

  function mkS(id, lbl, ph, val) {
    var wrap = document.createElement('div'); wrap.className = 'fgrp';
    var label = document.createElement('label'); label.className = 'flbl'; label.textContent = lbl;
    var rel = document.createElement('div'); rel.style.cssText = 'position:relative;display:flex;align-items:center';
    var inp = document.createElement('input'); inp.type = 'password'; inp.id = id; inp.placeholder = ph; inp.value = val||''; inp.autocomplete = 'new-password';
    inp.style.cssText = 'width:100%;background:var(--bg3);border:1px solid var(--border2);border-radius:8px;padding:9px 80px 9px 12px;color:var(--text);font-size:13px;font-family:inherit;outline:none;box-sizing:border-box';
    var btns = document.createElement('div'); btns.style.cssText = 'position:absolute;right:6px;display:flex;gap:4px';
    var showB = document.createElement('button'); showB.type='button'; showB.textContent='Show'; showB.dataset.fid = id;
    showB.style.cssText = 'background:rgba(99,102,241,.12);border:1px solid rgba(99,102,241,.3);border-radius:5px;padding:2px 6px;color:#818cf8;font-size:10px;font-weight:700;cursor:pointer';
    showB.addEventListener('click', function(){ toggleConnPass(this); });
    var copyB = document.createElement('button'); copyB.type='button'; copyB.textContent='Copy'; copyB.dataset.fid = id;
    copyB.style.cssText = 'background:var(--bg3);border:1px solid var(--border);border-radius:5px;padding:2px 6px;color:var(--muted);font-size:10px;cursor:pointer';
    copyB.addEventListener('click', function(){ copyField(this.dataset.fid); });
    btns.appendChild(showB); btns.appendChild(copyB); rel.appendChild(inp); rel.appendChild(btns);
    wrap.appendChild(label); wrap.appendChild(rel);
    return wrap;
  }

  function mkP(id, lbl, ph, val, type) {
    var wrap = document.createElement('div'); wrap.className = 'fgrp';
    var label = document.createElement('label'); label.className = 'flbl'; label.textContent = lbl;
    var inp = type === 'textarea' ? document.createElement('textarea') : document.createElement('input');
    inp.id = id; inp.placeholder = ph;
    inp.style.cssText = 'width:100%;background:var(--bg3);border:1px solid var(--border2);border-radius:8px;padding:9px 12px;color:var(--text);font-size:13px;font-family:inherit;outline:none;box-sizing:border-box';
    if (type === 'textarea') { inp.rows = 3; inp.textContent = val||''; } else { inp.type='text'; inp.value = val||''; }
    wrap.appendChild(label); wrap.appendChild(inp);
    return wrap;
  }

  // Build form via DOM entirely
  formEl.innerHTML = '';
  var card = document.createElement('div');
  card.style.cssText = 'background:var(--bg2);border:1px solid rgba(96,165,250,.25);border-radius:12px;padding:20px;margin-bottom:16px';

  var title = document.createElement('div');
  title.style.cssText = 'font-weight:800;font-size:15px;color:#60a5fa;margin-bottom:16px';
  title.textContent = (isEdit ? 'Edit' : 'Add') + ' ERP / VPN Connection';
  card.appendChild(title);

  function frow(els) { var r=document.createElement('div'); r.className='frow'; r.style.cssText='gap:12px;margin-bottom:12px'; els.forEach(function(e){r.appendChild(e);}); return r; }

  var envSel = document.createElement('select');
  envSel.id = 'cf-env'; envSel.style.cssText = 'width:100%;background:var(--bg3);border:1px solid var(--border2);border-radius:8px;padding:9px 12px;color:var(--text);font-size:13px;font-family:inherit;outline:none';
  [['production','Production'],['development','Development'],['testing','Testing'],['sandbox','Sandbox']].forEach(function(pair){ var o=document.createElement('option'); o.value=pair[0]; o.textContent=pair[1]; if((ed.environment||'').toLowerCase()===pair[0]) o.selected=true; envSel.appendChild(o); });
  var envWrap = document.createElement('div'); envWrap.className='fgrp';
  var envLbl = document.createElement('label'); envLbl.className='flbl'; envLbl.textContent='Environment';
  envWrap.appendChild(envLbl); envWrap.appendChild(envSel);

  card.appendChild(frow([mkP('cf-erp','ERP System *','SAP, Oracle...',ed.erp_system), envWrap]));
  card.appendChild(frow([mkS('cf-server','Server URL','https://erp.company.com',ed.server_url), mkS('cf-user','Username','login username',ed.username)]));
  card.appendChild(frow([mkS('cf-pass','Password',isEdit?'Leave blank to keep existing password':'account password',''), mkS('cf-client','Client / System No.','100',ed.client_number)]));
  card.appendChild(frow([mkS('cf-sysid','System ID','e.g. PRD',ed.system_id), document.createElement('div')]));

  var vpnHdr = document.createElement('div'); vpnHdr.style.cssText='font-size:13px;font-weight:700;color:#60a5fa;margin-bottom:12px;padding-top:14px;border-top:1px solid var(--border)'; vpnHdr.textContent='VPN Details (optional)'; card.appendChild(vpnHdr);
  card.appendChild(frow([mkP('cf-vpntype','VPN Type','OpenVPN, Cisco...',ed.vpn_type), mkS('cf-vpnsrv','VPN Server','vpn.company.com',ed.vpn_server)]));
  card.appendChild(frow([mkS('cf-vpnusr','VPN Username','vpnuser',ed.vpn_username), mkS('cf-vpnpw','VPN Password','vpn password','')]));
  card.appendChild(mkP('cf-notes','Notes','Any access notes...',ed.notes,'textarea'));

  var btnRow = document.createElement('div'); btnRow.style.cssText='display:flex;gap:10px;margin-top:16px';
  var saveBtn=document.createElement('button'); saveBtn.className='btn btn-primary'; saveBtn.textContent='Save Connection';
  saveBtn.addEventListener('click', function(){ saveConnForm(pid, isEdit ? ed.id : null); });
  var cancelBtn=document.createElement('button'); cancelBtn.className='btn btn-outline'; cancelBtn.textContent='Cancel';
  cancelBtn.addEventListener('click', cancelConnForm);
  btnRow.appendChild(saveBtn); btnRow.appendChild(cancelBtn);
  card.appendChild(btnRow);
  formEl.appendChild(card);

  formEl.style.display = 'block';
  formEl.scrollIntoView({behavior:'smooth', block:'start'});
}

async function loadEstimate(pid) {
  var r = await _api('GET', '/proj/projects/'+pid+'/estimates');
  var d = await r.json();
  var el = document.getElementById('estimate-content');
  if (!d.estimates?.length) { el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">&#128203;</div><p>No estimate created yet</p></div></div>'; return; }
  var est = d.estimates[0];
  el.innerHTML = '<div class="card"><div class="detail-row"><span class="lbl">Estimate #</span><span>'+est.estimate_number+'</span></div>'
    +'<div class="detail-row"><span class="lbl">Status</span><span>'+_badge(est.status)+'</span></div>'
    +'<div class="detail-row"><span class="lbl">Total</span><span style="color:var(--gl);font-weight:700">'+est.total+' '+est.currency+'</span></div></div>';
}

// ── Meetings ──────────────────────────────────────────────────────────────────
function _sortMtgs(arr, dk, tk) {
  var now = Date.now();

  function getMs(item) {
    var ds = item[dk]||'';
    var ts = item[tk]||'00:00';
    if (!ds) return -1; // no date → bottom
    var ms = new Date(ds + 'T' + ts.substring(0,5) + ':00').getTime();
    return isNaN(ms) ? -1 : ms;
  }

  var upcoming = [], past = [];
  arr.forEach(function(m) {
    var ms = getMs(m);
    if (ms < 0 || ms <= now) past.push(m);
    else upcoming.push(m);
  });

  // Upcoming: soonest first (ascending)
  upcoming.sort(function(a, b) { return getMs(a) - getMs(b); });
  // Past: most recent first (descending), no-date at very end
  past.sort(function(a, b) {
    var ma = getMs(a), mb = getMs(b);
    if (ma < 0 && mb < 0) return 0;
    if (ma < 0) return 1;
    if (mb < 0) return -1;
    return mb - ma;
  });

  return upcoming.concat(past);
}

async function loadAllMeetings() {
  var el = document.getElementById('meetings-list-inner');
  if (!el) { console.warn('[meetings] meetings-list-inner not found'); return; }
  el.innerHTML = '<div style="padding:24px;text-align:center;color:var(--muted)"><span class="spinner"></span> Loading meetings...</div>';

  var myMeetingsUrl = (ROLE === 'consultant') ? '/ls/consultants/my-meetings' : '/proj/my-meetings';
  var discMeetings = [];
  try {
    var dr = await _api('GET', myMeetingsUrl);
    if (dr.ok) { var dd = await dr.json(); discMeetings = dd.meetings || []; }
  } catch(e) { console.warn('[meetings] disc fetch error', e); }

  var projMeetings = [];
  for (var p of _projects) {
    try {
      var pr = await _api('GET', '/proj/projects/'+p.id);
      var pd = await pr.json();
      projMeetings = projMeetings.concat((pd.meetings||[]).map(function(m){
        return Object.assign({}, m, {_ptitle: p.title, _source: 'project'});
      }));
    } catch(e) {}
  }

  // Badge count
  var now = new Date();
  var upcoming = discMeetings.filter(function(m){ return m.date && new Date(m.date)>=now && m.status!=='cancelled' && m.status!=='declined'; }).length;
  var ovEl = document.getElementById('ov-meetings');
  if (ovEl) ovEl.textContent = upcoming;

  window._allDiscMeetings = discMeetings;
  window._allProjMeetings = projMeetings;

  if (!discMeetings.length && !projMeetings.length) {
    el.innerHTML = '<div class="card"><div class="empty"><div class="empty-icon">&#128197;</div><p>No meetings yet</p></div></div>';
    return;
  }

  el.innerHTML = '';
  applyMeetingFiltersCons();
}

function _buildDiscMeetingCard(m) {
  var card = document.createElement('div');

  // Precise past check: 1h after meeting start time
  var meetingMs = 0;
  if (m.date && m.time) {
    var tRaw = String(m.time).match(/^(\d{1,2}:\d{2})/);
    if (tRaw) { try { meetingMs = new Date(m.date + 'T' + tRaw[1] + ':00').getTime(); } catch(e) {} }
  } else if (m.date) {
    try { meetingMs = new Date(m.date + 'T00:00:00').getTime(); } catch(e) {}
  }
  var localTodayD = new Date().toLocaleDateString('en-CA');
  var isTodayD    = m.meeting_date && (m.meeting_date === localTodayD || m.meeting_date === new Date().toISOString().split('T')[0]);
  var isPast      = meetingMs > 0 && Date.now() > meetingMs + 60*60*1000 && !isTodayD;
  var isLiveNow   = isTodayD || (meetingMs > 0 && Date.now() >= meetingMs - 15*60*1000 && Date.now() <= meetingMs + 60*60*1000);

  var isConfirmed = m.status === 'confirmed' || m.status === 'rescheduled' || m.is_selected;
  var statusColors = { confirmed:'var(--gl)', rescheduled:'var(--gl)', interested:'#60a5fa', pending:'var(--warn)', declined:'var(--danger)', cancelled:'var(--muted)' };
  var statusColor  = isPast ? 'var(--muted)' : (statusColors[m.status] || 'var(--muted)');
  var borderColor  = isLiveNow ? 'var(--gl)' : isPast ? 'var(--border)' : (isConfirmed ? 'rgba(15,181,116,.3)' : 'var(--border)');

  card.style.cssText = 'background:var(--bg2);border:1px solid '+borderColor+';border-left:3px solid '+(isLiveNow?'var(--gl)':isPast?'var(--border)':isConfirmed?'var(--gl)':statusColor)+';border-radius:10px;padding:16px;margin-bottom:10px;opacity:'+(isPast?'0.55':'1');

  var srcTz = m.timezone || m.preferred_timezone || null;
  var dstTz = _userTz();
  var time  = m.time ? _fmtTime(m.time, dstTz, srcTz) : '';
  var date  = m.date ? _fmtDate(m.date) : '';

  var displayStatus = isPast ? 'completed'
    : isLiveNow ? 'live now'
    : (m.status === 'rescheduled') ? 'confirmed'
    : (m.status === 'cancelled')   ? 'cancelled'
    : m.status || '';
  var badgeColor = isPast ? 'var(--gl)' : isLiveNow ? 'var(--gl)' : statusColor;

  card.innerHTML =
    '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:10px">'
      + '<div>'
        + (m.company ? '<div style="font-size:10px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.05em;margin-bottom:2px">📁 ' + escHtml(m.company) + '</div>' : '')
        + '<div style="font-size:11px;color:var(--muted);margin-bottom:4px">DISCOVERY MEETING'+(m.ticket_number?' &nbsp;·&nbsp; <span style="font-family:monospace;color:var(--gl)">'+escHtml(m.ticket_number)+'</span>':'')+'</div>'
        + '<div style="font-size:16px;font-weight:800">'+escHtml(m.company||'-')+' &mdash; '+escHtml(m.erp_system||'')+'</div>'
      + '</div>'
      + '<div style="display:flex;align-items:center;gap:6px">'
        + (isPast ? '<span style="font-size:10px;padding:2px 8px;border-radius:6px;background:rgba(15,181,116,.08);border:1px solid rgba(15,181,116,.2);color:var(--gl);font-weight:700;letter-spacing:.05em">✅ Completed</span>' : '')
        + '<span style="font-size:11px;padding:3px 10px;border-radius:10px;background:'+badgeColor+'22;color:'+badgeColor+';font-weight:700;flex-shrink:0">'+(isLiveNow?'🔴 ':'')+escHtml(displayStatus)+'</span>'
      + '</div>'
    + '</div>'
    + '<div style="display:flex;flex-wrap:wrap;gap:14px;margin-bottom:12px;font-size:13px">'
      + (date ? '<div>&#128197; <b>'+escHtml(date)+'</b></div>' : '')
      + (time ? '<div>&#128336; <b>'+escHtml(time)+'</b></div>' : '')
      + (m.platform ? '<div>&#128421; '+escHtml({'daily':'⚡ EOH Room','livekit':'⚡ EOH Room','jitsi':'Jitsi','meet':'Google Meet','zoom':'Zoom','zoho':'Zoho Meeting'}[m.platform]||m.platform)+'</div>' : '')
      + (m.erp_version ? '<div>v'+escHtml(m.erp_version)+'</div>' : '')
    + '</div>'
    + (isConfirmed
      ? (m.link
          ? _buildJoinBtn(m.link, m.date, m.time, m.timezone, m.meeting_platform || m.platform, m._attendees || [])
          : (isPast ? '' : '<div style="font-size:12px;color:var(--muted);background:var(--bg3);border-radius:8px;padding:10px 14px;margin-bottom:12px">&#9203; Meeting link will be shared before the meeting</div>'))
      : '')
    + (m.rate ? '<div style="font-size:13px;margin-bottom:8px">&#128176; <b>'+escHtml(String(m.rate))+'</b>/hr</div>' : '')
    + (m.modules || m.support_type
      ? '<div style="display:flex;gap:10px;font-size:12px;color:var(--muted)">'
          + (m.support_type ? '<span>'+escHtml(m.support_type)+'</span>' : '')
          + (m.modules ? '<span>'+escHtml(Array.isArray(m.modules)?m.modules.join(', '):(m.modules||''))+'</span>' : '')
        + '</div>'
      : '')
    + (m.notes ? '<div style="font-size:12px;color:var(--muted);margin-top:8px;padding-top:8px;border-top:1px solid var(--border)">&#128221; '+escHtml(m.notes)+'</div>' : '');

  return card;
}

// ═══════════════════════════════════════════════════════════════════════════
// FULL PROFILE - Merged from consultant dashboard
// ═══════════════════════════════════════════════════════════════════════════
var CONS_DATA = null;  // full consultant data from /ls/consultants/me
var TAGS = { lang:[], erp:[], mod:[], skill:[] };
var CV_FILE = null, _idFile = null;
var _wasApproved = false, _pendingEditNotified = false;
var DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'];

// Show consultant-only nav items when role is consultant
(function showConsNav(){
  if (typeof ROLE === 'undefined') {
    setTimeout(showConsNav, 200); return;
  }
  if (ROLE === 'consultant') {
    document.querySelectorAll('.nav-item.cons-only, .nav-section.cons-only').forEach(function(el){
      el.style.display = 'flex';
    });
    document.querySelectorAll('.fgrp.cons-only, div.cons-only').forEach(function(el){
      if (!el.classList.contains('section')) el.style.display = '';
    });
    loadConsProfile();
  }
  if (ROLE === 'manager') {
    // Show ERPM nav items
    document.querySelectorAll('.nav-item.mgr-only, .nav-section.mgr-only').forEach(function(el){
      el.style.display = 'flex';
    });
    // Make mgr-only sections register with showSection
    document.querySelectorAll('.section.mgr-only').forEach(function(el){
      el.style.removeProperty('display');
    });
    // Hide consultant-only nav items
    document.querySelectorAll('.nav-item.cons-only, .nav-section.cons-only').forEach(function(el){
      el.style.display = 'none';
    });
  }
  if (ROLE === 'consultant') {
    // Hide ERPM-only nav items explicitly
    document.querySelectorAll('.nav-item.mgr-only, .nav-section.mgr-only').forEach(function(el){
      el.style.display = 'none';
    });
  }
})();

async function loadConsProfile() {
  try {
    var r = await _api('GET', '/ls/consultants/me');
    if (!r.ok) return;
    var d = await r.json();
    CONS_DATA = d.consultant;
    populateConsUI(CONS_DATA);
    _refreshAvatarDisplay(); // always refresh nav + card avatar after profile loads
  } catch(e) { console.warn('[ConsProfile]', e); }
}

function populateConsUI(c) {
  if (!c) return;
  // Basic profile fields (shared with manager view)
  if (c.full_name)  document.getElementById('p-name').value  = c.full_name;
  if (c.phone)      document.getElementById('p-phone').value = c.phone;
  if (c.country)    document.getElementById('p-country').value = c.country;
  var city = document.getElementById('p-city'); if (city && c.city) city.value = c.city;
  var tz = document.getElementById('p-tz'); if (tz && c.timezone) tz.value = c.timezone;
  // Languages
  if (c.languages) c.languages.forEach(function(l){ addTagVal('lang',l); });
  // Professional
  if (c.current_company) document.getElementById('pr-company').value = c.current_company;
  if (c.job_title)       document.getElementById('pr-title').value   = c.job_title;
  if (c.years_exp!=null) document.getElementById('pr-exp').value     = c.years_exp;
  if (c.linkedin_url)    document.getElementById('pr-linkedin').value= c.linkedin_url;
  // Expertise tags
  if (c.erp_expertise) c.erp_expertise.forEach(function(v){ addTagVal('erp',v); });
  if (c.modules)       c.modules.forEach(function(v){ addTagVal('mod',v); });
  if (c.skills)        c.skills.forEach(function(v){ addTagVal('skill',v); });
  // Rates
  if (c.hourly_rate)     document.getElementById('r-hourly').value  = c.hourly_rate;
  if (c.monthly_rate)    document.getElementById('r-monthly').value = c.monthly_rate;
  if (c.currency)        document.getElementById('r-currency').value= c.currency;
  if (c.preferred_hours) document.getElementById('r-hours').value   = c.preferred_hours;
  // Dynamic lists - clear first to prevent duplicates on re-load
  var eduList  = document.getElementById('edu-list');
  var certList = document.getElementById('cert-list');
  var workList = document.getElementById('work-list');
  if (eduList  && !eduList.children.length  && (c.education||[]).length)      c.education.forEach(addEduItem);
  if (certList && !certList.children.length && (c.certifications||[]).length) c.certifications.forEach(addCertItem);
  if (workList && !workList.children.length && (c.work_experience||[]).length) c.work_experience.forEach(addWorkItem);
  // CV
  if (c.cv_filename) document.getElementById('cv-current').textContent = '&#128206; Current CV: ' + c.cv_filename;
  _wasApproved = (c.status === 'approved');
  var emEl = document.getElementById('p-email-display');
  if (emEl) emEl.value = c.email || USER?.email || '';
  if (c.status === 'pending') {
    // Show persistent banner that profile is awaiting review
    setTimeout(function(){
      if (!document.getElementById('review-pending-banner')) {
        var notice = document.createElement('div');
        notice.id = 'review-pending-banner';
        notice.style.cssText = 'position:fixed;top:70px;right:16px;background:rgba(245,158,11,.1);border:1px solid rgba(245,158,11,.35);border-radius:10px;padding:10px 16px;font-size:12px;color:var(--warn);font-weight:600;z-index:400;display:flex;align-items:center;gap:8px;max-width:320px;box-shadow:0 4px 16px rgba(0,0,0,.2)';
        notice.innerHTML = '&#128260; <span>Profile update pending admin review</span>';
        document.body.appendChild(notice);
      }
    }, 500);
  }
}

// ── Profile save (works for both manager and consultant) ─────────────────────
(function fillProfile(){
  if (!USER) return;
  document.getElementById('p-name').value    = USER.full_name||'';
  document.getElementById('p-phone').value   = USER.phone||'';
  document.getElementById('p-country').value = USER.country||'';
  try { document.getElementById('p-tz').value = USER.timezone||'UTC'; } catch(e){}
  var em = document.getElementById('p-email-display');
  if (em) em.value = USER.email || '';
})();

async function saveProfile() {
  var ep = ROLE==='manager' ? '/proj/auth/me' : '/ls/consultants/me';
  var payload = {
    full_name: document.getElementById('p-name').value,
    phone:     document.getElementById('p-phone').value,
    country:   document.getElementById('p-country').value,
    timezone:  document.getElementById('p-tz').value
  };
  if (ROLE === 'consultant') {
    var cityEl = document.getElementById('p-city');
    if (cityEl) payload.city = cityEl.value;
    payload.languages = TAGS.lang;
  }
  var r = await _api('PUT', ep, payload);
  var d = await r.json();
  if (r.ok) {
    // Update in-memory user/consultant with new timezone
    var newTz = payload.timezone;
    if (d.user)       { USER = d.user; }
    if (d.consultant) { CONS_DATA = Object.assign(CONS_DATA || {}, d.consultant); }
    // Always patch timezone directly since endpoint returns different keys per role
    if (newTz) {
      if (!USER) USER = {};
      USER.timezone = newTz;
      if (!CONS_DATA) CONS_DATA = {};
      CONS_DATA.timezone = newTz;
      // Persist to localStorage
      try { localStorage.setItem('ls_consultant', JSON.stringify(CONS_DATA)); } catch(e) {}
      try { localStorage.setItem('ls_proj_user',  JSON.stringify(USER)); }      catch(e) {}
    }
    // Re-render meetings/opportunities with updated timezone (always, not just when tz changed)
    if (typeof loadOpportunities === 'function') loadOpportunities();
    if (typeof loadAllMeetings   === 'function') loadAllMeetings();
    if (d.pending_review) {
      document.getElementById('profile-msg').innerHTML = '<div style="background:rgba(245,158,11,.1);border:1px solid rgba(245,158,11,.3);border-radius:7px;padding:10px 12px;font-size:12px;color:var(--warn)">&#128260; Profile saved and submitted for admin review. You will be notified once approved.</div>';
    } else {
      document.getElementById('profile-msg').innerHTML = '<div class="ok-msg">&#10003; Profile updated</div>';
    }
  } else {
    document.getElementById('profile-msg').innerHTML = '<div class="err-msg">&#10060; '+(d.error||'Failed')+'</div>';
  }
}

// goSection handles wallet/banking/rates directly

// ── Tag system ────────────────────────────────────────────────────────────────
function addTag(key, e) {
  if (e.key !== 'Enter' && e.key !== ',') return;
  e.preventDefault();
  var inp = document.getElementById(key + '-input');
  var val = inp.value.trim().replace(/,$/, '');
  if (val) addTagVal(key, val);
  inp.value = '';
}
function addTagVal(key, val) {
  if (!val || TAGS[key].includes(val)) return;
  TAGS[key].push(val);
  var wrap = document.getElementById(key + '-wrap');
  if (!wrap) return;
  var tag = document.createElement('span');
  tag.className = 'tag';
  tag.dataset.val = val;
  tag.innerHTML = val + '<button onclick="removeTag(\''+key+'\',\''+val.replace(/'/g,"\\'")+'\',this)" type="button">×</button>';
  wrap.insertBefore(tag, document.getElementById(key + '-input'));
}
function removeTag(key, val, btn) {
  TAGS[key] = TAGS[key].filter(function(v){ return v !== val; });
  var el = btn ? btn.closest('.tag') : null;
  if (el) el.remove();
}

// ── Dynamic list builders ─────────────────────────────────────────────────────
function addEduItem(data) {
  data = data || {};
  var id = 'edu-' + Date.now();
  document.getElementById('edu-list').insertAdjacentHTML('beforeend',
    '<div class="list-item" id="'+id+'">'
    +'<button class="remove-item" onclick="this.parentElement.remove()" type="button">×</button>'
    +'<div class="frow" style="grid-template-columns:1fr 1fr 1fr">'
    +'<div class="fgrp"><label class="flbl">Degree</label><input class="finput edu-degree" placeholder="e.g. B.Sc. Computer Science" value="'+(data.degree||'')+'"></div>'
    +'<div class="fgrp"><label class="flbl">Field</label><input class="finput edu-field" placeholder="e.g. Information Systems" value="'+(data.field||'')+'"></div>'
    +'<div class="fgrp"><label class="flbl">Year</label><input class="finput edu-year" type="number" min="1970" max="2030" placeholder="2015" value="'+(data.year||'')+'"></div>'
    +'</div>'
    +'<div class="frow single"><div class="fgrp"><label class="flbl">Institution</label><input class="finput edu-institution" placeholder="University / Institution" value="'+(data.institution||'')+'"></div></div>'
    +'</div>');
}
function addCertItem(data) {
  data = data || {};
  var id = 'cert-' + Date.now();
  document.getElementById('cert-list').insertAdjacentHTML('beforeend',
    '<div class="list-item" id="'+id+'">'
    +'<button class="remove-item" onclick="this.parentElement.remove()" type="button">×</button>'
    +'<div class="frow" style="grid-template-columns:1fr 1fr 1fr">'
    +'<div class="fgrp"><label class="flbl">Certificate</label><input class="finput cert-name" placeholder="e.g. SAP Certified Associate" value="'+(data.name||'')+'"></div>'
    +'<div class="fgrp"><label class="flbl">Issuer</label><input class="finput cert-issuer" placeholder="e.g. SAP SE" value="'+(data.issuer||'')+'"></div>'
    +'<div class="fgrp"><label class="flbl">Year</label><input class="finput cert-year" type="number" min="1990" max="2030" placeholder="2022" value="'+(data.year||'')+'"></div>'
    +'</div></div>');
}
function addWorkItem(data) {
  data = data || {};
  var id = 'work-' + Date.now();
  document.getElementById('work-list').insertAdjacentHTML('beforeend',
    '<div class="list-item" id="'+id+'">'
    +'<button class="remove-item" onclick="this.parentElement.remove()" type="button">×</button>'
    +'<div class="frow"><div class="fgrp"><label class="flbl">Company</label><input class="finput work-company" placeholder="Company name" value="'+(data.company||'')+'"></div>'
    +'<div class="fgrp"><label class="flbl">Job Title</label><input class="finput work-title" placeholder="e.g. SAP Consultant" value="'+(data.title||'')+'"></div></div>'
    +'<div class="frow"><div class="fgrp"><label class="flbl">From</label><input class="finput work-from" placeholder="e.g. Jan 2018" value="'+(data.from||'')+'"></div>'
    +'<div class="fgrp"><label class="flbl">To</label><input class="finput work-to" placeholder="e.g. Dec 2022 or Present" value="'+(data.to||'')+'"></div></div>'
    +'<div class="frow single"><div class="fgrp"><label class="flbl">Description</label><textarea class="ftextarea work-desc" rows="3" placeholder="Key responsibilities, ERP systems used...">'+(data.description||'')+'</textarea></div></div>'
    +'</div>');
}

// ── Availability grid ─────────────────────────────────────────────────────────
function buildAvailGrid() {
  var grid = document.getElementById('avail-grid'); if (!grid) return;
  grid.innerHTML = DAYS.map(function(day) {
    var key = day.toLowerCase().slice(0,3);
    return '<div class="avail-day" id="avail-'+key+'">'
      +'<div class="avail-day-hdr"><span class="avail-day-name">'+day+'</span>'
      +'<button class="btn btn-sm btn-outline" onclick="addTimeSlot(\''+key+'\')">+ Add slot</button></div>'
      +'<div id="slots-'+key+'" class="slots-wrap"><span style="font-size:12px;color:var(--dim)">No slots - click Add slot</span></div></div>';
  }).join('');
}
function addTimeSlot(day, from, to) {
  var wrap = document.getElementById('slots-'+day); if (!wrap) return;
  var ph = wrap.querySelector('span'); if (ph) ph.remove();
  var id = 'slot-'+day+'-'+Date.now();
  wrap.insertAdjacentHTML('beforeend',
    '<div class="time-slot" id="'+id+'">'
    +'<input class="finput slot-from" type="time" value="'+(from||'09:00')+'" style="width:110px">'
    +'<span style="color:var(--dim);font-size:12px">to</span>'
    +'<input class="finput slot-to" type="time" value="'+(to||'17:00')+'" style="width:110px">'
    +'<button class="remove-slot" onclick="removeSlot(\''+id+'\',\''+day+'\')" type="button">×</button></div>');
}
function removeSlot(id, day) {
  document.getElementById(id).remove();
  var wrap = document.getElementById('slots-'+day);
  if (wrap && !wrap.querySelector('.time-slot')) wrap.innerHTML = '<span style="font-size:12px;color:var(--dim)">No slots - click Add slot</span>';
}
function populateAvailGrid(avail) {
  if (!avail) return;
  if (typeof avail === 'string') { try { avail = JSON.parse(avail); } catch(e){ return; } }
  var grid = document.getElementById('avail-grid');
  if (!grid || !grid.children.length) buildAvailGrid();
  DAYS.forEach(function(day) {
    var key = day.toLowerCase().slice(0,3);
    var wrap = document.getElementById('slots-'+key); if (wrap) wrap.innerHTML = '';
  });
  DAYS.forEach(function(day) {
    var key = day.toLowerCase().slice(0,3);
    (avail[key]||[]).forEach(function(s){ addTimeSlot(key, s.from, s.to); });
  });
}
function getAvailData() {
  var result = {};
  DAYS.forEach(function(day) {
    var key = day.toLowerCase().slice(0,3);
    var wrap = document.getElementById('slots-'+key); if (!wrap) return;
    var slots = Array.from(wrap.querySelectorAll('.time-slot')).map(function(el){
      return { from: el.querySelector('.slot-from').value, to: el.querySelector('.slot-to').value };
    }).filter(function(s){ return s.from && s.to; });
    if (slots.length) result[key] = slots;
  });
  return result;
}

// ── Section save ──────────────────────────────────────────────────────────────
function _buildSectionPayload(section) {
  if (section==='professional')  return { current_company:document.getElementById('pr-company').value.trim(), job_title:document.getElementById('pr-title').value.trim(), years_exp:parseInt(document.getElementById('pr-exp').value)||null, linkedin_url:document.getElementById('pr-linkedin').value.trim() };
  if (section==='expertise')     return { erp_expertise:TAGS.erp, modules:TAGS.mod, skills:TAGS.skill };
  if (section==='education')     return { education:Array.from(document.querySelectorAll('#edu-list .list-item')).map(function(el){ return { degree:el.querySelector('.edu-degree').value.trim(), field:el.querySelector('.edu-field').value.trim(), year:parseInt(el.querySelector('.edu-year').value)||null, institution:el.querySelector('.edu-institution').value.trim() }; }) };
  if (section==='certs')         return { certifications:Array.from(document.querySelectorAll('#cert-list .list-item')).map(function(el){ return { name:el.querySelector('.cert-name').value.trim(), issuer:el.querySelector('.cert-issuer').value.trim(), year:parseInt(el.querySelector('.cert-year').value)||null }; }) };
  if (section==='experience')    return { work_experience:Array.from(document.querySelectorAll('#work-list .list-item')).map(function(el){ return { company:el.querySelector('.work-company').value.trim(), title:el.querySelector('.work-title').value.trim(), from:el.querySelector('.work-from').value.trim(), to:el.querySelector('.work-to').value.trim(), description:el.querySelector('.work-desc').value.trim() }; }) };
  if (section==='rates')         return { hourly_rate:parseFloat(document.getElementById('r-hourly').value)||null, monthly_rate:parseFloat(document.getElementById('r-monthly').value)||null, currency:document.getElementById('r-currency').value, preferred_hours:document.getElementById('r-hours').value.trim() };
  if (section==='availability')  return { availability:getAvailData() };
  return null;
}

async function saveSection(section) {
  var payload = _buildSectionPayload(section);
  var msgId   = section + '-msg';
  if (section==='certs')        msgId = 'certs-msg';
  if (section==='availability') msgId = 'avail-msg';
  var msgEl = document.getElementById(msgId);
  if (!msgEl) return;
  msgEl.innerHTML = '<div class="ok-msg"><span class="spinner"></span> Saving...</div>';
  try {
    payload._changed_section = section;
    var r = await _api('PUT', '/ls/consultants/me', payload);
    var d = await r.json();
    if (!r.ok) throw new Error(d.error || 'Save failed');
    if (d.consultant) Object.assign(CONS_DATA || {}, d.consultant);
    // Re-approval flow for approved consultants
    if (_wasApproved && !_pendingEditNotified) {
      _pendingEditNotified = true;
      _api('POST', '/ls/consultants/request-reapproval', { changed_section: section })
        .then(function(r){ if(r.ok) { showReviewBanner(); CONS_DATA.status='pending'; } })
        .catch(function(){});
    }
    msgEl.innerHTML = '<div class="ok-msg">&#10003; Saved</div>';
    setTimeout(function(){ msgEl.innerHTML=''; }, 3000);
  } catch(e) { msgEl.innerHTML = '<div class="err-msg">&#10060; ' + e.message + '</div>'; }
}

function showReviewBanner() {
  var existing = document.getElementById('review-pending-banner');
  if (existing) return;
  var banner = document.createElement('div');
  banner.id = 'review-pending-banner';
  banner.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:rgba(245,158,11,.12);border:1px solid rgba(245,158,11,.4);border-radius:10px;padding:12px 24px;font-size:13px;color:var(--warn);font-weight:600;z-index:500;display:flex;align-items:center;gap:10px;box-shadow:0 8px 32px rgba(0,0,0,.3);max-width:90vw';
  banner.innerHTML = '<span style="font-size:18px">&#128260;</span><span>Your profile changes are pending admin review. You\'ll be notified once approved.</span>'
    +'<button onclick="this.parentElement.remove()" style="background:none;border:none;color:var(--warn);cursor:pointer;font-size:18px;margin-left:8px;padding:0">×</button>';
  document.body.appendChild(banner);
  setTimeout(function(){ banner.style.transition='.4s'; banner.style.opacity='0'; setTimeout(function(){ banner.remove(); },400); }, 8000);
}

async function _saveSectionSilent(section) {
  var payload = _buildSectionPayload(section); if (!payload) return;
  var r = await _api('PUT', '/ls/consultants/me', payload);
  if (!r.ok) { var d = await r.json(); throw new Error(d.error || 'Failed'); }
}

async function saveAllSections() {
  var spin = document.getElementById('save-all-spin');
  var msg  = document.getElementById('save-all-msg');
  spin.style.display = 'inline-block';
  msg.innerHTML = '<div class="ok-msg"><span class="spinner"></span> Saving all sections...</div>';
  var sections = ['professional','expertise','education','certs','experience','rates'];
  var hasGrid = document.getElementById('avail-grid')?.children?.length > 0;
  if (hasGrid) sections.push('availability');
  var errors = [];
  for (var s of sections) {
    try { await _saveSectionSilent(s); }
    catch(e) { errors.push(s + ': ' + e.message); }
  }
  // Save basic personal too
  try { await saveProfile(); } catch(e) { errors.push('personal: ' + e.message); }
  spin.style.display = 'none';
  msg.innerHTML = errors.length
    ? '<div class="err-msg">&#10060; ' + errors.join('<br>') + '</div>'
    : '<div class="ok-msg">&#10003; All profile data saved</div>';
  setTimeout(function(){ msg.innerHTML=''; document.getElementById('ai-banner').style.display='none'; }, 5000);
}

// ── CV Upload ─────────────────────────────────────────────────────────────────
function onCvSelect(input) {
  CV_FILE = input.files[0];
  if (CV_FILE) {
    document.getElementById('cv-chosen').textContent = '&#128206; ' + CV_FILE.name;
    document.getElementById('cv-upload-btn').disabled = false;
    document.getElementById('cv-save-only-btn').disabled = false;
  }
}
function onCvDrop(e) {
  e.preventDefault();
  document.getElementById('cv-drop').classList.remove('drag');
  CV_FILE = e.dataTransfer.files[0];
  if (CV_FILE) {
    document.getElementById('cv-chosen').textContent = '&#128206; ' + CV_FILE.name;
    document.getElementById('cv-upload-btn').disabled = false;
    document.getElementById('cv-save-only-btn').disabled = false;
  }
}

async function uploadCVOnly() {
  if (!CV_FILE) return;
  var btn=document.getElementById('cv-save-only-btn'), spin=document.getElementById('cv-save-spin');
  btn.disabled=true; spin.style.display='inline-block';
  document.getElementById('cv-msg').innerHTML = '<div class="ok-msg"><span class="spinner"></span> Uploading CV...</div>';
  try {
    var fd = new FormData(); fd.append('cv', CV_FILE); fd.append('no_extract','1');
    var r = await fetch('https://erp-ai-backend.vercel.app/ls/consultants/upload-cv?no_extract=1', {
      method:'POST', headers:{'Authorization':'Bearer '+TOKEN}, body:fd
    });
    var d = await r.json();
    if (!r.ok) throw new Error(d.error || 'Upload failed');
    document.getElementById('cv-msg').innerHTML = '<div class="ok-msg">&#10003; CV uploaded</div>';
    document.getElementById('cv-current').textContent = '&#128206; Current CV: ' + CV_FILE.name;
    CV_FILE = null;
    document.getElementById('cv-upload-btn').disabled = true;
    document.getElementById('cv-save-only-btn').disabled = true;
    setTimeout(function(){ document.getElementById('cv-msg').innerHTML=''; }, 3000);
  } catch(e) { document.getElementById('cv-msg').innerHTML = '<div class="err-msg">&#10060; ' + e.message + '</div>'; }
  finally { btn.disabled=false; spin.style.display='none'; }
}

async function uploadCV() {
  if (!CV_FILE) return;
  var btn=document.getElementById('cv-upload-btn'), spin=document.getElementById('cv-spin');
  btn.disabled=true; spin.style.display='inline-block';
  document.getElementById('cv-msg').innerHTML = '<div class="ok-msg"><span class="spinner"></span> &#10024; Uploading and extracting with AI... this may take 20-40 seconds</div>';
  try {
    var fd = new FormData(); fd.append('cv', CV_FILE);
    var r = await fetch('https://erp-ai-backend.vercel.app/ls/consultants/upload-cv', {
      method:'POST', headers:{'Authorization':'Bearer '+TOKEN}, body:fd
    });
    var d = await r.json();
    if (!r.ok) throw new Error(d.error || 'Upload failed');
    var ex = d.extracted || {};
    // Fill form fields
    if (ex.full_name)       document.getElementById('p-name').value       = ex.full_name;
    if (ex.phone)           document.getElementById('p-phone').value      = ex.phone;
    if (ex.country)         document.getElementById('p-country').value    = ex.country;
    var cEl=document.getElementById('p-city'); if(cEl&&ex.city) cEl.value = ex.city;
    if (ex.current_company) document.getElementById('pr-company').value   = ex.current_company;
    if (ex.job_title)       document.getElementById('pr-title').value     = ex.job_title;
    if (ex.years_exp)       document.getElementById('pr-exp').value       = ex.years_exp;
    if (ex.linkedin_url)    document.getElementById('pr-linkedin').value  = ex.linkedin_url;
    if (ex.hourly_rate)     document.getElementById('r-hourly').value     = ex.hourly_rate;
    if (ex.languages)       ex.languages.forEach(function(l){ addTagVal('lang',l); });
    if (ex.erp_expertise)   ex.erp_expertise.forEach(function(v){ addTagVal('erp',v); });
    if (ex.modules)         ex.modules.forEach(function(v){ addTagVal('mod',v); });
    if (ex.skills)          ex.skills.forEach(function(v){ addTagVal('skill',v); });
    if (ex.education)       { document.getElementById('edu-list').innerHTML=''; ex.education.forEach(addEduItem); }
    if (ex.certifications)  { document.getElementById('cert-list').innerHTML=''; ex.certifications.forEach(addCertItem); }
    if (ex.work_experience) { document.getElementById('work-list').innerHTML=''; ex.work_experience.forEach(addWorkItem); }
    // Show review summary
    var rows = [];
    if (ex.full_name||ex.phone||ex.country||ex.city) rows.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--border)"><span style="color:var(--gl);font-size:14px">&#10003;</span><span style="font-weight:600;width:160px">Personal Info</span><span style="color:var(--muted);font-size:12px">'+(ex.full_name||'')+(ex.city?', '+ex.city:'')+(ex.country?', '+ex.country:'')+'</span></div>');
    if (ex.current_company||ex.job_title) rows.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--border)"><span style="color:var(--gl);font-size:14px">&#10003;</span><span style="font-weight:600;width:160px">Professional</span><span style="color:var(--muted);font-size:12px">'+(ex.job_title||'')+' @ '+(ex.current_company||'')+(ex.years_exp?' · '+ex.years_exp+' yrs':'')+'</span></div>');
    if ((ex.erp_expertise||[]).length) rows.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--border)"><span style="color:var(--gl);font-size:14px">&#10003;</span><span style="font-weight:600;width:160px">ERP Systems</span><span style="color:var(--muted);font-size:12px">'+ex.erp_expertise.join(', ')+'</span></div>');
    if ((ex.modules||[]).length) rows.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--border)"><span style="color:var(--gl);font-size:14px">&#10003;</span><span style="font-weight:600;width:160px">Modules</span><span style="color:var(--muted);font-size:12px">'+ex.modules.slice(0,5).join(', ')+(ex.modules.length>5?' +'+( ex.modules.length-5)+' more':'')+'</span></div>');
    if ((ex.skills||[]).length) rows.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--border)"><span style="color:var(--gl);font-size:14px">&#10003;</span><span style="font-weight:600;width:160px">Technical Skills</span><span style="color:var(--muted);font-size:12px">'+ex.skills.length+' skills extracted</span></div>');
    if ((ex.certifications||[]).length) rows.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--border)"><span style="color:var(--gl);font-size:14px">&#10003;</span><span style="font-weight:600;width:160px">Certifications</span><span style="color:var(--muted);font-size:12px">'+ex.certifications.length+' found: '+ex.certifications.slice(0,2).map(function(c){return c.name;}).join(', ')+(ex.certifications.length>2?' +more':'')+'</span></div>');
    if ((ex.education||[]).length) rows.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0;border-bottom:1px solid var(--border)"><span style="color:var(--gl);font-size:14px">&#10003;</span><span style="font-weight:600;width:160px">Education</span><span style="color:var(--muted);font-size:12px">'+ex.education.map(function(e){return (e.degree||'')+(e.institution?' - '+e.institution:'');}).join('; ')+'</span></div>');
    if ((ex.work_experience||[]).length) rows.push('<div style="display:flex;align-items:center;gap:8px;padding:5px 0"><span style="color:var(--gl);font-size:14px">&#10003;</span><span style="font-weight:600;width:160px">Work Experience</span><span style="color:var(--muted);font-size:12px">'+ex.work_experience.length+' roles extracted</span></div>');
    document.getElementById('ai-review-summary').innerHTML = rows.length
      ? rows.join('')
      : '<div style="color:var(--warn);font-size:12px">&#9888; Limited data extracted - please fill in the sections manually</div>';
    document.getElementById('cv-msg').innerHTML = '';
    document.getElementById('ai-banner').style.display = 'block';
    document.getElementById('cv-current').textContent = '&#128206; Current CV: ' + CV_FILE.name;
  } catch(e) { document.getElementById('cv-msg').innerHTML = '<div class="err-msg">&#10060; ' + e.message + '</div>'; }
  finally { btn.disabled=false; spin.style.display='none'; }
}

// ── Wallet ────────────────────────────────────────────────────────────────────
async function loadWallet() {
  try {
    var r = await _api('GET', '/ls/consultants/wallet'); if (!r.ok) return;
    var d = await r.json(); var w = d.wallet || {};
    document.getElementById('wallet-balance').textContent   = '$' + parseFloat(w.balance||0).toFixed(2);
    document.getElementById('wallet-total').textContent     = '$' + parseFloat(w.total_earned||0).toFixed(2);
    document.getElementById('wallet-withdrawn').textContent = '$' + parseFloat(w.total_withdrawn||0).toFixed(2);
    var txs = d.transactions || [];
    if (txs.length) {
      document.getElementById('wallet-transactions').innerHTML = txs.map(function(tx){
        var isCredit = tx.type === 'credit';
        return '<div style="display:flex;align-items:center;justify-content:space-between;padding:10px 0;border-bottom:1px solid var(--border);font-size:13px">'
          +'<div style="flex:1;min-width:0">'          +'<div style="font-weight:600;font-size:13px;margin-bottom:3px">'+(tx.description||'Payment').split(' | ')[0]+'</div>'          +((tx.description||'').split(' | ').slice(1).length ? '<div style="font-size:11px;color:var(--muted);line-height:1.6;margin-bottom:2px">'+(tx.description||'').split(' | ').slice(1).join(' &middot; ')+'</div>' : '')          +'<div style="font-size:10px;color:var(--dim);margin-top:1px">'+_fmtDate(tx.created_at)+'</div>'          +'</div>'
          +'<div style="font-weight:700;color:'+(isCredit?'var(--gl)':'var(--danger)')+'">'+( isCredit?'+':'-')+'$'+parseFloat(tx.amount||0).toFixed(2)+'</div></div>';
      }).join('');
    }
  } catch(e) { console.error('[Wallet]', e); }
}

// ── Banking ───────────────────────────────────────────────────────────────────
async function loadBanking() {
  try {
    var r = await _api('GET', '/ls/consultants/banking'); if (!r.ok) return;
    var d = await r.json(); var b = d.banking || {};
    if (b.bank_name)       document.getElementById('b-bank-name').value     = b.bank_name;
    if (b.account_name)    document.getElementById('b-account-name').value  = b.account_name;
    if (b.account_number)  document.getElementById('b-account-number').value= b.account_number;
    if (b.routing)         document.getElementById('b-routing').value       = b.routing;
    if (b.account_type)    document.getElementById('b-account-type').value  = b.account_type;
    if (b.bank_country)    document.getElementById('b-bank-country').value  = b.bank_country;
    if (b.paypal)          document.getElementById('b-paypal').value        = b.paypal;
    if (b.tax_id)          document.getElementById('b-tax-id').value        = b.tax_id;
    if (b.dob)             document.getElementById('b-dob').value           = b.dob;
    if (b.id_document_url) { document.getElementById('id-current-link').style.display='block'; document.getElementById('id-view-link').href=b.id_document_url; }
    if (b.id_type)         document.getElementById('b-id-type').value       = b.id_type;
    if (b.id_country_us===false) { document.getElementById('b-non-us').checked=true; toggleNonUS(document.getElementById('b-non-us')); }
    if (b.ssn_last4)       document.getElementById('b-ssn').placeholder     = 'On file (ending '+b.ssn_last4+')';
    ['agree-terms','agree-privacy','agree-payment','agree-conduct'].forEach(function(id){ if (b['agree_'+id.split('-')[1]]) document.getElementById(id).checked=true; });
  } catch(e) { console.error('[Banking]', e); }
}

async function saveBanking() {
  var msgEl = document.getElementById('banking-msg');
  if (_idFile) {
    msgEl.innerHTML = '<div class="ok-msg"><span class="spinner"></span> Uploading ID document...</div>';
    var uploaded = await uploadIdDocument();
    if (!uploaded) { msgEl.innerHTML = '<div class="err-msg">&#10060; ID upload failed</div>'; return; }
  }
  var checks = ['agree-terms','agree-privacy','agree-payment','agree-conduct'];
  if (!checks.every(function(id){ return document.getElementById(id).checked; })) {
    msgEl.innerHTML = '<div class="err-msg">&#9888; Please agree to all policies before saving</div>'; return;
  }
  var nonUS  = document.getElementById('b-non-us')?.checked;
  var ssnVal = nonUS ? '' : document.getElementById('b-ssn').value.replace(/\D/g,'');
  var payload = {
    bank_name:document.getElementById('b-bank-name').value.trim(), account_name:document.getElementById('b-account-name').value.trim(),
    account_number:document.getElementById('b-account-number').value.trim(), routing:document.getElementById('b-routing').value.trim(),
    account_type:document.getElementById('b-account-type').value, bank_country:document.getElementById('b-bank-country').value.trim(),
    paypal:document.getElementById('b-paypal').value.trim(), tax_id:document.getElementById('b-tax-id').value.trim(),
    dob:document.getElementById('b-dob').value, id_type:document.getElementById('b-id-type').value,
    agree_terms:true, agree_privacy:true, agree_payment:true, agree_conduct:true, id_country_us:!nonUS
  };
  if (ssnVal.length >= 4) payload.ssn = ssnVal;
  msgEl.innerHTML = '<div class="ok-msg"><span class="spinner"></span> Saving...</div>';
  try {
    var r = await _api('PUT', '/ls/consultants/banking', payload);
    var d = await r.json();
    if (!r.ok) throw new Error(d.error || 'Save failed');
    msgEl.innerHTML = '<div class="ok-msg">&#10003; Banking details saved securely</div>';
    document.getElementById('b-ssn').value = '';
    if (ssnVal) document.getElementById('b-ssn').placeholder = 'Updated (ending '+ssnVal.slice(-4)+')';
    setTimeout(function(){ msgEl.innerHTML=''; }, 4000);
  } catch(e) { msgEl.innerHTML = '<div class="err-msg">&#10060; ' + e.message + '</div>'; }
}

// ── ID Document upload ────────────────────────────────────────────────────────
function onIdFileSelect(input) {
  _idFile = input.files[0];
  if (_idFile) {
    document.getElementById('id-file-chosen').textContent = '&#128206; ' + _idFile.name + ' (' + (_idFile.size/1024/1024).toFixed(1)+' MB)';
    document.getElementById('id-file-chosen').style.display = 'block';
    document.getElementById('id-drop-area').style.borderColor = 'var(--gl)';
  }
}
function onIdFileDrop(e) {
  e.preventDefault(); e.currentTarget.style.borderColor='';
  var f = e.dataTransfer.files[0];
  if (f) { _idFile=f; document.getElementById('id-file-chosen').textContent='&#128206; '+f.name; document.getElementById('id-file-chosen').style.display='block'; }
}
async function uploadIdDocument() {
  if (!_idFile) return null;
  var prog=document.getElementById('id-upload-progress'), bar=document.getElementById('id-progress-bar'), txt=document.getElementById('id-progress-text');
  prog.style.display='block'; bar.style.width='20%'; txt.textContent='Uploading...';
  try {
    var fd=new FormData(); fd.append('id_document', _idFile); bar.style.width='50%';
    var r = await fetch('https://erp-ai-backend.vercel.app/ls/consultants/upload-id', {
      method:'POST', headers:{'Authorization':'Bearer '+TOKEN}, body:fd
    });
    var d = await r.json();
    if (!r.ok) throw new Error(d.error||'Upload failed');
    bar.style.width='100%'; txt.textContent='Uploaded &#10003;';
    setTimeout(function(){ prog.style.display='none'; }, 2000);
    document.getElementById('id-current-link').style.display='block';
    document.getElementById('id-view-link').href=d.url;
    _idFile=null; return d.url;
  } catch(e) { bar.style.width='0%'; txt.textContent='Upload failed: '+e.message; return null; }
}

// ── SSN / identity helpers ────────────────────────────────────────────────────
function toggleNonUS(chk) {
  var ssnInput=document.getElementById('b-ssn'), ssnReq=document.getElementById('ssn-required'), ssnHint=document.getElementById('ssn-hint'), taxReq=document.getElementById('taxid-required');
  if (chk.checked) {
    ssnInput.value=''; ssnInput.placeholder='Not applicable'; ssnInput.disabled=true;
    if (ssnReq) ssnReq.style.display='none';
    if (ssnHint) ssnHint.textContent='SSN not required for non-US/Canada consultants.';
    if (taxReq) { taxReq.textContent='*'; taxReq.style.color='var(--danger)'; }
  } else {
    ssnInput.placeholder='XXX-XX-XXXX'; ssnInput.disabled=false;
    if (ssnReq) ssnReq.style.display='inline';
    if (ssnHint) ssnHint.textContent='Required for US/Canada consultants for W2/T4.';
    if (taxReq) taxReq.textContent='';
  }
}
function fmtSSN(inp) {
  var v=inp.value.replace(/\D/g,'').substring(0,9);
  if (v.length>5) v=v.slice(0,3)+'-'+v.slice(3,5)+'-'+v.slice(5);
  else if (v.length>3) v=v.slice(0,3)+'-'+v.slice(3);
  inp.value=v;
}
function togglePwdField(id,btn) {
  var el=document.getElementById(id); if (!el) return;
  el.type=el.type==='password'?'text':'password';
  btn.textContent=el.type==='password'?'&#128065;':'&#128584;';
}
async function changeConsPassword() {
  var current=document.getElementById('pw-current').value, newPw=document.getElementById('pw-new').value, conf=document.getElementById('pw-confirm').value;
  var msgEl=document.getElementById('pw-msg'); msgEl.innerHTML='';
  if (!current)       { msgEl.innerHTML='<div class="err-msg">Enter current password</div>'; return; }
  if (newPw.length<8) { msgEl.innerHTML='<div class="err-msg">New password must be at least 8 characters</div>'; return; }
  if (newPw!==conf)   { msgEl.innerHTML='<div class="err-msg">Passwords do not match</div>'; return; }
  msgEl.innerHTML='<div class="ok-msg"><span class="spinner"></span> Changing...</div>';
  try {
    var r=await _api('POST','/ls/consultants/change-password',{current_password:current,new_password:newPw});
    var d=await r.json(); if (!r.ok) throw new Error(d.error||'Failed');
    msgEl.innerHTML='<div class="ok-msg">&#10003; Password changed</div>';
    ['pw-current','pw-new','pw-confirm'].forEach(function(id){ var el=document.getElementById(id); if(el) el.value=''; });
  } catch(e) { msgEl.innerHTML='<div class="err-msg">&#10060; '+e.message+'</div>'; }
}
function _fmtDate(iso) {
  if (!iso) return '-';
  try {
    var d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(iso + 'T00:00:00') : new Date(iso);
    return d.toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'});
  } catch(_){ return iso; }
}

// ═══════════════════════════════════════════════════════════════════════════
// TASK CREATION (Manager + Consultant with permission)
// ═══════════════════════════════════════════════════════════════════════════
async function openTaskInvoiceModal(taskId, taskTitle, estHours) {
  var pid=_currentProj&&_currentProj.project&&_currentProj.project.id;
  var rate=0, me=(_currentProj&&_currentProj.members||[]).find(function(m){return m.user_id===USER.id;});
  if(me&&me.rate) rate=parseFloat(me.rate)||0;
  var suggested=(rate>0&&estHours>0)?(rate*estHours).toFixed(2):'';
  showPortalModal('Create Task Invoice',
    '<div style="background:rgba(15,181,116,.06);border:1px solid rgba(15,181,116,.2);border-radius:8px;padding:10px 14px;margin-bottom:14px">'    +'<div style="font-size:13px;font-weight:700">'+escHtml(taskTitle)+'</div>'    +(estHours?'<div style="font-size:11px;color:var(--muted)">'+estHours+'h'+(rate?' @ $'+rate+'/h = $'+(rate*estHours).toFixed(2):'')+'</div>':'')+'</div>'    +'<div class="fgrp"><label class="flbl">Invoice Title *</label><input class="finput" id="ti-title" value="'+escHtml('Work: '+String(taskTitle||'').substring(0,50))+'"></div>'    +'<div class="frow"><div class="fgrp"><label class="flbl" style="color:var(--warn)">Amount ($) *</label>'    +'<input class="finput" id="ti-amount" type="number" min="1" step="0.01" value="'+suggested+'" placeholder="0.00"></div>'    +'<div class="fgrp"><label class="flbl">Due Date</label><input class="finput" id="ti-due" type="date"></div></div>'    +'<div class="fgrp"><label class="flbl">Notes</label><textarea class="ftextarea" id="ti-notes" rows="2" placeholder="Payment terms, scope..."></textarea></div>'    +'<div style="display:flex;align-items:center;gap:8px;margin-bottom:10px">'    +'<input type="checkbox" id="ti-send" style="accent-color:var(--gl);width:16px;height:16px">'    +'<label for="ti-send" style="font-size:12px;cursor:pointer">Send invoice to client immediately</label></div>'    +'<div id="ti-msg"></div>',
    async function() {
      var ttl=(document.getElementById('ti-title')||{}).value.trim();
      var amt=parseFloat((document.getElementById('ti-amount')||{}).value)||0;
      var msgEl=document.getElementById('ti-msg');
      if(!ttl){msgEl.innerHTML='<div class="err-msg">Invoice title required</div>';return;}
      if(!amt||amt<1){msgEl.innerHTML='<div class="err-msg">Amount required (min $1)</div>';return;}
      var r=await _api('POST','/proj/projects/'+pid+'/tasks/'+taskId+'/invoice',{
        title:ttl,amount:amt,currency:'USD',
        due_date:(document.getElementById('ti-due')||{}).value||null,
        notes:(document.getElementById('ti-notes')||{}).value||null,
        send_now:!!((document.getElementById('ti-send')||{}).checked),
      });
      var d=await r.json();
      if(r.ok){closePortalModal();window.toast&&window.toast('Invoice '+(d.invoice&&d.invoice.status==='sent'?'sent to client':'saved')+' done','success');await refreshCurrentTab();}
      else msgEl.innerHTML='<div class="err-msg">'+escHtml(d.error||'Failed')+'</div>';
    }
  );
}

function openCreateTask()      { openCreateTaskModal(); }
function openCreateTaskModal() {
  if (!_currentProj) { alert('Open a project first'); return; }
  var pid = _currentProj.project?.id;
  var members = _currentProj.members||[];
  var consOpts = members.filter(function(m){ return m.role==='consultant'; })
    .map(function(m){ return '<option value="'+m.user_id+'">'+(m.pm_users?.full_name||m.user_id)+'</option>'; }).join('');
  var tickOpts = (_currentProj.tickets||[]).map(function(t){
    return '<option value="'+t.id+'">'+t.ticket_number+'</option>';
  }).join('');

  showPortalModal('Create Task',
    '<div class="fgrp"><label class="flbl">Title *</label><input class="finput" id="ct-title" placeholder="Task title"></div>'
    +'<div class="frow"><div class="fgrp"><label class="flbl">Priority</label><select class="fselect" id="ct-priority"><option value="medium">Medium</option><option value="low">Low</option><option value="high">High</option><option value="critical">Critical</option></select></div>'
    +'<div class="fgrp"><label class="flbl">Category</label><input class="finput" id="ct-cat" placeholder="e.g. Configuration"></div></div>'
    +(ROLE==='manager'&&consOpts?'<div class="fgrp"><label class="flbl">Assign Consultant</label><select class="fselect" id="ct-cons"><option value="">Unassigned</option>'+consOpts+'</select></div>':'')
    +(tickOpts?'<div class="fgrp"><label class="flbl">Linked Ticket</label><select class="fselect" id="ct-ticket"><option value="">None</option>'+tickOpts+'</select></div>':'')
    +'<div class="frow"><div class="fgrp"><label class="flbl">Est. Hours <span style="color:var(--danger)">*</span></label><input class="finput" id="ct-hrs" type="number" min="0.5" step="0.5" placeholder="e.g. 3.5" required></div><div class="fgrp"><label class="flbl">Start Date <span style="color:var(--danger)">*</span></label><input class="finput" id="ct-start" type="date" required></div></div>'
    +'<div class="frow"><div class="fgrp"><label class="flbl">End Date <span style="color:var(--danger)">*</span></label><input class="finput" id="ct-end" type="date" required></div><div class="fgrp"><label class="flbl">Due Date <span style="color:var(--danger)">*</span></label><input class="finput" id="ct-due" type="date" required></div></div>'
    +'<div class="fgrp"><label class="flbl">Description</label><textarea class="ftextarea" id="ct-desc" rows="3" placeholder="Task details..."></textarea></div>'
    +'<div class="fgrp"><label class="flbl" style="color:var(--warn)">Requirements & Scope *</label><textarea class="ftextarea" id="ct-req" rows="4" placeholder="List all task requirements, deliverables, and acceptance criteria. This is used for invoicing and legal documentation."></textarea></div>'
    +'<div style="background:rgba(245,158,11,.07);border:1px solid rgba(245,158,11,.2);border-radius:8px;padding:12px 14px;margin-bottom:10px">'
    +'<label style="display:flex;align-items:flex-start;gap:10px;cursor:pointer">'
    +'<input type="checkbox" id="ct-agree" style="margin-top:2px;accent-color:var(--gl);width:16px;height:16px;flex-shrink:0">'
    +'<span style="font-size:12px;color:var(--text)">I accept the task scope and <a href="/pages/task-agreement" target="_blank" style="color:var(--gl)">Task Responsibility Agreement</a> (California B&amp;P Code §17200).</span>'
    +'</label></div>'
    +'<div id="ct-msg"></div>',
    async function() {
      var title = document.getElementById('ct-title')?.value.trim();
      var msg   = document.getElementById('ct-msg');
      var hrs=parseFloat(document.getElementById('ct-hrs')?.value)||0;
      var req2=(document.getElementById('ct-req')?.value||'').trim();
      var agree=!!(document.getElementById('ct-agree')?.checked);
      if (!title) { msg.innerHTML='<div class="err-msg">Title required</div>'; return; }
      if (!hrs||hrs<0.5) { msg.innerHTML='<div class="err-msg">Estimated hours required (min 0.5h)</div>'; return; }
      if (!req2) { msg.innerHTML='<div class="err-msg">Requirements & Scope required for invoicing</div>'; return; }
      if (!document.getElementById('ct-start')?.value) { msg.innerHTML='<div class="err-msg">Start date is required</div>'; return; }
      if (!document.getElementById('ct-end')?.value) { msg.innerHTML='<div class="err-msg">End date is required</div>'; return; }
      if (!document.getElementById('ct-due')?.value) { msg.innerHTML='<div class="err-msg">Due date is required</div>'; return; }
      if (!agree) { msg.innerHTML='<div class="err-msg">Please accept the Task Responsibility Agreement</div>'; return; }
      var r = await _api('POST', '/proj/projects/'+pid+'/tasks', {
        title, priority: document.getElementById('ct-priority')?.value,
        category: document.getElementById('ct-cat')?.value,
        assigned_to:        document.getElementById('ct-cons')?.value||null,
        assigned_consultant: document.getElementById('ct-cons')?.value||null,
        ticket_id:           document.getElementById('ct-ticket')?.value||null,
        estimated_hours:     hrs,
        requirements:        req2,
        agreement_accepted:  true,
        start_date:          document.getElementById('ct-start')?.value||null,
        end_date:            document.getElementById('ct-end')?.value||null,
        due_date:            document.getElementById('ct-due')?.value||null,
        description:         document.getElementById('ct-desc')?.value,
        assigned_to_source:  'ls_consultants'
      });
      var d = await r.json();
      if (r.ok) { closePortalModal(); await refreshCurrentTab(); window.toast&&window.toast('Task created &#10003;','success'); }
      else msg.innerHTML = '<div class="err-msg">&#10060; '+(d.error||'Failed')+'</div>';
    }
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// MEETING SCHEDULING
// ═══════════════════════════════════════════════════════════════════════════
function openMeetingModal()    { openScheduleMeeting(); }
function openScheduleMeeting() {
  var pid = _currentProj?.project?.id;
  var today = new Date().toISOString().split('T')[0];
  var userTz = 'UTC';
  try { userTz = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch(e){}

  // Build project selector only when NOT inside a specific project
  var projSelector = '';
  if (!pid && _projects && _projects.length > 0) {
    projSelector = '<div class="fgrp"><label class="flbl">Project *</label>'
      + '<select class="fselect" id="sm-project" onchange="loadMeetingAttendees(this.value)">'
      + '<option value="">— Select a project —</option>'
      + _projects.map(function(p){ return '<option value="'+p.id+'">'+escHtml(p.title||'Untitled')+'</option>'; }).join('')
      + '</select></div>';
  }

  showPortalModal('Schedule Meeting',
    projSelector
    +'<div class="fgrp"><label class="flbl">Title *</label><input class="finput" id="sm-title" placeholder="Meeting title"></div>'
    +'<div class="frow"><div class="fgrp"><label class="flbl">Date *</label><input class="finput" id="sm-date" type="date" min="'+today+'"></div>'
    +'<div class="fgrp"><label class="flbl">Time *</label><input class="finput" id="sm-time" type="time"></div></div>'
    +'<div class="fgrp"><label class="flbl">Timezone</label><select class="fselect" id="sm-tz">'
    +'<option value="UTC">UTC</option><option value="America/New_York">US Eastern (ET)</option>'
    +'<option value="America/Los_Angeles">US Pacific (PT)</option><option value="Europe/London">London (GMT)</option>'
    +'<option value="Asia/Dubai">Dubai (GST)</option><option value="Asia/Riyadh">Riyadh (AST)</option>'
    +'<option value="Africa/Cairo">Cairo (EET)</option></select></div>'
    +'<div class="fgrp"><label class="flbl">Agenda</label><textarea class="ftextarea" id="sm-agenda" rows="3" placeholder="What will be discussed?"></textarea></div>'
    +'<div class="fgrp"><label class="flbl" style="display:flex;align-items:center;justify-content:space-between">Invite Attendees <span style="font-size:10px;color:var(--muted);font-weight:400">Loading project members…</span></label>'
    +'<div id="sm-attendees-list" style="display:flex;flex-direction:column;gap:6px;max-height:180px;overflow-y:auto;background:var(--bg2);border:1px solid var(--border2);border-radius:8px;padding:10px"></div></div>'
    +'<div style="background:rgba(245,158,11,.06);border:1px solid rgba(245,158,11,.2);border-radius:7px;padding:10px 12px;font-size:12px;color:var(--warn)">&#9888; Client must confirm this meeting before it is finalized.</div>'
    +'<div id="sm-msg" style="margin-top:8px"></div>',
    async function() {
      var projectId = pid || (document.getElementById('sm-project')?.value) || '';
      var title = document.getElementById('sm-title')?.value.trim();
      var date  = document.getElementById('sm-date')?.value;
      var time  = document.getElementById('sm-time')?.value;
      var msg   = document.getElementById('sm-msg');
      if (!projectId) { msg.innerHTML='<div class="err-msg">Please select a project</div>'; return; }
      if (!title||!date||!time) { msg.innerHTML='<div class="err-msg">Title, date and time required</div>'; return; }

      // Collect selected attendees
      var attendees = [];
      document.querySelectorAll('#sm-attendees-list input[type="checkbox"]:checked').forEach(function(cb) {
        attendees.push({ id: cb.dataset.id, name: cb.dataset.name, email: cb.dataset.email, role: cb.dataset.role });
      });
      if (!attendees.length) { msg.innerHTML='<div class="err-msg">Please select at least 1 attendee</div>'; return; }

      var r = await _api('POST', '/proj/projects/'+projectId+'/meetings', {
        title, scheduled_date: date, scheduled_time: time,
        timezone: document.getElementById('sm-tz')?.value||'UTC',
        agenda: document.getElementById('sm-agenda')?.value,
        attendees: attendees.length ? attendees : null
      });
      var d = await r.json();
      if (r.ok) {
        closePortalModal();
        window.toast && window.toast('✅ Meeting scheduled — emails sent to team', 'success');
        if (pid) { openProject(pid); } else { loadAllMeetings(); }
      } else msg.innerHTML = '<div class="err-msg">&#10060; '+(d.error||'Failed')+'</div>';
    }
  );

  // Auto-set timezone, date, and time
  try {
    var now = new Date();
    // Date → today
    var el_date = document.getElementById('sm-date');
    if (el_date) el_date.value = now.toLocaleDateString('en-CA'); // YYYY-MM-DD in local time
    // Time → current time rounded to next 5 min
    var el_time = document.getElementById('sm-time');
    if (el_time) {
      var mins = now.getMinutes();
      var roundedMins = Math.ceil(mins / 5) * 5;
      var adjHour = now.getHours() + Math.floor(roundedMins / 60);
      roundedMins = roundedMins % 60;
      el_time.value = String(adjHour % 24).padStart(2,'0') + ':' + String(roundedMins).padStart(2,'0');
    }
    // Timezone
    document.getElementById('sm-tz').value = userTz;
  } catch(e){}

  // Load attendees for current project or wait for selection
  if (pid) { loadMeetingAttendees(pid); }
}

async function loadMeetingAttendees(projectId) {
  var listEl = document.getElementById('sm-attendees-list');
  if (!listEl || !projectId) return;
  listEl.innerHTML = '<div style="font-size:12px;color:var(--muted);padding:8px">Loading members…</div>';
  try {
    var r = await _api('GET', '/proj/projects/'+projectId+'/members');
    var d = await r.json();
    var people = d.people || [];
    if (!people.length) {
      listEl.innerHTML = '<div style="font-size:12px;color:var(--muted);padding:8px">No members found in this project</div>';
      return;
    }
    var roleColors  = { client:'#60a5fa', consultant:'var(--gl)', manager:'#a78bfa', erpm:'#a78bfa', pm:'#a78bfa' };
    var roleLabels  = { client:'Client', consultant:'Consultant', manager:'ERP Manager', erpm:'ERP Manager', pm:'ERP Manager' };
    listEl.innerHTML = people.map(function(p) {
      var rColor = roleColors[p.role] || 'var(--muted)';
      var rLabel = roleLabels[p.role] || p.role;
      return '<label style="display:flex;align-items:center;gap:10px;padding:7px 8px;border-radius:6px;cursor:pointer;transition:background .15s" onmouseover="this.style.background=\'var(--bg3)\'" onmouseout="this.style.background=\'\'">'
        + '<input type="checkbox" checked data-id="'+escHtml(String(p.id||''))+'" data-name="'+escHtml(p.name)+'" data-email="'+escHtml(p.email)+'" data-role="'+escHtml(p.role)+'" style="width:15px;height:15px;accent-color:var(--gl);flex-shrink:0">'
        + '<div style="flex:1;font-size:13px;font-weight:600">'+escHtml(p.name)+'</div>'
        + '<span style="font-size:10px;padding:2px 8px;border-radius:10px;background:'+rColor+'22;color:'+rColor+';font-weight:700;flex-shrink:0">'+escHtml(rLabel)+'</span>'
        + '</label>';
    }).join('');
    // Update label to show count
    var lbl = document.querySelector('#sm-attendees-list').previousElementSibling?.querySelector('span');
    if (lbl) lbl.textContent = people.length + ' members (all selected by default)';
  } catch(e) {
    listEl.innerHTML = '<div style="font-size:12px;color:var(--danger);padding:8px">Error loading members</div>';
  }
}

// ═══════════════════════════════════════════════════════════════════════════
// FILE UPLOAD
// ═══════════════════════════════════════════════════════════════════════════
async function uploadFile(input) {
  var pid = _currentProj?.project?.id;
  if (!pid || !input.files[0]) return;
  var file = input.files[0];
  var label = input.closest('label');
  if (label) label.innerHTML = '&#9203; Uploading...';

  try {
    // Get signed upload URL from backend
    var r1 = await _api('POST', '/proj/projects/'+pid+'/files/upload-url', {
      filename: file.name, file_type: file.type
    });
    var d1 = await r1.json();
    if (!r1.ok) throw new Error(d1.error||'Failed to get upload URL');

    // Upload to Supabase Storage
    var uploadR = await fetch(d1.signed_url, {
      method: 'PUT', headers: { 'Content-Type': file.type }, body: file
    });
    if (!uploadR.ok) throw new Error('Upload failed: ' + uploadR.status);

    // Register file in DB
    var folder2 = (document.getElementById('cons-folder-input')||{}).value || '';
    var r2 = await _api('POST', '/proj/projects/'+pid+'/files', {
      filename: file.name, file_path: d1.path,
      file_size: file.size, file_type: file.type,
      folder: folder2.trim() || null,
    });
    var d2 = await r2.json();
    if (!r2.ok) throw new Error(d2.error||'Failed to register file');

    if (label) label.innerHTML = '&#128206; Upload';
    await refreshCurrentTab();
    window.toast&&window.toast('File uploaded &#10003;','success');
  } catch(e) {
    if (label) label.innerHTML = '&#128206; Upload';
    alert('Upload error: ' + e.message);
  }
}

async function deleteProjectFile(fileId, filename) {
  if (!confirm('Delete "' + filename + '"? This cannot be undone.')) return;
  try {
    var r = await _api('DELETE', '/proj/files/' + fileId);
    var d = await r.json().catch(function(){ return {}; });
    if (r.ok) {
      window.toast && window.toast('File deleted', 'success');
      await refreshCurrentTab();
    } else {
      window.toast && window.toast(d.error || 'Delete failed', 'error');
    }
  } catch(e) {
    window.toast && window.toast('Delete failed: ' + e.message, 'error');
  }
}

// ═══════════════════════════════════════════════════════════════════════════
// PORTAL MODAL HELPER
// ═══════════════════════════════════════════════════════════════════════════
function showPortalModal(title, body, onConfirm) {
  closePortalModal();
  var el = document.createElement('div');
  el.id = 'portal-modal';
  el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.8);z-index:500;display:flex;align-items:center;justify-content:center;padding:20px;overflow-y:auto';
  el.innerHTML = '<div style="background:#0F1526;border:1px solid #1E2A42;border-radius:12px;width:100%;max-width:540px;overflow:hidden">'
    +'<div style="display:flex;align-items:center;justify-content:space-between;padding:16px 20px;background:#0A0E1A;border-bottom:1px solid #1E2A42">'
    +'<div style="font-size:15px;font-weight:800">'+title+'</div>'
    +'<button onclick="closePortalModal()" style="background:none;border:none;color:#7D8BA3;font-size:20px;cursor:pointer">&#x2715;</button>'
    +'</div><div style="padding:20px">'+body+'</div>'
    +'<div style="padding:14px 20px;background:#0A0E1A;border-top:1px solid #1E2A42;display:flex;gap:8px">'
    +'<button class="btn btn-primary btn-sm" id="modal-confirm-btn">Confirm</button>'
    +'<button class="btn btn-outline btn-sm" onclick="closePortalModal()">Cancel</button>'
    +'</div></div>';
  el.addEventListener('click', function(e){ if(e.target===el) closePortalModal(); });
  document.body.appendChild(el);
  document.getElementById('modal-confirm-btn').onclick = onConfirm;
}
function closePortalModal() {
  var el = document.getElementById('portal-modal');
  if (el) el.remove();
}

// ═══════════════════════════════════════════════════════════════════════════
// AI DOCUMENT GENERATOR
// ═══════════════════════════════════════════════════════════════════════════
var _PROJECT_DOC_TYPES = [
  { value:'project_charter', label:'&#128196; Project Charter',       who:'manager' },
  { value:'scope_document',  label:'&#128203; Scope Document',        who:'manager' },
  { value:'status_report',   label:'&#128202; Status Report',         who:'manager' },
  { value:'meeting_minutes', label:'&#128221; Meeting Minutes',       who:'both'    },
  { value:'change_request',  label:'&#128260; Change Request',        who:'both'    },
  { value:'technical_spec',  label:'&#9881; Technical Specification',who:'consultant'},
  { value:'task_doc',        label:'&#10003; Task Documentation',    who:'consultant'},
  { value:'handover_report', label:'&#127937; Handover Report',       who:'manager' },
];


// ═══════════════════════════════════════════════════════════════════════════
// CHAT ENGINE - Sprint 7
// ═══════════════════════════════════════════════════════════════════════════
var _chatState = {
  projectId:    null,
  interval:     null,
  lastTimestamp:null,
  replyTo:      null,
  messages:     [],
  myId:         null,
  myName:       null,
  myRole:       null,
};

function initChat(projectId, userId, userName, userRole, containerId) {
  if (_chatState.interval) clearInterval(_chatState.interval);
  _chatState = { projectId, interval: null, lastTimestamp: null, replyTo: null, messages: [], myId: userId, myName: userName, myRole: userRole };
  renderChatContainer(containerId);
  fetchChatMessages(true);
  _chatState.interval = setInterval(function(){ fetchChatMessages(false); }, 5000);
}

function destroyChat() {
  if (_chatState.interval) { clearInterval(_chatState.interval); _chatState.interval = null; }
}

function renderChatContainer(containerId) {
  var el = document.getElementById(containerId);
  if (!el) return;

  var team = (_currentProj && _currentProj.eoh_team) || [];
  var proj  = (_currentProj && _currentProj.project) || {};
  var myAv  = USER && USER.full_name ? USER.full_name.charAt(0).toUpperCase() : '?';
  var myClr = ROLE === 'manager' ? '#f59e0b' : '#60a5fa';

  el.style.cssText = 'display:flex;height:100%;min-height:520px;overflow:hidden;border-radius:14px;border:1px solid var(--border);background:var(--bg2);box-shadow:0 4px 24px rgba(0,0,0,.18)';
  el.innerHTML = '';

  // ── Sidebar ───────────────────────────────────────────────────────────────
  var sidebar = document.createElement('div');
  sidebar.style.cssText = 'width:220px;flex-shrink:0;border-right:1px solid var(--border);background:var(--bg3);display:flex;flex-direction:column;overflow:hidden';

  // Sidebar header
  var sHdr = document.createElement('div');
  sHdr.style.cssText = 'padding:16px 14px 12px;border-bottom:1px solid var(--border);background:var(--bg2)';
  sHdr.innerHTML = '<div style="font-size:13px;font-weight:800;color:var(--text);margin-bottom:2px">&#128172; Project Chat</div>'
    + '<div style="font-size:11px;color:var(--muted)">'+(proj.title||'')+(proj.erp_system?' &middot; '+escHtml(proj.erp_system):'')+'</div>';
  sidebar.appendChild(sHdr);

  // Members label
  var membersLbl = document.createElement('div');
  membersLbl.style.cssText = 'padding:10px 14px 4px;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:var(--muted)';
  membersLbl.textContent = 'Members (' + (team.length + 1) + ')';
  sidebar.appendChild(membersLbl);

  // Members list
  var membersList = document.createElement('div');
  membersList.style.cssText = 'overflow-y:auto;flex:1;padding:4px 0';

  // Me row
  var meRow = document.createElement('div');
  meRow.style.cssText = 'display:flex;align-items:center;gap:10px;padding:8px 14px;background:rgba(15,181,116,.06);border-left:3px solid var(--gl)';
  meRow.innerHTML = '<div style="width:32px;height:32px;border-radius:50%;background:'+myClr+'22;color:'+myClr+';display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;flex-shrink:0">'+myAv+'</div>'
    + '<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:700;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--text)">'+(USER&&USER.full_name||'You')+'</div>'
    + '<div style="font-size:10px;color:'+myClr+'">'+( ROLE==='manager'?'ERP Manager':'Consultant')+'</div></div>'
    + '<span style="font-size:9px;font-weight:700;background:var(--gl);color:#fff;border-radius:4px;padding:1px 5px">YOU</span>';
  membersList.appendChild(meRow);

  // Team members (active only)
  team.forEach(function(m) {
    if (!m.id || m.id === (USER&&USER.id) || !m.full_name) return;
    var clr = m.role === 'manager' ? '#f59e0b' : '#60a5fa';
    var lbl = m.role === 'manager' ? 'ERP Manager' : 'Consultant';
    var av  = m.full_name.charAt(0).toUpperCase();
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:center;gap:10px;padding:8px 14px;border-left:3px solid transparent;transition:.15s';
    row.innerHTML = '<div style="width:32px;height:32px;border-radius:50%;background:'+clr+'22;color:'+clr+';display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;flex-shrink:0">'+av+'</div>'
      + '<div style="flex:1;min-width:0"><div style="font-size:12px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--text)">'+escHtml(m.full_name)+'</div>'
      + '<div style="font-size:10px;color:'+clr+'">'+lbl+'</div></div>'
      + '<div style="width:7px;height:7px;border-radius:50%;background:#22c55e;flex-shrink:0" title="Online"></div>';
    membersList.appendChild(row);
  });

  if (!team.length) {
    var noTeam = document.createElement('div');
    noTeam.style.cssText = 'padding:14px;font-size:11px;color:var(--muted);text-align:center;line-height:1.6';
    noTeam.textContent = 'No other team members yet';
    membersList.appendChild(noTeam);
  }
  sidebar.appendChild(membersList);
  el.appendChild(sidebar);

  // ── Main chat area ─────────────────────────────────────────────────────────
  var main = document.createElement('div');
  main.id = 'chat-main';
  main.style.cssText = 'flex:1;min-width:0;display:flex;flex-direction:column;background:var(--bg2)';

  // Header
  main.innerHTML = '<div style="display:flex;align-items:center;justify-content:space-between;padding:12px 18px;border-bottom:1px solid var(--border);background:var(--bg3);flex-shrink:0">'
    + '<div style="display:flex;align-items:center;gap:10px">'
    + '<div style="width:8px;height:8px;border-radius:50%;background:#22c55e;box-shadow:0 0 6px rgba(34,197,94,.5)"></div>'
    + '<div>'
    + '<div style="font-size:13px;font-weight:700;color:var(--text)" id="chat-status-label">Group Chat</div>'
    + '<div id="chat-status" style="font-size:10px;color:var(--muted)">Connecting...</div>'
    + '</div></div>'
    + '<div style="font-size:11px;color:var(--muted)">'+escHtml(proj.title||'')+'</div>'
    + '</div>'
    // Messages area
    + '<div class="chat-msgs" id="chat-msgs" style="flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:2px;background:var(--bg2)"></div>'
    // Reply bar
    + '<div id="chat-reply-bar" style="display:none;padding:6px 14px;background:rgba(15,181,116,.06);border-top:2px solid var(--gl);font-size:12px;color:var(--muted);display:none;align-items:center;justify-content:space-between"></div>'
    // Compose area
    + '<div style="padding:10px 14px;border-top:1px solid var(--border);background:var(--bg3);flex-shrink:0">'
    + '<div style="display:flex;align-items:flex-end;gap:8px;background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:6px 8px 6px 14px">'
    + '<label style="cursor:pointer;color:var(--muted);padding:4px;border-radius:6px;font-size:16px;transition:.15s;flex-shrink:0" title="Attach file">&#128206;<input type="file" style="display:none" onchange="chatAttachFile(this)"></label>'
    + '<button onclick="chatInsertEmoji()" style="background:none;border:none;color:var(--muted);cursor:pointer;padding:4px;font-size:16px;flex-shrink:0" title="Emoji">&#128522;</button>'
    + '<div class="chat-input" id="chat-input" contenteditable="true" data-placeholder="Type a message..." onkeydown="chatKeydown(event)" oninput="chatInputChange()" style="flex:1;min-height:24px;max-height:120px;overflow-y:auto;outline:none;font-size:13px;color:var(--text);line-height:1.5;padding:4px 0"></div>'
    + '<button id="chat-send" onclick="chatSend()" style="background:linear-gradient(135deg,#0fb574,#0A4FCC);border:none;color:#fff;width:34px;height:34px;border-radius:50%;cursor:pointer;font-size:15px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:.2s" title="Send (Enter)">&#10148;</button>'
    + '</div></div>';

  el.appendChild(main);
}


async function fetchChatMessages(initial) {
  var pid = _chatState.projectId;
  if (!pid) return;
  try {
    var url = '/proj/projects/'+pid+'/messages';
    if (!initial && _chatState.lastTimestamp) url += '?since=' + encodeURIComponent(_chatState.lastTimestamp);
    var r = await _api('GET', url);
    if (r.status === 404) {
      // Endpoint not yet deployed - stop polling to avoid console spam
      if (_chatState.interval) { clearInterval(_chatState.interval); _chatState.interval = null; }
      document.getElementById('chat-status').textContent = 'Unavailable';
      document.getElementById('chat-status').style.color = 'var(--danger)';
      return;
    }
    var d = await r.json();
    if (!r.ok) return;
    var msgs = d.messages || [];
    if (!msgs.length && !initial) return;

    if (initial) {
      _chatState.messages = msgs;
    } else {
      // Append only new messages
      var existingIds = new Set(_chatState.messages.map(function(m){ return m.id; }));
      msgs.filter(function(m){ return !existingIds.has(m.id); }).forEach(function(m){ _chatState.messages.push(m); });
    }
    if (msgs.length) _chatState.lastTimestamp = msgs[msgs.length-1].created_at;
    renderMessages(initial);
    if (initial) {
      document.getElementById('chat-status').textContent = 'Online';
      document.getElementById('chat-status').style.color = 'var(--gl)';
    }
  } catch(e) {
    document.getElementById('chat-status').textContent = 'Offline';
    document.getElementById('chat-status').style.color = 'var(--danger)';
  }
}

function renderMessages(scrollToBottom) {
  var el = document.getElementById('chat-msgs');
  if (!el) return;
  var wasBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 60;
  var msgs = _chatState.messages;
  if (!msgs.length) {
    el.innerHTML = '<div style="text-align:center;color:var(--muted);font-size:13px;padding:32px;flex:1">No messages yet. Start the conversation!</div>';
    return;
  }
  var html = '';
  var lastDate = null;
  msgs.forEach(function(m, idx) {
    var mine     = m.sender_id === _chatState.myId;
    var isSystem = m.sender_type === 'admin' && m.is_system;
    var msgDate  = new Date(m.created_at).toDateString();
    // Date divider
    if (msgDate !== lastDate) {
      lastDate = msgDate;
      var today = new Date().toDateString();
      var yesterday = new Date(Date.now()-86400000).toDateString();
      var dateLabel = msgDate === today ? 'Today' : msgDate === yesterday ? 'Yesterday' : new Date(m.created_at).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'});
      html += '<div class="chat-date-divider">'+dateLabel+'</div>';
    }
    if (isSystem) {
      html += '<div class="chat-msg system"><div class="chat-bubble">&#128276; '+escHtml(m.message)+'</div></div>';
      return;
    }
    // Merge consecutive messages from same sender
    var prevMsg = idx > 0 ? msgs[idx-1] : null;
    var showSender = !prevMsg || prevMsg.sender_id !== m.sender_id || prevMsg.sender_type === 'admin';
    // Reply preview
    var replyHtml = '';
    if (m.reply_to_id) {
      var parent = msgs.find(function(x){ return x.id === m.reply_to_id; });
      if (parent) replyHtml = '<div class="chat-reply-preview" onclick="scrollToMsg(this.dataset.id)" data-id="'+parent.id+'" title="original">&#8629; '+escHtml((parent.message||'').substring(0,80))+'</div>';
    }
    // Attachments
    var attHtml = '';
    if (m.attachments && m.attachments.length) {
      attHtml = m.attachments.map(function(a){
        var sz = a.size ? (a.size < 1048576 ? (a.size/1024).toFixed(1)+' KB' : (a.size/1048576).toFixed(2)+' MB') : '';
        return '<a href="'+a.url+'" download="'+escHtml(a.name||'file')+'" target="_blank" class="chat-attachment" title="Download '+escHtml(a.name||'file')+'">'          +'&#128206; <span>'+escHtml(a.name||'file')+'</span>'          +(sz ? '<span style="font-size:10px;color:var(--muted);margin-left:6px">'+sz+'</span>' : '')          +'<span style="font-size:10px;margin-left:6px;color:var(--gl)">&#11015;</span>'          +'</a>';
      }).join('');
    }
    var timeStr = new Date(m.created_at).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'});
    var senderInitial = (m.sender_name||'?').charAt(0).toUpperCase();
    var senderClr = m.sender_type==='manager'?'#f59e0b':m.sender_type==='client'?'#818cf8':'#60a5fa';
    var bubbleBg  = mine ? 'linear-gradient(135deg,rgba(15,181,116,.18),rgba(10,76,204,.15))' : 'var(--bg3)';
    var bubbleBdr = mine ? 'rgba(15,181,116,.25)' : 'var(--border)';
    var radius    = mine ? '14px 14px 4px 14px' : '14px 14px 14px 4px';
    var align     = mine ? 'flex-end' : 'flex-start';
    var dir       = mine ? 'row-reverse' : 'row';
    html += '<div class="chat-msg-wrap" id="cm-'+m.id+'" style="display:flex;align-items:flex-end;gap:8px;margin-bottom:4px;flex-direction:'+dir+';">';
    html += !mine&&showSender ? '<div style="width:28px;height:28px;border-radius:50%;background:'+senderClr+'22;color:'+senderClr+';display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex-shrink:0">'+senderInitial+'</div>' : '<div style="width:28px;flex-shrink:0"></div>';
    html += '<div style="max-width:68%;display:flex;flex-direction:column;align-items:'+align+'">';
    if (showSender&&!mine) html += '<div style="font-size:10px;font-weight:700;color:'+senderClr+';margin-bottom:3px;padding-left:4px">'+escHtml(m.sender_name||m.sender_type)+'</div>';
    if (replyHtml) html += replyHtml;
    html += '<div style="background:'+bubbleBg+';border:1px solid '+bubbleBdr+';border-radius:'+radius+';padding:9px 13px;font-size:13px;line-height:1.5;color:var(--text);word-break:break-word">'+escHtml(m.message)+attHtml+'</div>';
    html += '<div style="display:flex;align-items:center;gap:6px;margin-top:3px;padding:0 4px">';
    html += '<span style="font-size:10px;color:var(--dim)">'+timeStr+'</span>';
    html += '<button onclick="chatReply(this.dataset.id,this.dataset.msg)" data-id="'+m.id+'" data-msg="'+escAttr(m.message)+'" style="background:none;border:none;color:var(--dim);cursor:pointer;font-size:11px;padding:2px 4px;border-radius:4px;transition:.15s" title="Reply" onmouseenter="this.style.background=\'rgba(255,255,255,.06)\'" onmouseleave="this.style.background=\'none\'">&#8629;</button>';
    if (mine) html += '<button onclick="chatDelete(this.dataset.id)" data-id="'+m.id+'" style="background:none;border:none;color:var(--dim);cursor:pointer;font-size:11px;padding:2px 4px;border-radius:4px;transition:.15s" title="Delete" onmouseenter="this.style.background=\'rgba(224,82,82,.1)\'" onmouseleave="this.style.background=\'none\'">&#128465;</button>';
    html += '</div></div></div>';
  });
  el.innerHTML = html;
  if (scrollToBottom || wasBottom) el.scrollTop = el.scrollHeight;
}

function escHtml(s) { return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\n/g,'<br>'); }
function escAttr(s) { return (s||'').replace(/'/g,"\'").replace(/"/g,'&quot;').replace(/\n/g,' ').substring(0,100); }

function scrollToMsg(id) {
  var el = document.getElementById('cm-'+id);
  if (el) { el.scrollIntoView({behavior:'smooth',block:'center'}); el.style.background='rgba(15,181,116,.08)'; setTimeout(function(){ el.style.background=''; },1200); }
}

function chatKeydown(e) {
  if (e.key==='Enter' && !e.shiftKey) { e.preventDefault(); chatSend(); }
}

function chatInputChange() {
  var el = document.getElementById('chat-input');
  var text = el.innerText.trim();
  var btn = document.getElementById('chat-send');
  if (btn) btn.disabled = !text;
}

function chatReply(msgId, msgText) {
  _chatState.replyTo = msgId;
  var bar = document.getElementById('chat-reply-bar');
  if (bar) {
    bar.style.display = 'flex';
    bar.className = 'chat-reply-bar';
    bar.innerHTML = '<div><span style="font-weight:700;color:var(--gl)">&#8617; Replying to:</span> '+escHtml(msgText.substring(0,100))+'</div>'
      +'<button onclick="chatCancelReply()" style="background:none;border:none;color:var(--muted);font-size:16px;cursor:pointer">&#10005;</button>';
  }
  document.getElementById('chat-input')?.focus();
}

function chatCancelReply() {
  _chatState.replyTo = null;
  var bar = document.getElementById('chat-reply-bar');
  if (bar) { bar.style.display='none'; bar.innerHTML=''; }
}

function chatInsertEmoji() {
  var existing = document.getElementById('emoji-picker');
  if (existing) { existing.remove(); return; }
  var emojis = ['&#128077;','&#10003;','&#10060;','&#128293;','&#9888;','&#128197;','&#128161;','&#127881;','&#128064;','&#128591;','&#128170;','&#128640;','&#128522;','&#129300;','&#128078;','&#9203;','&#128276;','&#128204;','&#128194;','&#9997;'];
  var el = document.createElement('div');
  el.id = 'emoji-picker';
  el.style.cssText = 'position:absolute;bottom:calc(100% - 48px);left:12px;background:var(--bg2);border:1px solid var(--border);border-radius:10px;padding:10px;display:flex;flex-wrap:wrap;gap:4px;z-index:200;max-width:220px;box-shadow:0 8px 24px rgba(0,0,0,.3)';
  el.innerHTML = emojis.map(function(e){ return '<button onclick="insertEmoji(this.dataset.e)" data-e="'+e+'" style="background:none;border:none;font-size:22px;cursor:pointer;border-radius:6px;padding:3px;width:36px;transition:.1s" onmouseover="this.style.background=\'rgba(15,181,116,.12)\'" onmouseout="this.style.background=\'none\'">'+e+'</button>'; }).join('');
  setTimeout(function(){ document.addEventListener('click', function _ec(ev){ if(!ev.target.closest('#emoji-picker')&&!ev.target.closest('.chat-tool-btn')){ el.remove(); document.removeEventListener('click',_ec); } }); }, 0);
  var footer = document.querySelector('.chat-footer');
  if (footer) { footer.style.position = 'relative'; footer.appendChild(el); }
  else { var main = document.getElementById('chat-main'); if(main) main.appendChild(el); }
}

function insertEmoji(e) {
  var inp = document.getElementById('chat-input');
  if (inp) {
    inp.focus();
    var sel = window.getSelection();
    if (sel.rangeCount && inp.contains(sel.getRangeAt(0).commonAncestorContainer)) {
      var range = sel.getRangeAt(0);
      range.deleteContents();
      range.insertNode(document.createTextNode(e));
      range.collapse(false);
      sel.removeAllRanges(); sel.addRange(range);
    } else {
      inp.innerText += e;
    }
    chatInputChange();
  }
  document.getElementById('emoji-picker')?.remove();
}


async function chatSend() {
  var inp = document.getElementById('chat-input');
  var text = inp?.innerText.trim();
  if (!text) return;
  inp.innerText = '';
  inp.disabled = true;
  var btn = document.getElementById('chat-send');
  if (btn) btn.disabled = true;
  document.getElementById('emoji-picker')?.remove();
  try {
    var r = await _api('POST', '/proj/projects/'+_chatState.projectId+'/messages', {
      message: text, reply_to_id: _chatState.replyTo || null
    });
    if (r.ok) {
      var d = await r.json();
      _chatState.messages.push(d.message);
      _chatState.lastTimestamp = d.message.created_at;
      chatCancelReply();
      renderMessages(true);
    }
  } catch(e) {}
  inp.disabled = false;
  inp.focus();
  if (btn) btn.disabled = false;
}

async function chatDelete(msgId) {
  if (!confirm('Delete this message?')) return;
  var r = await _api('DELETE', '/proj/messages/'+msgId);
  if (r.ok) {
    _chatState.messages = _chatState.messages.filter(function(m){ return m.id !== msgId; });
    renderMessages(false);
  } else {
    var d = await r.json();
    alert(d.error||'Cannot delete');
  }
}

async function chatAttachFile(input) {
  var file = input.files[0];
  if (!file) return;
  var pid = _chatState.projectId;
  try {
    var r1 = await _api('POST', '/proj/projects/'+pid+'/files/upload-url', { filename: file.name, file_type: file.type });
    var d1 = await r1.json();
    if (!r1.ok) throw new Error(d1.error);
    await fetch(d1.signed_url, { method:'PUT', headers:{'Content-Type':file.type}, body:file });
    var r2 = await _api('POST', '/proj/projects/'+pid+'/files', { filename: file.name, file_path: d1.path, file_size: file.size, file_type: file.type });
    var d2 = await r2.json();
    // Send as chat attachment (include size for admin/download display)
    var r3 = await _api('POST', '/proj/projects/'+pid+'/messages', {
      message: '&#128206; Shared a file: '+file.name,
      file_url: d2.file && d2.file.file_url, file_name: file.name, file_type: file.type, file_size: file.size
    });
    var d3 = await r3.json();
    if (r3.ok) { _chatState.messages.push(d3.message); renderMessages(true); }
  } catch(e) { alert('Upload failed: '+e.message); }
  input.value = '';
}

function openGenDoc() {
  var pid = _currentProj?.project?.id;
  if (!pid && ROLE==='manager') { alert('Open a project first to generate documents'); return; }

  // Doc type cards
  var types = _PROJECT_DOC_TYPES.filter(function(t){ return t.who==='both'||(t.who===ROLE); });
  var typeOpts = types.map(function(t){
    return '<label style="display:flex;align-items:flex-start;gap:10px;background:var(--bg3);border:2px solid var(--border);border-radius:8px;padding:12px;cursor:pointer">'
        +'<input type="radio" name="gd-type" value="'+t.value+'" style="margin-top:3px;accent-color:var(--gl)">'
        +'<div><div style="font-weight:700;font-size:13px">'+t.label+'</div></div>'
        +'</label>';
  }).join('');

  // ── Collect tasks ───────────────────────────────────────────────────────
  var allTasks = [];
  if (ROLE==='consultant' || ROLE==='manager') {
    if (_currentProj?.tasks?.length) {
      // Project is open — show ALL tasks. Access verified by Guard 1.
      var projTitle = _currentProj.project?.title || '';
      allTasks = _currentProj.tasks.map(function(t){
        var mine = t.assigned_to===USER?.id || t.assigned_consultant_id===USER?.id;
        return Object.assign({}, t, { _proj_id: pid, _proj_title: projTitle, _mine: mine });
      });
      // My tasks first, then by workflow status
      allTasks.sort(function(a, b){
        if (a._mine && !b._mine) return -1;
        if (!a._mine && b._mine) return 1;
        var ord = { in_progress:0, submitted:1, pending:2, completed:3, cancelled:4 };
        return ((ord[a.status]??5) - (ord[b.status]??5)) || (a.title||'').localeCompare(b.title||'');
      });
    }
    // No project open — fall back to assigned tasks across all projects
    if (!allTasks.length && Array.isArray(_projects)) {
      _projects.forEach(function(p) {
        var pId = p.id||p.project?.id, pTitle = p.title||p.project?.title||'';
        (p.tasks||[]).forEach(function(t) {
          if (t.assigned_to===USER?.id || t.assigned_consultant_id===USER?.id || ROLE==='manager')
            allTasks.push(Object.assign({}, t, { _proj_id: pId, _proj_title: pTitle, _mine: true }));
        });
      });
    }
  }
  if (!pid && ROLE==='consultant' && !allTasks.length) {
    alert('No assigned tasks found. Please open a project first.'); return;
  }

  // ── Task card picker ────────────────────────────────────────────────────
  var statusColor = { pending:'#7d9ab5', in_progress:'#0ea5e9', submitted:'#f59e0b', completed:'#0fb574', cancelled:'#ef4444' };
  var statusIcon  = { pending:'○', in_progress:'◐', submitted:'◑', completed:'●', cancelled:'✕' };

  var taskSel = '';
  if (allTasks.length) {
    // Task cards — div-based (not label+radio) for reliable click handling
    var taskCards = allTasks.map(function(t, idx) {
      var tPid   = t.project_id || t._proj_id || pid || '';
      var sc     = { pending:'#7d9ab5', in_progress:'#0ea5e9', submitted:'#f59e0b', completed:'#0fb574', cancelled:'#ef4444' }[t.status] || 'var(--muted)';
      var si     = { pending:'○', in_progress:'◐', submitted:'◑', completed:'●', cancelled:'✕' }[t.status] || '○';
      var priCol = t.priority==='high'?'#ef4444':t.priority==='medium'?'#f59e0b':'var(--muted)';
      var desc   = (t.description||'').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      var shortDesc = desc.length>120 ? desc.substring(0,120)+'…' : desc;
      return '<div class="gd-task-card" data-idx="'+idx+'" data-task-id="'+t.id+'" data-pid="'+tPid+'" '
        +'style="background:var(--bg3);border:2px solid var(--border);border-radius:8px;padding:11px 13px;cursor:pointer;transition:border-color .15s,background .15s">'
          +'<div style="font-size:13px;font-weight:600;color:var(--text);margin-bottom:4px">'+t.title+'</div>'
          +(shortDesc?'<div style="font-size:11px;color:var(--muted);line-height:1.5;margin-bottom:5px">'+shortDesc+'</div>':'')
          +'<div style="display:flex;gap:6px;flex-wrap:wrap;align-items:center">'
            +(t._mine?'<span style="font-size:10px;background:rgba(15,181,116,.12);color:var(--gl);border-radius:4px;padding:1px 6px;font-weight:700">👤 Mine</span>':'')
            +(t.assigned_to_name&&!t._mine?'<span style="font-size:10px;color:var(--muted)">👤 '+t.assigned_to_name+'</span>':'')
            +'<span style="font-size:10px;color:'+sc+'">'+si+' '+(t.status||'pending').replace(/_/g,' ')+'</span>'
            +(t.priority?'<span style="font-size:10px;color:'+priCol+';font-weight:600;text-transform:capitalize">'+t.priority+'</span>':'')
            +(t.estimated_hours?'<span style="font-size:10px;color:var(--muted)">⏱ '+t.estimated_hours+'h</span>':'')
            +(t._proj_title?'<span style="font-size:10px;color:var(--muted)">📁 '+t._proj_title+'</span>':'')
          +'</div>'
        +'</div>';
    }).join('');

    taskSel = '<div class="fgrp">'
      +'<label class="flbl">Project Task <span style="color:var(--muted);font-weight:400">(optional)</span></label>'
      +'<div id="gd-task-list" style="display:flex;flex-direction:column;gap:6px;max-height:240px;overflow-y:auto;padding-right:2px">'
        +'<div class="gd-task-card" data-task-id="" data-pid="'+(pid||'')+'" '
          +'style="background:var(--bg3);border:2px solid var(--gl);border-radius:8px;padding:10px 13px;cursor:pointer">'
          +'<span style="font-size:13px;font-weight:600;color:var(--gl)">📄 Project-level document (no specific task)</span>'
        +'</div>'
        +taskCards
      +'</div>'
      +'<input type="hidden" id="gd-selected-task-id" value="">'
      +'</div>';
  } else {
    taskSel = '<div style="background:var(--bg3);border:1px solid var(--border);border-radius:8px;padding:10px 14px;font-size:12px;color:var(--muted);margin-bottom:8px">'
      +'📄 No tasks found — document will be generated at the project level.</div>';
  }

  // ── Quota fetch ─────────────────────────────────────────────────────────
  _api('GET', '/proj/doc-quota').then(function(r){ return r.json(); }).then(function(d) {
    var quotaBar = '';
    if (d && d.used !== undefined) {
      var pct = Math.min(100, Math.round(d.used/d.limit*100));
      var col = pct>=100?'var(--danger)':pct>=80?'var(--warn)':'var(--gl)';
      quotaBar = '<div style="background:var(--bg3);border:1px solid var(--border);border-radius:8px;padding:10px 14px;margin-bottom:14px;display:flex;align-items:center;justify-content:space-between">'
        +'<div><div style="font-size:11px;color:var(--muted);margin-bottom:4px">Documents this month</div>'
        +'<div style="height:4px;background:var(--bg2);border-radius:2px;width:160px"><div style="height:100%;width:'+pct+'%;background:'+col+';border-radius:2px"></div></div></div>'
        +'<div style="font-size:14px;font-weight:800;color:'+col+'">'+d.used+' / '+d.limit+'</div>'
        +'</div>';
      if (d.used >= d.limit) {
        showPortalModal('✨ Generate AI Document',
          '<div style="text-align:center;padding:28px 0"><div style="font-size:36px;margin-bottom:12px">🚫</div>'
          +'<div style="font-size:16px;font-weight:700;color:var(--danger);margin-bottom:8px">Monthly Limit Reached</div>'
          +'<div style="font-size:13px;color:var(--muted)">Used <strong>'+d.used+' of '+d.limit+'</strong> this month.<br>Resets 1st of next month.</div></div>',
          null, 'Close');
        return;
      }
    }
    _showGenDocModal(typeOpts, taskSel, quotaBar, pid);
  }).catch(function(){ _showGenDocModal(typeOpts, taskSel, '', pid); });
}

function _gdTaskChanged2(radio) {
  var hiddenPid = document.getElementById('gd-resolved-pid');
  if (hiddenPid) hiddenPid.value = radio.getAttribute('data-pid') || '';
  document.querySelectorAll('input[name="gd-task"]').forEach(function(el) {
    var lbl = el.closest('label');
    if (lbl) lbl.style.borderColor = el.checked ? 'var(--gl)' : 'var(--border)';
  });
}
function _gdTaskChanged(sel) {
  var opt = sel.options[sel.selectedIndex];
  var hiddenPid = document.getElementById('gd-resolved-pid');
  if (hiddenPid) hiddenPid.value = (opt && opt.getAttribute('data-pid')) || '';
}

function _showGenDocModal(typeOpts, taskSel, quotaBar, pid) {
  showPortalModal('✨ Generate AI Document',
    quotaBar
    +'<input type="hidden" id="gd-resolved-pid" value="'+(pid||'')+'">'
    +'<div style="margin-bottom:12px"><div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:var(--muted);margin-bottom:10px">Document Type</div>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:16px">'+typeOpts+'</div></div>'
    +taskSel
    +'<div class="fgrp"><label class="flbl">Additional Context <span style="color:var(--muted);font-weight:400">(optional)</span></label>'
    +'<textarea class="ftextarea" id="gd-context" rows="3" placeholder="Add any extra context, key points, requirements, meeting agenda..."></textarea></div>'
    +'<div style="display:flex;align-items:center;gap:8px;background:var(--bg3);border-radius:7px;padding:10px 12px;margin-bottom:8px">'
    +'<input type="checkbox" id="gd-save" checked style="accent-color:var(--gl);width:15px;height:15px">'
    +'<label for="gd-save" style="font-size:12px;cursor:pointer">Save to project files after generation</label></div>'
    +'<div id="gd-msg"></div>',
    async function() {
      var typeEl = document.querySelector('input[name="gd-type"]:checked');
      if (!typeEl) { document.getElementById('gd-msg').innerHTML='<div class="err-msg">Please select a document type</div>'; return; }
      var docType     = typeEl.value;
      var context     = document.getElementById('gd-context')?.value || '';
      var save        = document.getElementById('gd-save')?.checked || false;
      var taskId      = document.getElementById('gd-selected-task-id')?.value || null;
      if (!taskId) taskId = null;
      var resolvedPid = document.getElementById('gd-resolved-pid')?.value || pid;
      if (!resolvedPid) {
        document.getElementById('gd-msg').innerHTML='<div class="err-msg">No project found. Please open a project first.</div>';
        return;
      }
      var btn = document.getElementById('modal-confirm-btn');
      btn.innerHTML='⏳ Generating...'; btn.disabled=true;
      try {
        var endpoint = taskId ? '/proj/tasks/'+taskId+'/generate-doc' : '/proj/projects/'+resolvedPid+'/generate-doc';
        var r = await _api('POST', endpoint, { doc_type:docType, context, save_to_files:save });
        var d = await r.json();
        btn.textContent='Confirm'; btn.disabled=false;
        if (r.ok) { closePortalModal(); showDocPreview(d.html, d.filename, d.file, save, resolvedPid); }
        else if (r.status===429) { document.getElementById('gd-msg').innerHTML='<div class="err-msg" style="padding:12px">🚫 <strong>Limit reached:</strong> '+(d.error||'Monthly limit exceeded')+'</div>'; }
        else { document.getElementById('gd-msg').innerHTML='<div class="err-msg">❌ '+(d.error||'Generation failed')+'</div>'; }
      } catch(e) {
        btn.textContent='Confirm'; btn.disabled=false;
        document.getElementById('gd-msg').innerHTML='<div class="err-msg">❌ '+e.message+'</div>';
      }
    }
  );

  // ── Attach events after modal renders ─────────────────────────────────────
  setTimeout(function() {
    // Doc type cards
    document.querySelectorAll('input[name="gd-type"]').forEach(function(el) {
      el.addEventListener('change', function() {
        document.querySelectorAll('input[name="gd-type"]').forEach(function(e2) {
          var lbl = e2.closest('label');
          if (lbl) { lbl.style.borderColor=e2.checked?'var(--gl)':'var(--border)'; lbl.style.background=e2.checked?'rgba(15,181,116,.06)':'var(--bg3)'; }
        });
      });
    });

    // Task cards — click anywhere to select
    var taskCards = document.querySelectorAll('.gd-task-card');
    var taskIdInput  = document.getElementById('gd-selected-task-id');
    var pidInput     = document.getElementById('gd-resolved-pid');
    taskCards.forEach(function(card) {
      card.addEventListener('click', function() {
        // Deselect all
        taskCards.forEach(function(c) {
          c.style.borderColor  = 'var(--border)';
          c.style.background   = 'var(--bg3)';
        });
        // Select this one
        card.style.borderColor = 'var(--gl)';
        card.style.background  = 'rgba(15,181,116,.06)';
        // Store selection
        var selTaskId = card.getAttribute('data-task-id') || '';
        var selPid    = card.getAttribute('data-pid') || pid || '';
        if (taskIdInput) taskIdInput.value = selTaskId;
        if (pidInput)    pidInput.value    = selPid;
      });
    });

    // Highlight first card (project-level) as default selected
    if (taskCards.length > 0) {
      taskCards[0].style.borderColor = 'var(--gl)';
      taskCards[0].style.background  = 'rgba(15,181,116,.06)';
    }
  }, 60);
}

function showDocPreview(html, filename, fileRecord, saved, projectId) {
  closePortalModal();
  var overlay = document.createElement('div');
  overlay.id = 'doc-preview-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.85);z-index:600;display:flex;flex-direction:column';
  overlay.innerHTML =
    '<div style="background:#0A0E1A;padding:12px 20px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #1E2A42;flex-shrink:0">'
    +'<div><div style="font-size:14px;font-weight:800">&#10024; '+filename+'</div>'
    +'<div style="font-size:11px;color:#7D8BA3;margin-top:2px">'+(saved?'&#10003; Saved to project files':'Not saved - download to keep')+'</div></div>'
    +'<div style="display:flex;gap:8px">'
    +'<button onclick="downloadDoc()" class="btn btn-primary" style="padding:7px 14px;font-size:12px">&#11015; Download</button>'
    +(!saved&&projectId?'<button onclick="saveDocNow(this.dataset.pid)" data-pid="'+(projectId||'')+'">Save to Files</button>':'')
    +'<button onclick="closeDocPreview()" style="background:none;border:1px solid #1E2A42;color:#7D8BA3;border-radius:6px;padding:7px 14px;font-size:12px;cursor:pointer">&#10005; Close</button>'
    +'</div></div>'
    +'<div style="flex:1;overflow-y:auto;background:#fff">'
    +'<div id="doc-preview-content" style="max-width:900px;margin:0 auto;padding:48px 40px;font-family:Georgia,serif;font-size:15px;line-height:1.7;color:#111">'
    + html
    +'</div></div>';
  document.body.appendChild(overlay);

  // Store for download
  window._genDocHtml     = html;
  window._genDocFilename = filename;
  window._genDocFileUrl  = fileRecord && fileRecord.file_url ? fileRecord.file_url : null;
  window._genDocProjectId = projectId;
}

function downloadDoc() {
  // Use the stored file_url (docx) if available; fall back to HTML blob
  var fileUrl = window._genDocFileUrl;
  if (fileUrl) {
    var a = document.createElement('a');
    a.href = fileUrl;
    a.download = window._genDocFilename || 'document.docx';
    a.click();
    return;
  }
  // Fallback: download HTML
  var html = window._genDocHtml;
  var full = '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>'+window._genDocFilename+'</title>'
    +'<style>body{font-family:Georgia,serif;max-width:900px;margin:48px auto;padding:0 40px;color:#111;line-height:1.7}h1,h2,h3{font-family:sans-serif}table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:8px}th{background:#f5f5f5}</'+'style>'
    +'</'+'head><body>'+html+'</'+'body></'+'html>';
  var blob = new Blob([full], { type: 'text/html' });
  var a = document.createElement('a');
  a.href = URL.createObjectURL(blob); a.download = window._genDocFilename||'document.html'; a.click();
}

async function saveDocNow(pid) {
  var r = await _api('POST', '/proj/projects/'+pid+'/generate-doc', {
    doc_type: 'project_charter', context: '', save_to_files: true
  }).catch(function(){});
  // Actually just call the files upload endpoint with the already-generated content
  // Since we have the HTML, create a blob and upload via the upload URL route
  try {
    var html = window._genDocHtml;
    var filename = window._genDocFilename;
    var r1 = await _api('POST', '/proj/projects/'+pid+'/files/upload-url', { filename, file_type: 'text/html' });
    var d1 = await r1.json();
    if (!r1.ok) throw new Error(d1.error);
    var blob = new Blob([html], { type: 'text/html' });
    var upR = await fetch(d1.signed_url, { method:'PUT', headers:{'Content-Type':'text/html'}, body: blob });
    if (!upR.ok) throw new Error('Upload failed');
    var r2 = await _api('POST', '/proj/projects/'+pid+'/files', { filename, file_path: d1.path, file_size: blob.size, file_type:'text/html', description:'AI Generated Document' });
    if (r2.ok) {
      var saveBtn = document.querySelector('#doc-preview-overlay button:nth-child(2)');
      if (saveBtn) { saveBtn.textContent='&#10003; Saved!'; saveBtn.disabled=true; }
    }
  } catch(e) { alert('Save failed: '+e.message); }
}

function closeDocPreview() {
  var el = document.getElementById('doc-preview-overlay');
  if (el) el.remove();
}

// ═══════════════════════════════════════════════════════════════════════════
// DASHBOARD NOTIFICATION FEED + OPPORTUNITIES PREVIEW
// ═══════════════════════════════════════════════════════════════════════════

function _timeAgo(dateStr) {
  if (!dateStr) return '';
  var diff = Date.now() - new Date(dateStr).getTime();
  var s = Math.floor(diff/1000);
  if (s < 60)    return 'just now';
  if (s < 3600)  return Math.floor(s/60)  + 'm ago';
  if (s < 86400) return Math.floor(s/3600) + 'h ago';
  return Math.floor(s/86400) + 'd ago';
}

var _DASH_ICONS = { invoice:'&#129534;', estimate:'&#128176;', task:'&#10003;', task_submitted:'&#128228;', task_confirmed:'&#127881;', task_rejected:'&#128260;', task_assigned:'&#128203;', task_cancelled:'&#10060;', meeting:'&#128197;', document:'&#128196;', chat:'&#128172;', ticket:'&#127915;', project:'&#128193;', payment:'&#128179;', approval:'&#128077;', system:'&#9881;', inbox_message:'&#128140;', general:'&#128276;', default:'&#128276;' };
var NOTIF_ICONS = _DASH_ICONS;

function _updateDashboardFeed(notifs, unreadCount) {
  var unreadEl = document.getElementById('ov-unread-count');
  if (unreadEl) unreadEl.textContent = unreadCount || '0';

  // Update chat tab badge from unread chat/message notifications
  var unreadChat = (notifs||[]).filter(function(n){ return !n.is_read && (n.type==='new_message'||n.type==='chat'); }).length;
  var chatBadge = document.getElementById('ptab-chat-badge');
  if (chatBadge) { chatBadge.textContent = unreadChat; chatBadge.style.display = unreadChat ? 'inline' : 'none'; }
  var feedEl = document.getElementById('ov-notif-feed');
  if (!feedEl) return;
  if (!notifs || !notifs.length) {
    feedEl.innerHTML = '<div style="padding:32px;text-align:center;color:var(--muted);font-size:13px">No recent activity</div>';
    return;
  }
  feedEl.innerHTML = '';
  var _uc = unreadCount;
  notifs.slice(0, 15).forEach(function(n) {
    var icon = _DASH_ICONS[n.type] || '&#128276;';
    var isNew = !n.is_read;
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:flex-start;gap:12px;padding:12px 18px;border-bottom:1px solid var(--border);cursor:pointer;background:' + (isNew ? 'rgba(15,181,116,.03)' : 'transparent');
    (function(notif) {
      row.addEventListener('click', function() {
        notifClick(notif.id, notif.link || '');
        row.style.background = 'transparent';
        var dot = row.querySelector('.n-dot'); if (dot) dot.remove();
        if (_uc > 0) { _uc--; var uel=document.getElementById('ov-unread-count'); if(uel) uel.textContent=_uc; updateNotifBadge(_uc); }
      });
    })(n);
    row.addEventListener('mouseover', function(){ row.style.background='var(--bg3)'; });
    row.addEventListener('mouseout',  function(){ row.style.background=isNew?'rgba(15,181,116,.03)':'transparent'; });
    var _decodeHtml = function(str) {
      if (!str) return '';
      var t = document.createElement('textarea');
      t.innerHTML = str;
      return t.value;
    };
    var iconEl=document.createElement('div'); iconEl.style.cssText='width:34px;height:34px;border-radius:50%;background:var(--bg3);display:flex;align-items:center;justify-content:center;font-size:15px;flex-shrink:0'; iconEl.innerHTML=icon;
    var body=document.createElement('div'); body.style.cssText='flex:1;min-width:0';
    var titleEl=document.createElement('div'); titleEl.style.cssText='font-size:13px;font-weight:'+(isNew?'700':'500')+';margin-bottom:2px'; titleEl.textContent=_decodeHtml(n.title||'');
    var timeEl=document.createElement('div'); timeEl.style.cssText='font-size:10px;color:var(--muted);margin-top:3px'; timeEl.textContent=_timeAgo(n.created_at);
    body.appendChild(titleEl);
    if(n.body||n.message){var ml=document.createElement('div');ml.style.cssText='font-size:12px;color:var(--muted)';ml.textContent=_decodeHtml(n.body||n.message);body.appendChild(ml);}
    body.appendChild(timeEl);
    row.appendChild(iconEl); row.appendChild(body);
    if(isNew){var dot=document.createElement('div');dot.className='n-dot';dot.style.cssText='width:8px;height:8px;border-radius:50%;background:var(--gl);flex-shrink:0;margin-top:5px';row.appendChild(dot);}
    feedEl.appendChild(row);
  });
}

async function _loadOppPreview() {
  try {
    // Consultant uses ls endpoint (different auth), ERPM uses proj endpoint
    var oppUrl = (typeof ROLE !== 'undefined' && ROLE === 'consultant')
      ? '/ls/consultants/opportunities'
      : '/proj/opportunities';
    var r = await _api('GET', oppUrl);
    if (!r.ok) return;
    var d = await r.json();
    var opps = (d.opportunities||[]).filter(function(o){ return o.status==='pending' && o.request_status!=='closed'; });
    var cntEl = document.getElementById('ov-opp-count'); if(cntEl) cntEl.textContent=opps.length||'0';
    var preview=document.getElementById('ov-opp-preview'); var listEl=document.getElementById('ov-opp-list');
    if(!preview||!listEl) return;
    if(!opps.length){preview.style.display='none';return;}
    preview.style.display='block';
    listEl.innerHTML=opps.slice(0,3).map(function(o){
      return '<div style="padding:12px 0;border-bottom:1px solid var(--border);display:flex;justify-content:space-between;align-items:center">'
        +'<div><div style="font-weight:700;font-size:13px">'+escHtml(o.company_name||'')+' - '+escHtml(o.erp_system||'')+'</div>'
        +'<div style="font-size:11px;color:var(--muted)">'+(o.meeting_date||'')+(o.meeting_platform?' · '+escHtml(o.meeting_platform):'')+'</div></div>'
        +(o.offered_rate?'<div style="font-size:14px;font-weight:800;color:var(--warn)">$'+o.offered_rate+'/hr</div>':'')+'</div>';
    }).join('')+(opps.length>3?'<div style="padding:10px 0;font-size:12px;color:var(--muted);text-align:center">+'+(opps.length-3)+' more</div>':'');
  } catch(e){}
}

// Start dashboard
setTimeout(_loadOppPreview, 800);


// ── Notification Panel Functions ────────────────────────────────────────────
var _notifOpen = false;
var _notifData = [];

function notifClick(id, link) {
  // Mark as read
  if (id) _api('PUT', '/proj/notifications/' + id + '/read').catch(function(){});

  // Close panel
  _notifOpen = false;
  var panel = document.getElementById('notif-panel');
  if (panel) panel.classList.remove('open');

  // Navigate based on link
  if (!link) return;
  if (link.startsWith('section:')) {
    // e.g. "section:tasks" → goSection('tasks')
    var sec = link.replace('section:', '');
    if (typeof goSection === 'function') goSection(sec);
    else if (typeof showSection === 'function') showSection(sec);
  } else if (link.startsWith('project:')) {
    // e.g. "project:uuid:chat" → open project then switch tab
    var parts = link.split(':');
    var pid = parts[1], tab = parts[2]||'overview';
    if (typeof openProject === 'function') {
      openProject(pid).then(function() {
        // Switch to the specified tab after project loads
        if (tab && tab !== 'overview') {
          var tabBtn = document.getElementById('ptab-' + tab) || document.querySelector('[data-tab="'+tab+'"]');
          if (tabBtn) tabBtn.click();
        }
      }).catch(function(){});
    } else if (typeof goSection === 'function') goSection('projects');
  } else if (link.startsWith('http')) {
    window.location.href = link;
  }

  // Re-render to update read status
  setTimeout(function(){
    var updated = _notifData.map(function(n){ return n.id==id ? Object.assign({},n,{is_read:true}) : n; });
    _notifData = updated;
    var unread = updated.filter(function(n){ return !n.is_read; }).length;
    updateNotifBadge(unread);
    document.getElementById('ov-unread-count') && (document.getElementById('ov-unread-count').textContent = unread);
  }, 300);
}

function toggleNotifPanel() {
  _notifOpen = !_notifOpen;
  var panel = document.getElementById('notif-panel');
  if (!panel) return;
  panel.classList.toggle('open', _notifOpen);
  if (_notifOpen) { loadNotifications(); }
}

function renderNotifList() {
  var el = document.getElementById('notif-list');
  if (!el) return;
  if (!_notifData.length) { el.innerHTML = '<div class="notif-empty">&#127881; All caught up! No notifications.</div>'; return; }
  el.innerHTML = _notifData.map(function(n) {
    var icon = NOTIF_ICONS[n.type] || NOTIF_ICONS.default;
    var timeAgo = _timeAgo(n.created_at);
    return '<div class="notif-item '+(n.is_read?'':'unread')+'" onclick="notifClick(this.dataset.id, this.dataset.link)" data-id="'+n.id+'" data-link="'+(n.link||'')+'">'
      +'<div class="notif-icon">'+icon+'</div>'
      +'<div class="notif-body">'
      +'<div class="notif-title">'+escHtml(n.title)+'</div>'
      +((n.body||n.message)?'<div class="notif-desc">'+escHtml(n.body||n.message)+'</div>':'')
      +'<div class="notif-time">'+timeAgo+'</div>'
      +'</div>'
      +(n.is_read?'':'<div style="width:8px;height:8px;border-radius:50%;background:var(--gl);flex-shrink:0;margin-top:6px"></div>')
      +'</div>';
  }).join('');
}

function updateNotifBadge(count) {
  var badge = document.getElementById('notif-badge');
  if (!badge) return;
  if (count > 0) { badge.textContent = count > 99 ? '99+' : count; badge.style.display = 'inline'; }
  else { badge.style.display = 'none'; }
  // Update browser title
  document.title = count > 0 ? '(' + count + ') EOH Portal' : 'EOH Portal';
}

async function loadNotifications() {
  try {
    var r = await _api('GET', _notifEndpoint());
    if (!r.ok) return;
    var d = await r.json();
    _notifData = d.notifications || [];
    var unread = d.unread || _notifData.filter(function(n){ return !n.is_read; }).length;
    updateNotifBadge(unread);
    // Update dashboard feed and unread counter
    _updateDashboardFeed(_notifData, unread);
    var uel = document.getElementById('ov-unread-count');
    if (uel) uel.textContent = unread;
    if (_notifOpen) renderNotifList();
  } catch(e) { console.error('[loadNotifications]', e.message); }
}

function _notifEndpoint() {
  // Both consultant and ERPM use /proj/notifications (dual-auth endpoint)
  return '/proj/notifications';
}

async function pollUnreadCount() {
  // Full refresh: fetch notifications so dashboard feed stays current
  await loadNotifications();
}

function _checkNewChatMessages() {
  // If we have a chat timer running, new messages will come via fetchChatMessages
  // Just ensure the badge is visible if there are unread notifications
}

var _notifPollInterval = null;

function startNotifPolling() {
  loadNotifications();
  if (_notifPollInterval) clearInterval(_notifPollInterval);
  _notifPollInterval = setInterval(pollUnreadCount, 15000); // every 15s
}



// ── Notification Panel Functions ────────────────────────────────────────────
var _notifOpen = false;
var _notifData = [];


// ── Opportunities + Time Logs (from consultant-portal-2.js) ──────────────
async function loadOpportunities() {
  var el = document.getElementById('opp-list');
  if (!el) return;
  el.innerHTML = '<div style="padding:20px;color:var(--muted);text-align:center">Loading...</div>';

  try {
    var oppUrl2=(typeof ROLE!=='undefined'&&ROLE==='consultant')?'/ls/consultants/opportunities':'/proj/opportunities';
    var r = await _api('GET', oppUrl2);
    if (!r.ok) {
      var errD = await r.json().catch(function(){return{};});
      el.innerHTML = '<div class="err-msg">Could not load opportunities: '+(errD.error||r.status)+'</div>';
      return;
    }
    var d = await r.json();
    var allOpps = d.opportunities || [];
    window._allOpps = allOpps;

    // Populate ERP filter from actual data
    var erpSel = document.getElementById('opp-filter-erp');
    if (erpSel && erpSel.options.length <= 1) {
      var erps = [...new Set(allOpps.map(function(o){
        return (o.ls_meeting_requests && o.ls_meeting_requests.ls_tickets && o.ls_meeting_requests.ls_tickets.erp_system) || o.erp_system || '';
      }).filter(Boolean))].sort();
      erps.forEach(function(e) {
        var opt = document.createElement('option'); opt.value = e; opt.textContent = e; erpSel.appendChild(opt);
      });
    }

    // Update badge
    var pending = allOpps.filter(function(o){ return o.status==='pending' && (o.request_status==='open' || (o.ls_meeting_requests && o.ls_meeting_requests.status==='open')); }).length;
    var badge = document.getElementById('opp-badge');
    if (badge) { badge.textContent = pending; badge.style.display = pending ? '' : 'none'; }

    applyOppFilters();
  } catch(e) {
    var el2 = document.getElementById('opp-list');
    if (el2) el2.innerHTML = '<div class="err-msg">Error loading opportunities: '+escHtml(e.message)+'</div>';
  }
}

function applyOppFilters() {
  var el   = document.getElementById('opp-list');
  if (!el) return;
  var opps = window._allOpps || [];
  var statusF = (document.getElementById('opp-filter')      || {}).value || '';
  var bcF     = (document.getElementById('opp-filter-bc')   || {}).value || '';
  var erpF    = (document.getElementById('opp-filter-erp')  || {}).value || '';
  var sortF   = (document.getElementById('opp-filter-sort') || {}).value || 'desc';

  var filtered = opps.filter(function(o) {
    if (statusF) {
      if (o.status !== statusF) return false;
    }
    if (bcF) {
      // request_status comes from the API, or nested ls_meeting_requests.status
      var bcStatus = o.request_status
        || (o.ls_meeting_requests && o.ls_meeting_requests.status)
        || '';
      if (bcStatus !== bcF) return false;
    }
    if (erpF) {
      var oErp = (o.ls_meeting_requests && o.ls_meeting_requests.ls_tickets && o.ls_meeting_requests.ls_tickets.erp_system) || o.erp_system || '';
      if (oErp !== erpF) return false;
    }
    return true;
  });

  filtered.sort(function(a, b) {
    var da = new Date((a.ls_meeting_requests && a.ls_meeting_requests.meeting_date) || a.meeting_date || '').getTime() || 0;
    var db = new Date((b.ls_meeting_requests && b.ls_meeting_requests.meeting_date) || b.meeting_date || '').getTime() || 0;
    return sortF === 'asc' ? da - db : db - da;
  });

  if (!filtered.length) {
    el.innerHTML = '<div style="text-align:center;padding:40px;color:var(--muted)"><div style="font-size:32px;margin-bottom:10px">🔍</div><p>No opportunities match your filters</p></div>';
    return;
  }

  el.innerHTML = filtered.map(function(opp) {
    var req  = opp.ls_meeting_requests || opp;
    var tick = req.ls_tickets || {
      ticket_number: opp.ticket_number,
      company_name: opp.company_name || opp.company,
      erp_system: opp.erp_system,
      modules: opp.modules,
      support_type: opp.support_type,
      preferred_date: opp.preferred_date || req.meeting_date,
      preferred_time: opp.preferred_time || req.meeting_time,
      preferred_timezone: opp.preferred_timezone || req.preferred_timezone,
    };
    return _buildOppCard(opp, req, tick);
  }).join('');
}

function clearOppFilters() {
  ['opp-filter','opp-filter-bc','opp-filter-erp'].forEach(function(id){ var el=document.getElementById(id); if(el) el.value=''; });
  var s = document.getElementById('opp-filter-sort'); if(s) s.value='desc';
  applyOppFilters();
}
function _buildOppCard(opp, req, tick) {
  req  = req  || opp.ls_meeting_requests || opp;
  tick = tick || req.ls_tickets || { ticket_number:opp.ticket_number, company_name:opp.company_name, erp_system:opp.erp_system, modules:opp.modules, priority:opp.priority, support_type:opp.support_type };
  if (!req.meeting_date)           req.meeting_date           = opp.meeting_date;
  if (!req.meeting_time)           req.meeting_time           = opp.meeting_time;
  if (!req.meeting_platform)       req.meeting_platform       = opp.meeting_platform;
  if (!req.preferred_timezone)     req.preferred_timezone     = opp.preferred_timezone;
  if (!req.offered_rate_consultant)req.offered_rate_consultant= opp.offered_rate;
  if (!req.offered_rate_erpm)      req.offered_rate_erpm      = opp.offered_rate;
  if (!req.notes)                  req.notes                  = opp.notes;
  if (!req.status)                 req.status                 = opp.request_status;
  if (!req.selected_consultant_id) req.selected_consultant_id = opp.selected_consultant_id;
  if (!req.selected_erpm_id)       req.selected_erpm_id       = opp.selected_erpm_id;
  if (!req.response_deadline)      req.response_deadline      = opp.response_deadline;
  var sm = { pending:{ label:'&#9203; Awaiting your response',color:'var(--warn)',bg:'rgba(245,158,11,.1)' }, interested:{ label:'&#10003; You expressed interest',color:'var(--gl)',bg:'rgba(15,181,116,.1)' }, declined:{ label:'&#10060; You declined',color:'var(--danger)',bg:'rgba(224,82,82,.1)' } };
  var ss = sm[opp.status] || { label:opp.status, color:'var(--muted)', bg:'rgba(156,163,175,.08)' };
  var isClosed = req.status==='closed'||req.status==='cancelled';
  var myId = USER&&USER.id ? USER.id : '';
  var isSelected = req.selected_consultant_id===myId||req.selected_erpm_id===myId||opp.selected_consultant_id===myId||opp.selected_erpm_id===myId;
  var date = _fmtDate(req.meeting_date||'');
  var time = _fmtTime(req.meeting_time||'', _userTz(), req.preferred_timezone||null);
  var rateField = opp.user_type==='consultant' ? req.offered_rate_consultant : req.offered_rate_erpm;
  var isCancelled = isClosed||opp.status==='declined'||req.status==='cancelled'||req.status==='closed';
  var bc = isCancelled?'rgba(224,82,82,.2)':opp.status==='pending'?'rgba(245,158,11,.2)':'var(--border)';
  var bl = isCancelled?'var(--danger)':opp.status==='pending'?'var(--warn)':opp.status==='interested'?'var(--gl)':'var(--border2)';
  var h = '<div style="background:var(--bg3);border:1px solid '+bc+';border-left:3px solid '+bl+';border-radius:10px;padding:16px;margin-bottom:12px;'+(isCancelled?'opacity:0.6;pointer-events:none;':'')+'">';
  h += '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;flex-wrap:wrap"><div style="flex:1;min-width:0">';
  h += '<div style="display:flex;align-items:center;gap:8px;margin-bottom:8px"><span style="font-size:10px;font-weight:800;text-transform:uppercase;background:rgba(99,102,241,.12);color:#818cf8;padding:2px 8px;border-radius:6px">DISCOVERY MEETING</span>';
  if (tick.ticket_number) h += '<span style="font-size:10px;font-family:monospace;color:var(--gl);background:rgba(15,181,116,.08);padding:2px 8px;border-radius:6px;border:1px solid rgba(15,181,116,.2)">'+escHtml(tick.ticket_number)+'</span>';
  if (req.id) h += '<span style="font-size:10px;font-family:monospace;color:var(--dim)">MTG-'+String(req.id||'').replace(/-/g,'').substring(0,8).toUpperCase()+'</span>';
  if (isClosed) h += '<span style="font-size:10px;background:rgba(156,163,175,.12);color:var(--muted);padding:2px 8px;border-radius:6px">Closed</span>';
  h += '</div>';
  h += '<div style="font-size:18px;font-weight:800;margin-bottom:8px">'+escHtml(tick.company_name||tick.company||'—')+' &mdash; '+escHtml(tick.erp_system||'')+'</div>';
  h += '<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:12px">';
  if (date) h += '<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(15,181,116,.1);border:1px solid rgba(15,181,116,.25);color:var(--gl);font-size:13px;font-weight:800;padding:5px 12px;border-radius:8px">&#128197; '+date+'</span>';
  if (time) h += '<span style="display:inline-flex;align-items:center;gap:5px;background:rgba(10,76,204,.15);border:1px solid rgba(10,76,204,.35);color:#60a5fa;font-size:13px;font-weight:800;padding:5px 12px;border-radius:8px">&#128336; '+time+'</span>';
  if (req.meeting_platform) h += '<span style="background:var(--bg2);border:1px solid var(--border);color:var(--muted);font-size:11px;font-weight:600;padding:3px 9px;border-radius:8px">&#128187; '+escHtml(req.meeting_platform)+'</span>';
  if (tick.support_type) h += '<span style="background:var(--bg2);border:1px solid var(--border);color:var(--muted);font-size:11px;font-weight:600;padding:3px 9px;border-radius:8px">&#128295; '+escHtml(tick.support_type)+'</span>';
  h += '</div><div style="display:flex;gap:12px;flex-wrap:wrap;margin-bottom:12px">';
  if (rateField) h += '<div style="background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.2);border-radius:8px;padding:8px 14px"><div style="font-size:10px;color:var(--warn);font-weight:700;margin-bottom:2px">OFFERED RATE</div><div style="font-size:16px;font-weight:800;color:var(--warn)">$'+escHtml(String(rateField))+'/hr</div></div>';
  if (req.response_deadline) {
    var dlMs=new Date(req.response_deadline).getTime()-Date.now();
    var dlColor=dlMs<3600000?'var(--danger)':dlMs<86400000?'var(--warn)':'var(--text)';
    h += '<div style="background:var(--bg2);border:1px solid var(--border);border-radius:8px;padding:8px 14px"><div style="font-size:10px;color:var(--muted);font-weight:700;margin-bottom:2px">RESPOND BY</div><div style="font-size:13px;font-weight:700;color:'+dlColor+'">'+new Date(req.response_deadline).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})+' &middot; '+new Date(req.response_deadline).toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit',hour12:true})+'</div></div>';
  }
  h += '</div>';
  if (isSelected) {
    h += '<div style="background:rgba(15,181,116,.06);border:1px solid rgba(15,181,116,.2);border-radius:8px;padding:12px 16px;margin-bottom:12px"><div style="font-size:13px;font-weight:700;color:var(--gl);margin-bottom:10px">&#127881; You have been selected! Please confirm your attendance.</div>';
    if (opp.status!=='confirmed') h += '<div style="display:flex;gap:8px"><button class="btn btn-primary" style="font-size:12px;font-weight:700" data-rid="'+(opp.response_id||opp.id)+'" data-status="confirmed" onclick="respondToOpportunity(this.dataset.rid,this.dataset.status,this)">&#9989; Confirm Attendance</button><button class="btn btn-danger btn-sm" style="font-size:12px" data-rid="'+(opp.response_id||opp.id)+'" data-status="declined" onclick="respondToOpportunity(this.dataset.rid,this.dataset.status,this)">&#10060; Cannot Attend</button></div>';
    else h += '<div style="font-size:12px;color:var(--gl);font-weight:600">&#9989; Confirmed - see you at the meeting!</div>';
    h += '</div>';
  }
  if (isCancelled&&!isSelected) h += '<div style="background:rgba(224,82,82,.06);border:1px solid rgba(224,82,82,.2);border-radius:8px;padding:10px 14px;font-size:12px;color:var(--danger);margin-bottom:12px">&#128683; This meeting has been cancelled by the admin.</div>';
  h += '</div><div style="display:flex;flex-direction:column;gap:8px;flex-shrink:0;align-items:flex-end">';
  h += '<span style="font-size:11px;font-weight:700;padding:4px 12px;border-radius:20px;white-space:nowrap;background:'+ss.bg+';color:'+ss.color+'">'+ss.label+'</span>';
  if (opp.status==='pending'&&!isClosed&&!isCancelled) {
    h += '<button class="btn btn-sm" style="background:rgba(15,181,116,.12);border:1px solid var(--gl);color:var(--gl);font-weight:700;white-space:nowrap" data-rid="'+(opp.response_id||opp.id)+'" data-status="interested" onclick="respondToOpportunity(this.dataset.rid,this.dataset.status,this)">I am Available</button>';
    h += '<button class="btn btn-danger btn-sm" style="font-weight:700;white-space:nowrap" data-rid="'+(opp.response_id||opp.id)+'" data-status="declined" onclick="respondToOpportunity(this.dataset.rid,this.dataset.status,this)">Not Available</button>';
  }
  h += '</div></div></div>';
  return h;
}

// ── Meeting filters for consultant portal ─────────────────────────────────────
function applyMeetingFiltersCons() {
  var statusF = (document.getElementById('mtg-filter-status') || {}).value || '';
  var typeF   = (document.getElementById('mtg-filter-type')   || {}).value || '';
  var sortF   = (document.getElementById('mtg-filter-sort')   || {}).value || 'upcoming';
  var now     = Date.now();

  function getMs(m, dk, tk) {
    var d = m[dk]||'', t = (m[tk]||'00:00').substring(0,5);
    if (!d) return -1;
    var ms = new Date(d+'T'+t+':00').getTime();
    return isNaN(ms) ? -1 : ms;
  }

  function filterAndSort(arr, dk, tk, src) {
    var f = arr.filter(function(m) {
      if (typeF && src !== typeF) return false;
      var ms = getMs(m, dk, tk);
      var isPast = ms > 0 && now > ms + 3600000;
      var isUp   = ms > now;
      if (statusF === 'upcoming'  && !isUp)  return false;
      if (statusF === 'completed' && !isPast) return false;
      if (statusF === 'confirmed' && !(m.status==='confirmed'||m.status==='rescheduled')) return false;
      if (statusF === 'cancelled' && m.status !== 'cancelled') return false;
      return true;
    });
    return f.sort(function(a, b) {
      var ma = getMs(a,dk,tk), mb = getMs(b,dk,tk);
      if (ma<0&&mb<0) return 0; if (ma<0) return 1; if (mb<0) return -1;
      if (sortF==='upcoming') { var aU=ma>now,bU=mb>now; if(aU!==bU) return aU?-1:1; return aU?ma-mb:mb-ma; }
      return sortF==='asc' ? ma-mb : mb-ma;
    });
  }

  var s1 = filterAndSort(window._allDiscMeetings||[], 'date', 'time', 'discovery');
  var s2 = filterAndSort(window._allProjMeetings||[], 'scheduled_date', 'scheduled_time', 'project');
  var listEl = document.getElementById('meetings-list-inner');
  if (!listEl) return;
  listEl.innerHTML = '';

  if (!s1.length && !s2.length) {
    listEl.innerHTML = '<div style="text-align:center;padding:40px;color:var(--muted)"><div style="font-size:36px;margin-bottom:10px">🔍</div><p>No meetings match your filters</p></div>';
    return;
  }
  if (s1.length) {
    var h1 = document.createElement('div');
    h1.style.cssText = 'font-size:12px;font-weight:700;text-transform:uppercase;color:var(--muted);letter-spacing:.06em;margin:16px 0 8px';
    h1.innerHTML = '&#128269; Discovery Meetings';
    listEl.appendChild(h1);
    s1.forEach(function(m) { try { listEl.appendChild(_buildDiscMeetingCard(m)); } catch(e){} });
  }
  if (s2.length) {
    var h2 = document.createElement('div');
    h2.style.cssText = 'font-size:12px;font-weight:700;text-transform:uppercase;color:var(--muted);letter-spacing:.06em;margin:16px 0 8px';
    h2.innerHTML = '&#128193; Project Meetings';
    listEl.appendChild(h2);
    s2.forEach(function(m) {
      try {
        var wrap = document.createElement('div'); wrap.style.marginBottom = '4px';
        wrap.innerHTML = '<div style="font-size:10px;color:var(--gl);font-weight:700;margin-bottom:4px">'+escHtml(m._ptitle||'')+'</div>';
        wrap.insertAdjacentHTML('beforeend', meetingItem(m));
        listEl.appendChild(wrap);
      } catch(e){}
    });
  }
}

function clearMeetingFiltersCons() {
  ['mtg-filter-status','mtg-filter-type'].forEach(function(id){ var e=document.getElementById(id); if(e) e.value=''; });
  var s=document.getElementById('mtg-filter-sort'); if(s) s.value='upcoming';
  applyMeetingFiltersCons();
}

async function respondToOpportunity(responseId, status, btn) {
  // status: interested | declined | confirmed
  var origText = btn ? btn.textContent : '';
  if (btn) { btn.disabled=true; btn.textContent='Sending...'; }
  try {
    var r = await _api('PUT', '/proj/opportunities/'+responseId+'/respond', { status });
    var d = await r.json().catch(function(){return{};});
    if (r.ok) {
      var msg = status === 'interested' ? '&#10003; Availability confirmed - admin notified!' : '&#10060; Response sent';
      window.toast && window.toast(msg, status==='interested'?'success':'warn');
      await loadOpportunities();
    } else {
      window.toast && window.toast('Error: '+(d.error||'Failed'), 'error');
      if (btn) { btn.disabled=false; btn.textContent=origText; }
    }
  } catch(ex) {
    window.toast && window.toast(ex.message, 'error');
    if (btn) { btn.disabled=false; btn.textContent=origText; }
  }
}

async function loadMyTimeLogs() {
  var listEl    = document.getElementById('tl-list');
  var summaryEl = document.getElementById('tl-summary');
  if (!listEl) return;
  listEl.innerHTML = '<div style="padding:20px;color:var(--muted);text-align:center">Loading...</div>';

  var status = document.getElementById('tl-filter')?.value || '';
  var qs = status ? '?status='+status : '';

  try {
    var tlBase = (typeof ROLE !== 'undefined' && ROLE === 'consultant') ? '/ls/consultants/time-logs' : '/proj/time-logs';
    var r = await _api('GET', tlBase+qs);
    var d = await r.json().catch(function(){return{};});
    var logs    = d.logs    || [];
    var summary = d.summary || {};

    // Summary cards
    if (summaryEl) {
      summaryEl.innerHTML =
        _tlStat('Total Hours', (summary.total_hours||0).toFixed(1)+'h', 'var(--text)')
       +_tlStat('Approved Hours', (summary.approved_hours||0).toFixed(1)+'h', 'var(--gl)')
       +_tlStat('Pending $', '$'+(summary.pending_amount||0).toFixed(2), 'var(--warn)')
       +_tlStat('Approved $', '$'+(summary.approved_amount||0).toFixed(2), 'var(--gl)');
    }

    if (!logs.length) {
      listEl.innerHTML = '<div style="text-align:center;padding:40px;color:var(--muted)"><div style="font-size:32px;margin-bottom:10px">&#9201;</div><p>No time logs yet. Log hours on your tasks or meetings.</p></div>';
      return;
    }

    listEl.innerHTML = logs.map(function(log) {
      var task    = log.ls_tasks    || {};
      var project = log.ls_projects || {};
      var type    = log.task_id ? '&#128203; Task' : log.assignment_id ? '&#128197; Meeting' : '&#128188; Direct';
      var statusBg = { pending:'rgba(245,158,11,.1)', approved:'rgba(15,181,116,.1)', rejected:'rgba(224,82,82,.1)' }[log.status]||'rgba(156,163,175,.08)';
      var statusCl = { pending:'var(--warn)', approved:'var(--gl)', rejected:'var(--danger)' }[log.status]||'var(--muted)';
      var statusLb = { pending:'&#9203; Pending approval', approved:'&#10003; Approved', rejected:'&#10060; Rejected' }[log.status]||log.status;

      var h = '<div style="background:var(--bg3);border:1px solid var(--border);border-left:3px solid '+statusCl+';border-radius:10px;padding:14px 16px;margin-bottom:10px">';
      h += '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;flex-wrap:wrap">';
      h += '<div style="flex:1;min-width:0">';
      h += '<div style="font-size:11px;color:var(--muted);margin-bottom:4px">'+type+'</div>';
      if (task.title) h += '<div style="font-weight:700;font-size:13px;margin-bottom:2px">'+escHtml(task.title)+'</div>';
      if (project.title) h += '<div style="font-size:11px;color:var(--muted)">&#128193; '+escHtml(project.title)+'</div>';
      if (log.description) h += '<div style="font-size:11px;color:var(--muted);margin-top:4px;font-style:italic">'+escHtml(log.description)+'</div>';
      h += '<div style="font-size:11px;color:var(--muted);margin-top:4px">'+new Date(log.logged_at).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})+'</div>';
      if (log.status === 'rejected' && log.rejection_note) {
        h += '<div style="margin-top:8px;font-size:12px;color:var(--danger);background:rgba(224,82,82,.06);border-left:2px solid var(--danger);padding:5px 8px;border-radius:0 5px 5px 0">Rejection reason: '+escHtml(log.rejection_note)+'</div>';
      }
      h += '</div>';
      h += '<div style="text-align:right;flex-shrink:0">';
      h += '<div style="font-size:20px;font-weight:800;color:var(--gl)">$'+parseFloat(log.amount||0).toFixed(2)+'</div>';
      if (log.hours > 0) h += '<div style="font-size:11px;color:var(--muted)">'+log.hours+'h × $'+log.rate+'/hr</div>';
      h += '<div style="margin-top:6px"><span style="font-size:11px;font-weight:700;padding:3px 10px;border-radius:20px;background:'+statusBg+';color:'+statusCl+'">'+statusLb+'</span></div>';
      h += '</div></div></div>';
      return h;
    }).join('');
  } catch(e) {
    listEl.innerHTML = '<div class="err-msg">Error loading time logs: '+escHtml(e.message)+'</div>';
  }
}

function _tlStat(label, value, color) {
  return '<div style="background:var(--bg3);border:1px solid var(--border);border-radius:10px;padding:14px;text-align:center">'
    +'<div style="font-size:20px;font-weight:800;color:'+color+'">'+value+'</div>'
    +'<div style="font-size:11px;color:var(--muted);margin-top:4px;text-transform:uppercase;letter-spacing:.05em">'+label+'</div>'
    +'</div>';
}

function _buildLogHoursPanel(context) {
  // context: { id, type: 'task'|'meeting', title, project_id, assignment_id, task_id }
  var existing = document.getElementById('log-hours-panel');
  if (existing) existing.remove();

  var panel = document.createElement('div');
  panel.id = 'log-hours-panel';
  panel.setAttribute('style',
    'position:fixed;bottom:0;left:0;right:0;z-index:9999;background:#0F1526;' +
    'border-top:3px solid var(--gl);padding:20px 24px;box-shadow:0 -8px 32px rgba(0,0,0,.6)');
  document.body.appendChild(panel);

  var inner = document.createElement('div');
  inner.setAttribute('style','max-width:680px;margin:0 auto');
  panel.appendChild(inner);

  function mkEl(tag, style, text) {
    var el = document.createElement(tag);
    if (style) el.setAttribute('style', style);
    if (text)  el.textContent = text;
    return el;
  }

  inner.appendChild(mkEl('div','font-size:15px;font-weight:800;color:var(--gl);margin-bottom:4px','Log Hours'));
  inner.appendChild(mkEl('div','font-size:12px;color:var(--muted);margin-bottom:16px',
    'Log your actual hours for: ' + (context.title || context.type)));

  var grid = mkEl('div','display:grid;grid-template-columns:1fr 2fr;gap:12px;margin-bottom:12px');

  // Hours input
  var hoursWrap = mkEl('div','');
  hoursWrap.appendChild(mkEl('label','display:block;font-size:10px;font-weight:700;text-transform:uppercase;color:var(--muted);margin-bottom:4px;letter-spacing:.06em','Hours Worked'));
  var hoursInp = mkEl('input','width:100%;background:var(--bg3);border:1px solid var(--border2);border-radius:8px;padding:10px 12px;color:var(--text);font-size:22px;font-weight:800;font-family:inherit;outline:none;text-align:center;box-sizing:border-box');
  hoursInp.type = 'number'; hoursInp.min = '0.25'; hoursInp.step = '0.25'; hoursInp.placeholder = '0.0';
  hoursWrap.appendChild(hoursInp);
  grid.appendChild(hoursWrap);

  // Description
  var descWrap = mkEl('div','');
  descWrap.appendChild(mkEl('label','display:block;font-size:10px;font-weight:700;text-transform:uppercase;color:var(--muted);margin-bottom:4px;letter-spacing:.06em','Description (optional)'));
  var descTA = mkEl('textarea','width:100%;background:var(--bg3);border:1px solid var(--border2);border-radius:8px;padding:10px 12px;color:var(--text);font-size:13px;font-family:inherit;resize:none;outline:none;box-sizing:border-box;height:68px','');
  descTA.placeholder = 'Brief description of work done...';
  descWrap.appendChild(descTA);
  grid.appendChild(descWrap);
  inner.appendChild(grid);

  // Amount preview
  var preview = mkEl('div','background:rgba(15,181,116,.06);border:1px solid rgba(15,181,116,.15);border-radius:8px;padding:10px 14px;margin-bottom:14px;font-size:13px;display:flex;align-items:center;justify-content:space-between','');
  var previewLeft = mkEl('span','color:var(--muted)','Hours × Rate = Earnings');
  var previewAmt  = mkEl('span','font-size:18px;font-weight:800;color:var(--gl)','$0.00');
  preview.appendChild(previewLeft);
  preview.appendChild(previewAmt);
  inner.appendChild(preview);

  var errDiv = mkEl('div','color:var(--danger);font-size:12px;margin-bottom:8px;display:none','');
  inner.appendChild(errDiv);

  // Update preview on hours change
  var myRate = 0;
  // Build rate URL - pass both project_id and assignment_id so backend picks the right rate
  var rateQs = [];
  if (context.project_id)    rateQs.push('project_id='+context.project_id);
  if (context.assignment_id) rateQs.push('assignment_id='+context.assignment_id);
  var rateUrl = '/ls/consultants/my-rate' + (rateQs.length ? '?'+rateQs.join('&') : '');

  _api('GET', rateUrl).then(function(r){
    return r.json();
  }).then(function(d){
    myRate = parseFloat(d.rate || 0);
    // Show rate source so consultant knows which rate is being used
    var sourceLabel = {
      assignment: 'Rate set by admin for this meeting',
      project:    'Your project rate',
      profile:    'Your profile rate',
    }[d.source] || 'Your rate';
    var sourceColor = d.source === 'assignment' ? 'var(--gl)' : 'var(--muted)';
    previewLeft.innerHTML = '<span style="color:'+sourceColor+';font-weight:700">$'+myRate+'/hr</span>'
      + ' <span style="color:var(--muted);font-size:11px">- '+sourceLabel+'</span>';

    // Wire hours input to live-update amount
    function updatePreview() {
      var hrs = parseFloat(hoursInp.value || 0);
      previewAmt.textContent = hrs > 0 ? '$' + (hrs * myRate).toFixed(2) : '$0.00';
    }
    hoursInp.addEventListener('input', updatePreview);
  }).catch(function(){
    previewLeft.textContent = 'Rate not set - contact admin';
  });

  // Buttons
  var btnRow = mkEl('div','display:flex;gap:10px','');

  var submitBtn = mkEl('button','flex:1;padding:11px;background:linear-gradient(135deg,var(--gl),var(--g2));color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit','Submit Hours');
  submitBtn.addEventListener('click', async function(){
    var hrs = parseFloat(hoursInp.value);
    if (!hrs || hrs <= 0) { errDiv.textContent='Enter valid hours'; errDiv.style.display='block'; return; }
    submitBtn.disabled = true; submitBtn.textContent = 'Submitting...';
    try {
      var body = {
        hours:         hrs,
        description:   descTA.value || null,
        project_id:    context.project_id || null,
        task_id:       context.task_id || null,
        assignment_id: context.assignment_id || null,
      };
      var tlPostUrl = (typeof ROLE !== 'undefined' && ROLE === 'consultant') ? '/ls/consultants/time-logs' : '/proj/time-logs';
      var r = await _api('POST', tlPostUrl, body);
      var d = await r.json().catch(function(){return{};});
      if (r.ok) {
        panel.remove();
        window.toast && window.toast('Hours logged: $'+d.amount+' pending approval', 'success');
        if (context.task_id && typeof _refreshProjTab === 'function') await _refreshProjTab('tasks');
        if (context.assignment_id) await loadAllMeetings();
      } else {
        errDiv.textContent = d.error || 'Failed to log hours';
        errDiv.style.display = 'block';
        submitBtn.disabled = false; submitBtn.textContent = 'Submit Hours';
      }
    } catch(ex) {
      errDiv.textContent = ex.message;
      errDiv.style.display = 'block';
      submitBtn.disabled = false; submitBtn.textContent = 'Submit Hours';
    }
  });

  var cancelBtn = mkEl('button','padding:11px 20px;background:var(--bg3);color:var(--muted);border:1px solid var(--border);border-radius:8px;font-size:13px;cursor:pointer;font-family:inherit','Cancel');
  cancelBtn.addEventListener('click', function(){ panel.remove(); });

  btnRow.appendChild(submitBtn); btnRow.appendChild(cancelBtn);
  inner.appendChild(btnRow);
  hoursInp.focus();
}


// ── Timezone helpers ──────────────────────────────────────────────────────
function _userTz() {
  return (CONS_DATA && CONS_DATA.timezone)
      || (USER && USER.timezone)
      || Intl.DateTimeFormat().resolvedOptions().timeZone
      || 'UTC';
}

function _tzLabel(tz) {
  if (!tz) return '';
  try {
    // Get short timezone abbreviation
    var abbr = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'short' })
      .formatToParts(new Date())
      .find(function(p){ return p.type === 'timeZoneName'; });
    return abbr ? abbr.value : tz;
  } catch(e) { return tz; }
}

function _fmtTime(raw, tz, srcTz) {
  if (!raw) return '';
  var clean = String(raw).trim();
  var timeMatch = clean.match(/^(\d{1,2}:\d{2})/);
  if (!timeMatch) return clean;
  var parts = timeMatch[1].split(':');
  var h = parseInt(parts[0], 10), m = parseInt(parts[1], 10);
  if (isNaN(h) || isNaN(m)) return clean;

  var useTz = tz || _userTz();

  // If srcTz unknown — display raw time in user's timezone (no conversion, but show label)
  if (!srcTz) {
    try {
      var now0 = new Date();
      var td0 = now0.getFullYear() + '-' + String(now0.getMonth()+1).padStart(2,'0') + '-' + String(now0.getDate()).padStart(2,'0');
      var d0 = new Date(td0 + 'T' + String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':00');
      return new Intl.DateTimeFormat('en-US', {
        timeZone: useTz, hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short'
      }).format(d0);
    } catch(e) {
      var ampm0 = h >= 12 ? 'PM' : 'AM';
      return (h % 12 || 12) + ':' + String(m).padStart(2,'0') + ' ' + ampm0 + ' ' + _tzLabel(useTz);
    }
  }

  // srcTz known — convert from srcTz to user's useTz
  try {
    var now = new Date();
    var todayStr = now.getFullYear() + '-' + String(now.getMonth()+1).padStart(2,'0') + '-' + String(now.getDate()).padStart(2,'0');
    var d = new Date(todayStr + 'T' + String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':00Z');
    var srcFmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: srcTz, hour: '2-digit', minute: '2-digit', hour12: false
    }).format(d);
    var sp = srcFmt.replace(',','').trim().split(':');
    var srcH = parseInt(sp[0] === '24' ? '0' : sp[0], 10);
    var srcM = parseInt(sp[1], 10);
    var diffMin = (h - srcH) * 60 + (m - srcM);
    var utcDate = new Date(d.getTime() + diffMin * 60000);
    return new Intl.DateTimeFormat('en-US', {
      timeZone: useTz, hour: 'numeric', minute: '2-digit', hour12: true, timeZoneName: 'short'
    }).format(utcDate);
  } catch(e) {
    var ampm2 = h >= 12 ? 'PM' : 'AM';
    var h122  = h % 12 || 12;
    return h122 + ':' + String(m).padStart(2,'0') + ' ' + ampm2;
  }
}

function _fmtDateTime(dateRaw, timeRaw, tz, srcTz) {
  var d = _fmtDate(dateRaw);
  var t = _fmtTime(timeRaw, tz, srcTz);
  if (!d && !t) return '';
  if (!t) return d;
  if (!d) return t;
  return d + ' · ' + t;
}

function _meetRef(id) {
  if (!id) return '';
  return 'MTG-' + String(id).replace(/-/g,'').substring(0,6).toUpperCase();
}



// ── ERPM Profile Sections ────────────────────────────────────────────────
function loadMgrProfileSections() {
  var u = USER || {};
  var p = Object.assign({}, u.profile || {});
  function sv(id, val){ var el=document.getElementById(id); if(el) el.value=val||''; }
  // Rates
  sv('mgr-hourly-rate',   p.hourly_rate);
  sv('mgr-monthly-rate',  p.monthly_rate);
  sv('mgr-currency',      p.currency||'USD');
  sv('mgr-availability',  p.availability||'available');
  sv('mgr-pref-hours',    p.preferred_hours);
  sv('mgr-notice-days',   p.notice_days);
  sv('mgr-timezone',     (USER && USER.timezone) || p.timezone || _autoDetectTz());
  // Bank
  sv('mgr-bank-name',     p.mgr_bank_name);
  sv('mgr-bank-holder',   p.mgr_bank_holder);
  sv('mgr-bank-iban',     p.mgr_bank_iban);
  sv('mgr-bank-swift',    p.mgr_bank_swift);
  sv('mgr-bank-country',  p.mgr_bank_country);
  sv('mgr-id-type',       p.mgr_id_type||'passport');
  sv('mgr-id-number',     p.mgr_id_number);
  sv('mgr-id-expiry',     p.mgr_id_expiry);
  sv('mgr-nationality',   p.mgr_nationality);
}

async function saveMgrRates() {
  function gv(id){ var el=document.getElementById(id); return el?el.value:null; }
  var updates = {
    hourly_rate:     parseFloat(gv('mgr-hourly-rate'))||null,
    monthly_rate:    parseFloat(gv('mgr-monthly-rate'))||null,
    currency:        gv('mgr-currency')||'USD',
    availability:    gv('mgr-availability')||'available',
    preferred_hours: gv('mgr-pref-hours')||'',
    notice_days:     parseInt(gv('mgr-notice-days'))||null,
    timezone:        gv('mgr-timezone')||'UTC',
  };
  var r = await _api('PUT', '/proj/auth/me', updates);
  var d = await r.json().catch(function(){return{};});
  var msg = document.getElementById('mgr-rates-msg');
  if(r.ok){ if(msg) msg.innerHTML='<div class="ok-msg">&#10003; Saved</div>'; setTimeout(function(){if(msg)msg.innerHTML='';},3000); }
  else { if(msg) msg.innerHTML='<div class="err-msg">&#10060; '+escHtml(d.error||'Failed')+'</div>'; }
}

async function saveMgrBank() {
  var profile = USER && USER.profile ? Object.assign({}, USER.profile) : {};
  ['bank_name','bank_holder','bank_iban','bank_swift','bank_country','id_number'].forEach(function(f){
    var el=document.getElementById('mgr-'+f.replace('_','-'));
    if(el) profile['mgr_'+f]=el.value;
  });
  var r = await _api('PUT', '/proj/auth/me', { profile });
  var msg = document.getElementById('mgr-bank-msg');
  if(r.ok){ if(msg) msg.innerHTML='<div class="ok-msg">&#10003; Saved</div>'; setTimeout(function(){if(msg)msg.innerHTML='';},3000); }
  else { var d=await r.json().catch(function(){return{};}); if(msg) msg.innerHTML='<div class="err-msg">&#10060; '+escHtml(d.error||'Failed')+'</div>'; }
}

async function loadMgrWallet() {
  var balEl = document.getElementById('mgr-balance');
  var histEl = document.getElementById('mgr-wallet-history');
  try {
    var r = await _api('GET', '/proj/earnings');
    var d = await r.json().catch(function(){return{earnings:[]};});
    var total = (d.earnings||[]).filter(function(e){return e.status==='paid';}).reduce(function(s,e){return s+(e.amount||0);},0);
    var totalEl  = document.getElementById('mgr-balance-total');
    var pendEl   = document.getElementById('mgr-balance-pending');
    var countEl  = document.getElementById('mgr-balance-count');
    var paid    = (d.earnings||[]).filter(function(e){return e.status==='paid';}).reduce(function(s,e){return s+(e.amount||0);},0);
    var pending = (d.earnings||[]).filter(function(e){return e.status==='pending';}).reduce(function(s,e){return s+(e.amount||0);},0);
    if(totalEl)  totalEl.textContent  = '$' + paid.toFixed(2);
    if(pendEl)   pendEl.textContent   = '$' + pending.toFixed(2);
    if(countEl)  countEl.textContent  = (d.earnings||[]).length;
    if(balEl)    balEl.textContent    = '$' + paid.toFixed(2);
    if(histEl) {
      if(!(d.earnings||[]).length){ histEl.innerHTML='<div style="color:var(--muted);padding:20px;text-align:center">No payment history yet</div>'; return; }
      histEl.innerHTML = (d.earnings||[]).slice(0,10).map(function(e){
        return '<div style="display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--border)">'
          +'<div><div style="font-weight:600">'+escHtml(e.description||e.source||'Payment')+'</div>'
          +'<div style="font-size:11px;color:var(--muted)">'+(e.date||'')+'</div></div>'
          +'<div style="font-weight:700;color:'+(e.status==='paid'?'var(--gl)':'var(--warn)')+'">$'+(e.amount||0).toFixed(2)+'</div>'
          +'</div>';
      }).join('');
    }
  } catch(e) { if(histEl) histEl.textContent='Error loading wallet'; }
}


// ── Join Meeting Button with 15-min countdown ────────────────────────────
function _buildJoinBtn(link, date, time, tz, platform, people) {
  if (!link) return '';

  var now = Date.now();
  var todayStr = new Date().toISOString().split('T')[0]; // YYYY-MM-DD in UTC
  var localDate = new Date().toLocaleDateString('en-CA'); // YYYY-MM-DD in local time

  var meetingMs = 0;
  var isToday = false;
  if (date) {
    isToday = (date === todayStr || date === localDate);
    if (time) {
      var tClean = time.substring(0, 5); // HH:MM
      try { meetingMs = new Date(date + 'T' + tClean + ':00').getTime(); } catch(e) {}
    }
  }

  var diffMs  = meetingMs > 0 ? meetingMs - now : 0;
  var isPast  = meetingMs > 0 && now > meetingMs + 60 * 60 * 1000;
  // Show join if: today OR within 15min before → 1hr after
  var isLive  = isToday || (meetingMs > 0 && diffMs <= 15*60*1000 && diffMs > -60*60*1000);
  var isFuture = !isToday && meetingMs > 0 && diffMs > 15*60*1000;

  var uid = 'jb-' + Math.random().toString(36).slice(2, 8);
  var html = '<div style="margin-bottom:14px">';

  if (isPast && !isToday) {
    html += '<div style="display:flex;align-items:center;gap:10px;padding:12px 16px;background:var(--bg3);border:1px solid var(--border);border-radius:10px">'
      + '<span style="font-size:20px">&#128197;</span>'
      + '<div style="flex:1"><div style="font-size:12px;color:var(--muted);font-weight:700">MEETING ENDED</div>'
      + '<div style="font-size:11px;color:var(--muted);margin-top:2px">This meeting has concluded</div>'
      + '</div>'
      + '</div>';
  } else if (isLive) {
    // Active - show green Join button — opens EOH Meeting Room
    var _plat = platform || 'jitsi';
    var _name = (typeof CONS_DATA !== 'undefined' && CONS_DATA.full_name) ? CONS_DATA.full_name : (window.USER && window.USER.full_name ? window.USER.full_name : 'Consultant');
    var meetParams = new URLSearchParams({ platform: _plat, link: link, name: _name });
    if (people && people.length) { try { meetParams.set('people', encodeURIComponent(JSON.stringify(people))); } catch(e){} }
    var meetUrl = '/pages/eoh-meeting-room?' + meetParams.toString();
    var isExternal = (_plat === 'meet' || _plat === 'zoom');
    html += '<div style="display:flex;align-items:center;gap:12px;padding:14px 16px;background:rgba(15,181,116,.08);border:2px solid var(--gl);border-radius:12px;animation:pulse 2s infinite">'
      + '<span style="font-size:22px">&#129026;</span>'
      + '<div style="flex:1"><div style="font-size:11px;color:var(--gl);font-weight:700;text-transform:uppercase;margin-bottom:2px">&#9889; EOH Meeting Room is Live!</div>'
      + '<div style="font-size:12px;color:var(--muted)">Click to enter your branded meeting room</div></div>'
      + '<a href="'+(isExternal ? link : meetUrl)+'" '+(isExternal?'target="_blank"':'')+' style="background:var(--gl);color:#fff;padding:10px 20px;border-radius:8px;text-decoration:none;font-weight:700;font-size:14px;white-space:nowrap">&#9654; Join Now</a>'
      + '</div>';
  } else {
    // Future - show countdown
    var hh = Math.floor(diffMs/3600000);
    var mm = Math.floor((diffMs%3600000)/60000);
    var ss = Math.floor((diffMs%60000)/1000);
    var countdownStr = hh > 0 ? (hh + 'h ' + mm + 'm') : (mm + 'm ' + ss + 's');

    html += '<div id="'+uid+'" style="display:flex;align-items:center;gap:12px;padding:14px 16px;background:var(--bg3);border:1px solid var(--border);border-radius:12px">'
      + '<span style="font-size:22px">&#128274;</span>'
      + '<div style="flex:1"><div style="font-size:11px;color:var(--muted);font-weight:700;text-transform:uppercase;margin-bottom:2px">Opens in</div>'
      + '<div style="font-size:18px;font-weight:800;color:var(--warn);font-family:monospace" id="'+uid+'-cd">'+countdownStr+'</div></div>'
      + '<button disabled style="background:var(--bg2);color:var(--dim);border:1px solid var(--border);padding:10px 20px;border-radius:8px;font-weight:700;font-size:13px;cursor:not-allowed;white-space:nowrap">&#128274; Join Meeting</button>'
      + '</div>';

    // Start live countdown
    if (typeof _meetCountdowns === 'undefined') window._meetCountdowns = {};
    _meetCountdowns[uid] = setInterval(function() {
      var left = meetingMs - Date.now();
      var cdEl = document.getElementById(uid + '-cd');
      var wrapEl = document.getElementById(uid);
      if (!cdEl || !wrapEl) { clearInterval(_meetCountdowns[uid]); return; }
      if (left <= windowMs && left > -4*3600000) {
        // Switch to live
        clearInterval(_meetCountdowns[uid]);
        wrapEl.style.background = 'rgba(15,181,116,.08)';
        wrapEl.style.borderColor = 'var(--gl)';
        wrapEl.style.border = '2px solid var(--gl)';
        var _cdPlat = (typeof platform !== 'undefined' ? platform : null) || 'jitsi';
        var _cdName = (window.USER && window.USER.full_name) ? window.USER.full_name : 'Consultant';
        var _cdExt  = (_cdPlat === 'meet' || _cdPlat === 'zoom');
        var _cdUrl  = _cdExt ? link : '/pages/eoh-meeting-room?' + new URLSearchParams({ platform: _cdPlat, link: link, name: _cdName }).toString();
        wrapEl.innerHTML = '<span style="font-size:22px">&#129026;</span>'
          + '<div style="flex:1"><div style="font-size:11px;color:var(--gl);font-weight:700;text-transform:uppercase;margin-bottom:2px">&#9889; EOH Meeting Room is Live!</div>'
          + '<div style="font-size:12px;color:var(--muted)">Room is open — click to join</div></div>'
          + '<a href="'+_cdUrl+'" '+(_cdExt?'target="_blank"':'')+' style="background:var(--gl);color:#fff;padding:10px 20px;border-radius:8px;text-decoration:none;font-weight:700;font-size:14px;white-space:nowrap">&#9654; Join Now</a>';
        return;
      }
      var h = Math.floor(left/3600000);
      var m = Math.floor((left%3600000)/60000);
      var s = Math.floor((left%60000)/1000);
      cdEl.textContent = h > 0 ? (h + 'h ' + m + 'm') : (m + 'm ' + s + 's');
    }, 1000);
  }

  html += '</div>';
  return html;
}

// Add pulse animation to stylesheet
(function() {
  if (document.getElementById('join-btn-styles')) return;
  var style = document.createElement('style');
  style.id = 'join-btn-styles';
  style.textContent = '@keyframes pulse { 0%,100%{box-shadow:0 0 0 0 rgba(15,181,116,.3)} 50%{box-shadow:0 0 0 8px rgba(15,181,116,0)} }';
  document.head.appendChild(style);
})();


// ── Timezone Auto-detect & Save ──────────────────────────────────────────────
function _autoDetectTz() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch(e){ return 'UTC'; }
}

function _applyTzToSelect(selectId) {
  var el = document.getElementById(selectId);
  if (!el) return;
  var detected = (USER && USER.timezone) || _autoDetectTz();
  el.value = detected;
  if (!el.value) el.value = 'UTC'; // fallback if detected TZ not in list
}

function _fmtMeetingTime(date, time, tz) {
  // Returns: "Wed 28 May · 6:14 PM (Dubai)"
  if (!date || !time) return '';
  var tzLabel = tz ? tz.split('/').pop().replace(/_/g,' ') : _autoDetectTz().split('/').pop().replace(/_/g,' ');
  var d = new Date(date + 'T' + time);
  var opts = { weekday:'short', day:'numeric', month:'short', hour:'2-digit', minute:'2-digit', hour12:true, timeZone: tz || _autoDetectTz() };
  try { return d.toLocaleString('en-GB', opts) + ' (' + tzLabel + ')'; } catch(e){ return date + ' ' + time; }
}


// ═══════════════════════════════════════════════════════════════════════════════
// PROFILE CARD — Avatar, Profile ID, QR Code, Public Profile
// ═══════════════════════════════════════════════════════════════════════════════

// Load QRCode.js on demand
function _loadQRLib(cb) {
  if (window.QRCode) { cb(); return; }
  var s = document.createElement('script');
  s.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
  s.onload = cb;
  document.head.appendChild(s);
}

function _profileId(id) {
  return 'EOH-' + (id || '').replace(/-/g, '').substring(0, 8).toUpperCase();
}

function _profileUrl(id, type) {
  return 'https://erponlinehub.com/pages/eoh-public-profile?id=' + id + '&type=' + (type || 'consultant');
}

function _getAvatarUrl() {
  if (ROLE === 'consultant' && window.CONS_DATA) return CONS_DATA.profile_photo_url || '';
  if (USER && USER.profile) return USER.profile.avatar_url || '';
  return '';
}

function _initProfileCard() {
  var profileSection = document.getElementById('sec-profile');
  if (!profileSection) return;
  if (document.getElementById('eoh-profile-card')) return; // already injected

  var id   = USER && USER.id;
  var name = USER && USER.full_name ? USER.full_name : (ROLE === 'manager' ? 'Manager' : 'Consultant');
  var type = ROLE === 'manager' ? 'manager' : 'consultant';
  var pid  = _profileId(id);
  var pUrl = _profileUrl(id, type);
  var av   = _getAvatarUrl();
  var initials = name.split(' ').map(function(w){ return w[0]; }).join('').substring(0, 2).toUpperCase();

  var card = document.createElement('div');
  card.id = 'eoh-profile-card';
  card.style.cssText = 'background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:20px;margin-bottom:20px;max-width:800px;display:flex;align-items:flex-start;gap:20px;flex-wrap:wrap';

  card.innerHTML =
    // ── Avatar ──────────────────────────────────────────────────────────────
    '<div style="display:flex;flex-direction:column;align-items:center;gap:10px;flex-shrink:0">'
    + '<div id="avatar-wrap" style="position:relative;cursor:pointer" onclick="document.getElementById(\'avatar-file-input\').click()" title="Click to change photo">'
    +   '<div id="avatar-circle" style="width:88px;height:88px;border-radius:50%;'
    +     (av
        ? 'background:url('+escHtml(av)+') center/cover no-repeat;'
        : 'background:linear-gradient(135deg,var(--gl),var(--g2));display:flex;align-items:center;justify-content:center;font-size:30px;font-weight:800;color:#fff;')
    +   'border:3px solid var(--border);overflow:hidden;flex-shrink:0">'
    +     (av ? '' : '<span id="avatar-initials">'+initials+'</span>')
    +   '</div>'
    +   '<div style="position:absolute;bottom:0;right:0;width:24px;height:24px;background:var(--gl);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;border:2px solid var(--bg2)">📷</div>'
    + '</div>'
    + '<input type="file" id="avatar-file-input" accept="image/*" style="display:none" onchange="_onAvatarSelect(this)">'
    + '<div id="avatar-msg" style="font-size:11px;color:var(--muted);text-align:center;max-width:96px"></div>'
    + '</div>'
    // ── Profile ID + QR ─────────────────────────────────────────────────────
    + '<div style="flex:1;min-width:0">'
    +   '<div style="font-size:18px;font-weight:800;margin-bottom:2px">'+escHtml(name)+'</div>'
    +   '<div style="font-size:11px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;margin-bottom:12px">'+escHtml(ROLE === 'manager' ? 'ERP Manager' : 'Consultant')+'</div>'
    // Profile ID pill
    +   '<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;flex-wrap:wrap">'
    +     '<div style="background:var(--bg3);border:1px solid var(--border);border-radius:8px;padding:6px 12px;font-family:monospace;font-size:13px;font-weight:700;color:var(--gl);letter-spacing:.08em">'+pid+'</div>'
    +     '<button onclick="_copyProfileId(\''+pid+'\')" style="background:none;border:1px solid var(--border);border-radius:6px;padding:4px 8px;font-size:11px;color:var(--muted);cursor:pointer;font-family:inherit" title="Copy ID">📋 Copy ID</button>'
    +     '<a href="'+escHtml(pUrl)+'" target="_blank" style="background:rgba(15,181,116,.1);border:1px solid rgba(15,181,116,.25);border-radius:6px;padding:4px 8px;font-size:11px;color:var(--gl);text-decoration:none;font-weight:600">🌐 View Public Profile</a>'
    +   '</div>'
    // Description
    +   '<div style="font-size:11px;color:var(--muted);line-height:1.5">Your public profile is visible at the link above. Share your Profile ID or QR code so people can find and message you.</div>'
    + '</div>'
    // ── QR Code ──────────────────────────────────────────────────────────────
    + '<div style="display:flex;flex-direction:column;align-items:center;gap:8px;flex-shrink:0">'
    +   '<div style="font-size:10px;font-weight:700;text-transform:uppercase;color:var(--muted);letter-spacing:.06em">Your QR Code</div>'
    +   '<div id="profile-qr" style="background:#fff;border-radius:8px;padding:6px;width:110px;height:110px;display:flex;align-items:center;justify-content:center"></div>'
    +   '<button onclick="_downloadQR()" style="background:none;border:1px solid var(--border);border-radius:6px;padding:4px 10px;font-size:10px;color:var(--muted);cursor:pointer;font-family:inherit">⬇ Download</button>'
    + '</div>';

  // Insert before the existing profile form content
  var pageHdr = profileSection.querySelector('.page-hdr');
  if (pageHdr) pageHdr.insertAdjacentElement('afterend', card);
  else profileSection.insertBefore(card, profileSection.firstChild);

  // Try to show avatar immediately if already loaded
  _refreshAvatarDisplay();
  // Also try after a short delay in case profile API hasn't returned yet
  setTimeout(_refreshAvatarDisplay, 800);
  setTimeout(_refreshAvatarDisplay, 2000);

  // Render QR
  _loadQRLib(function() {
    var qrEl = document.getElementById('profile-qr');
    if (!qrEl || !window.QRCode) return;
    try {
      new QRCode(qrEl, {
        text:       pUrl,
        width:      98,
        height:     98,
        colorDark:  '#0a8a5f',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.M
      });
    } catch(e) { console.warn('[QR]', e.message); }
  });
}

async function _onAvatarSelect(input) {
  var file = input.files && input.files[0];
  if (!file) return;
  var msg = document.getElementById('avatar-msg');
  if (msg) msg.textContent = 'Uploading…';

  var form = new FormData();
  form.append('avatar', file);

  try {
    var r = await fetch(API + '/proj/profile/avatar', {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + TOKEN },
      body: form
    });
    var d = await r.json();
    if (r.ok && d.avatar_url) {
      _setAvatarCircle(d.avatar_url);
      if (window.CONS_DATA) CONS_DATA.profile_photo_url = d.avatar_url;
      if (USER && USER.profile) USER.profile.avatar_url = d.avatar_url;
      if (msg) msg.textContent = '✓ Updated';
      setTimeout(function(){ if(msg) msg.textContent=''; }, 2000);
    } else {
      if (msg) msg.textContent = d.error || 'Upload failed';
      setTimeout(function(){ if(msg) msg.textContent=''; }, 3000);
    }
  } catch(e) {
    if (msg) msg.textContent = 'Error: ' + e.message;
    setTimeout(function(){ if(msg) msg.textContent=''; }, 3000);
  }
  input.value = '';
}

function _copyProfileId(pid) {
  navigator.clipboard && navigator.clipboard.writeText(pid).then(function(){
    window.toast && window.toast('Profile ID copied: ' + pid, 'success');
  }).catch(function(){
    var ta = document.createElement('textarea');
    ta.value = pid; ta.style.position='fixed'; ta.style.opacity='0';
    document.body.appendChild(ta); ta.select();
    document.execCommand('copy');
    ta.remove();
    window.toast && window.toast('Profile ID copied', 'success');
  });
}

function _downloadQR() {
  var qrEl = document.getElementById('profile-qr');
  if (!qrEl) return;
  var img = qrEl.querySelector('img') || qrEl.querySelector('canvas');
  if (!img) return;
  var src = img.src || (img.tagName === 'CANVAS' ? img.toDataURL('image/png') : null);
  if (!src) return;
  var a = document.createElement('a');
  a.href = src;
  a.download = _profileId(USER && USER.id) + '-QR.png';
  a.click();
}

// ── Single helper to update avatar circle ────────────────────────────────────
function _setAvatarCircle(url) {
  if (!url) return;
  // Profile card circle
  var circle = document.getElementById('avatar-circle');
  if (circle) {
    circle.setAttribute('style',
      'width:88px;height:88px;border-radius:50%;'
      + 'background:url('+escHtml(url)+') center/cover no-repeat;'
      + 'border:3px solid var(--border);overflow:hidden;flex-shrink:0'
    );
    circle.innerHTML = '';
  }
  // Nav avatar — override gradient with photo
  var navAv = document.getElementById('nav-avatar');
  if (navAv) {
    navAv.textContent = '';
    navAv.style.backgroundImage = 'url(' + url + ')';
    navAv.style.backgroundSize   = 'cover';
    navAv.style.backgroundPosition = 'center';
  }
}

// ── Avatar refresh helper — call after any data load ─────────────────────────
function _refreshAvatarDisplay() {
  var url = _getAvatarUrl();
  if (url) _setAvatarCircle(url);
}

// Re-init profile card with fresh avatar after profile loads
var _origPopulateConsUI = typeof populateConsUI === 'function' ? populateConsUI : null;
if (_origPopulateConsUI) {
  populateConsUI = function(c) {
    _origPopulateConsUI(c);
    if (c && c.profile_photo_url) {
      if (window.CONS_DATA) CONS_DATA.profile_photo_url = c.profile_photo_url;
      _refreshAvatarDisplay();
    }  };
}

// Refresh profile ID display when navigating to profile section
var _origGoSection = typeof goSection === 'function' ? goSection : null;
if (_origGoSection) {
  goSection = function(id, el) {
    _origGoSection(id, el);
    if (id === 'profile') {
      setTimeout(function(){
        if (!document.getElementById('eoh-profile-card')) _initProfileCard();
      }, 100);
    }
  };
}

// ═══════════════════════════════════════════════════════════════════════════════
// INBOX — Private profile messaging
// ═══════════════════════════════════════════════════════════════════════════════
var _inboxConvId   = null;   // currently open conversation
var _inboxPollTimer = null;

async function loadInbox() {
  var listEl = document.getElementById('inbox-conv-list');
  if (!listEl) return;
  listEl.innerHTML = '<div style="padding:24px;text-align:center;color:var(--muted);font-size:13px">Loading…</div>';

  try {
    var r = await _api('GET', '/proj/inbox');
    if (!r.ok) { listEl.innerHTML = '<div style="padding:20px;color:var(--muted);font-size:13px">Could not load inbox</div>'; return; }
    var d = await r.json();
    var convs = d.conversations || [];

    // Update nav badge
    var totalUnread = convs.reduce(function(s, c){ return s + (c.unread || 0); }, 0);
    _updateInboxBadge(totalUnread);

    if (!convs.length) {
      listEl.innerHTML = '<div style="padding:32px 16px;text-align:center;color:var(--muted);font-size:13px">📭 No messages yet.<br><span style="font-size:11px">Share your public profile to receive messages.</span></div>';
      return;
    }
    listEl.innerHTML = '';
    convs.forEach(function(c) {
      var row = document.createElement('div');
      row.dataset.convId = c.id;
      var isActive = c.id === _inboxConvId;
      row.style.cssText = 'display:flex;align-items:flex-start;gap:10px;padding:12px 14px;border-bottom:1px solid var(--border);cursor:pointer;transition:.15s;background:' + (isActive ? 'rgba(15,181,116,.07)' : 'transparent') + ';border-left:3px solid ' + (isActive ? 'var(--gl)' : 'transparent');
      var av = (c.other_name || '?')[0].toUpperCase();
      var typeColor = c.other_type === 'consultant' ? 'var(--gl)' : c.other_type === 'manager' ? 'var(--purple,#a78bfa)' : '#60a5fa';
      row.innerHTML =
        '<div style="width:36px;height:36px;border-radius:50%;background:' + typeColor + '22;color:' + typeColor + ';display:flex;align-items:center;justify-content:center;font-weight:800;font-size:15px;flex-shrink:0">' + escHtml(av) + '</div>'
        + '<div style="flex:1;min-width:0">'
        +   '<div style="display:flex;justify-content:space-between;align-items:center">'
        +     '<div style="font-size:13px;font-weight:' + (c.unread > 0 ? '800' : '600') + ';overflow:hidden;text-overflow:ellipsis;white-space:nowrap">' + escHtml(c.other_name) + '</div>'
        +     (c.unread > 0 ? '<span style="background:var(--danger);color:#fff;border-radius:10px;padding:1px 6px;font-size:9px;font-weight:800;flex-shrink:0;margin-left:4px">' + c.unread + '</span>' : '')
        +   '</div>'
        +   '<div style="font-size:11px;color:var(--muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-top:2px">' + escHtml(c.last_message || '') + '</div>'
        +   '<div style="font-size:10px;color:var(--dim);margin-top:2px">' + (c.last_message_at ? _timeAgo(c.last_message_at) : '') + '</div>'
        + '</div>';
      row.addEventListener('click', function() { openInboxConversation(c.id, c.other_name, c.other_type); });
      row.addEventListener('mouseover', function(){ if(c.id!==_inboxConvId) row.style.background='var(--bg3)'; });
      row.addEventListener('mouseout',  function(){ if(c.id!==_inboxConvId) row.style.background='transparent'; });
      listEl.appendChild(row);
    });
  } catch(e) { listEl.innerHTML = '<div style="padding:20px;color:var(--muted)">Error: ' + escHtml(e.message) + '</div>'; }
}

async function openInboxConversation(convId, otherName, otherType) {
  _inboxConvId = convId;
  // Highlight selected row
  document.querySelectorAll('#inbox-conv-list > div').forEach(function(r){
    var active = r.dataset.convId === convId;
    r.style.background = active ? 'rgba(15,181,116,.07)' : 'transparent';
    r.style.borderLeft = active ? '3px solid var(--gl)' : '3px solid transparent';
  });

  var hdrEl    = document.getElementById('inbox-thread-header');
  var msgsEl   = document.getElementById('inbox-thread-msgs');
  var compose  = document.getElementById('inbox-compose');
  if (hdrEl) {
    var typeLabel = { consultant:'Consultant', manager:'ERP Manager', client:'Client' }[otherType] || otherType;
    hdrEl.innerHTML = '<span style="font-weight:800">' + escHtml(otherName) + '</span> <span style="font-size:11px;color:var(--muted);margin-left:6px">' + typeLabel + '</span>';
  }
  if (msgsEl) msgsEl.innerHTML = '<div style="text-align:center;color:var(--muted);padding:20px;font-size:13px">Loading…</div>';

  try {
    var r = await _api('GET', '/proj/inbox/' + convId);
    if (!r.ok) { if(msgsEl) msgsEl.innerHTML = '<div style="color:var(--muted);padding:20px">Error loading messages</div>'; return; }
    var d = await r.json();
    _renderInboxThread(d.messages || []);
    if (compose) { compose.style.display = 'flex'; }
    // Remove unread badge from this conv row
    var row = document.querySelector('#inbox-conv-list [data-conv-id="'+convId+'"]') ||
              Array.from(document.querySelectorAll('#inbox-conv-list > div')).find(function(el){ return el.dataset.convId === convId; });
    if (row) { var badge = row.querySelector('span[style*="danger"]'); if(badge) badge.remove(); }
    // Refresh nav badge
    loadInboxBadge();
    // Start polling for new messages in this thread
    if (_inboxPollTimer) clearInterval(_inboxPollTimer);
    _inboxPollTimer = setInterval(function(){ if(_inboxConvId === convId) pollInboxThread(convId); }, 8000);
  } catch(e) { if(msgsEl) msgsEl.innerHTML = '<div style="color:var(--muted);padding:20px">Error: ' + escHtml(e.message) + '</div>'; }
}

async function pollInboxThread(convId) {
  if (_inboxConvId !== convId) { clearInterval(_inboxPollTimer); return; }
  try {
    var r = await _api('GET', '/proj/inbox/' + convId);
    if (!r.ok) return;
    var d = await r.json();
    _renderInboxThread(d.messages || []);
  } catch(e) {}
}

function _renderInboxThread(messages) {
  var el = document.getElementById('inbox-thread-msgs');
  if (!el) return;
  if (!messages.length) { el.innerHTML = '<div style="text-align:center;color:var(--muted);padding:32px;font-size:13px">No messages yet. Say hello!</div>'; return; }
  var myId = USER && USER.id;
  el.innerHTML = messages.map(function(m) {
    var isMine = m.sender_id === myId;
    var bubble = isMine
      ? '<div style="align-self:flex-end;max-width:70%;background:linear-gradient(135deg,rgba(15,181,116,.2),rgba(10,76,204,.18));border:1px solid rgba(15,181,116,.28);border-radius:14px 14px 3px 14px;padding:10px 14px;font-size:13px;line-height:1.55;word-break:break-word;white-space:pre-wrap">'
      : '<div style="align-self:flex-start;max-width:70%;background:var(--bg2);border:1px solid var(--border);border-radius:14px 14px 14px 3px;padding:10px 14px;font-size:13px;line-height:1.55;word-break:break-word;white-space:pre-wrap">';
    return '<div style="display:flex;flex-direction:column;margin-bottom:4px">'
      + (!isMine ? '<div style="font-size:10px;font-weight:700;color:var(--muted);margin-bottom:3px;padding-left:2px">' + escHtml(m.sender_name) + '</div>' : '')
      + bubble + escHtml(m.message) + '</div>'
      + '<div style="font-size:10px;color:var(--dim);margin-top:3px;' + (isMine?'text-align:right':'') + '">' + _timeAgo(m.created_at) + '</div>'
      + '</div>';
  }).join('');
  el.scrollTop = el.scrollHeight;
}

function _inboxHasContactInfo(text) {
  if (!text) return false;
  // Full or partial email (contains @)
  if (/@/.test(text)) return true;
  // Common email domains
  if (/\b[\w\-]+\.(com|net|org|io|co|me|info|biz|edu|gov|uk|ae|sa|eg|de|fr|ca|au)\b/i.test(text)) return true;
  // 7+ consecutive digits (phone number)
  if (/\d{7,}/.test(text.replace(/[\s\-\.\(\)]/g, ''))) return true;
  // Message is entirely digits/separators with 4+ digits (split bypass)
  if (/^\s*[\+\d\s\-\.\(\)]+\s*$/.test(text) && text.replace(/\D/g,'').length >= 4) return true;
  return false;
}

async function sendInboxReply() {
  if (!_inboxConvId) return;
  var input = document.getElementById('inbox-reply-input');
  var text  = (input && input.value || '').trim();
  if (!text) return;

  // ── Client-side contact info check — block before API call ───────────────
  if (_inboxHasContactInfo(text)) {
    if (input) { input.value = ''; }
    // Record violation server-side even though we blocked client-side
    _api('POST', '/proj/inbox/violation', { preview: text.substring(0, 80) })
      .then(function(r) { return r.json(); })
      .then(function(v) {
        _showInboxPolicyWarning(
          'Sharing contact information (email, phone number) is strictly prohibited. Any attempt is automatically detected, removed, and reported. Repeated violations will result in your inbox being permanently locked.',
          v.violation_count
        );
        if (v.auto_locked) {
          window.toast && window.toast('🔒 Your inbox has been locked due to repeated violations.', 'error');
        }
      })
      .catch(function() {
        _showInboxPolicyWarning(
          'Sharing contact information (email, phone number) is strictly prohibited. Any attempt is automatically detected, removed, and reported. Repeated violations will result in your inbox being permanently locked.',
          null
        );
      });
    return;
  }

  // Get the other person's details from the current thread header
  var hdr = document.getElementById('inbox-thread-header');
  // We need to_id and to_type — get from conversation row data
  var row  = Array.from(document.querySelectorAll('#inbox-conv-list > div')).find(function(el){ return el.dataset.convId === _inboxConvId; });
  // We'll POST to the existing conversation by sending to the same convId's other participant
  // Fetch the conversation to get other participant
  try {
    var r1 = await _api('GET', '/proj/inbox/' + _inboxConvId);
    if (!r1.ok) return;
    var d1 = await r1.json();
    var conv = d1.conversation;
    var myId = USER && USER.id;
    var to_id   = conv.participant_a_id === myId ? conv.participant_b_id   : conv.participant_a_id;
    var to_type = conv.participant_a_id === myId ? conv.participant_b_type  : conv.participant_a_type;

    if (input) { input.value = ''; input.disabled = true; }
    var r = await _api('POST', '/proj/inbox', { to_id, to_type, message: text });
    var d = await r.json();
    if (r.ok) {
      _renderInboxThread((d1.messages || []).concat([d.message]));
      if (d.censored) {
        var rem = Math.max(0, 3 - (d.violation_count || 1));
        window.toast && window.toast(
          '⚠️ Contact info removed. ' + (rem > 0
            ? rem + ' warning' + (rem > 1 ? 's' : '') + ' left before inbox lock.'
            : 'Final warning — next violation locks your inbox permanently.'),
          'warn'
        );
      }
    } else {
      if (d.fully_blocked || d.auto_locked) {
        // Show the full policy warning in the thread area
        _showInboxPolicyWarning(d.error, d.violation_count);
      } else if (r.status === 403) {
        window.toast && window.toast('🔒 ' + (d.error || 'Inbox locked'), 'error');
      }
    }
    if (input) { input.disabled = false; input.focus(); }
    // Refresh conv list
    loadInbox();
  } catch(e) { if(input) input.disabled = false; }
}

function inboxReplyKey(e) {
  if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendInboxReply(); }
}

function _showInboxPolicyWarning(message, violationCount) {
  var msgsEl = document.getElementById('inbox-thread-msgs');
  if (!msgsEl) {
    window.toast && window.toast(message || 'Contact info not allowed', 'warn');
    return;
  }
  // Remove any existing policy warning
  var existing = msgsEl.querySelector('.inbox-policy-warn');
  if (existing) existing.remove();

  var remaining = Math.max(0, 3 - (violationCount || 1));
  var warn = document.createElement('div');
  warn.className = 'inbox-policy-warn';
  warn.style.cssText = 'background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.3);border-radius:10px;padding:14px 16px;margin:8px 0;font-size:12px;line-height:1.7';
  warn.innerHTML =
    '<div style="font-size:13px;font-weight:800;color:var(--warn);margin-bottom:6px;display:flex;align-items:center;gap:6px">'
    + '<span>⚠️</span><span>Message Blocked</span>'
    + (violationCount ? '<span style="margin-left:auto;font-size:10px;font-weight:700;background:rgba(245,158,11,.15);padding:2px 8px;border-radius:8px">Violation ' + violationCount + ' / 3</span>' : '')
    + '</div>'
    + '<div style="color:var(--text)">' + escHtml(message || 'Sharing contact information is not allowed.') + '</div>'
    + (remaining > 0
        ? '<div style="margin-top:8px;color:var(--muted);font-size:11px">⚡ ' + remaining + ' warning' + (remaining > 1 ? 's' : '') + ' remaining before your inbox is permanently locked.</div>'
        : '<div style="margin-top:8px;color:var(--danger);font-size:11px;font-weight:700">🔒 This is your final warning. Your inbox will be locked on the next violation.</div>');
  msgsEl.appendChild(warn);
  msgsEl.scrollTop = msgsEl.scrollHeight;
}

async function loadInboxBadge() {
  try {
    var r = await _api('GET', '/proj/inbox/unread-count');
    var d = await r.json();
    _updateInboxBadge(d.unread || 0);
  } catch(e) {}
}

function _updateInboxBadge(count) {
  var badge = document.getElementById('inbox-nav-badge');
  if (!badge) return;
  if (count > 0) { badge.textContent = count > 99 ? '99+' : count; badge.style.display = 'inline'; }
  else { badge.style.display = 'none'; }
}

// Poll inbox badge every 30s
setInterval(loadInboxBadge, 30000);
